(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/moment/locale sync recursive ^\\.\\/.*$":
/*!**************************************************!*\
  !*** ./node_modules/moment/locale sync ^\.\/.*$ ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "./node_modules/moment/locale/af.js",
	"./af.js": "./node_modules/moment/locale/af.js",
	"./ar": "./node_modules/moment/locale/ar.js",
	"./ar-dz": "./node_modules/moment/locale/ar-dz.js",
	"./ar-dz.js": "./node_modules/moment/locale/ar-dz.js",
	"./ar-kw": "./node_modules/moment/locale/ar-kw.js",
	"./ar-kw.js": "./node_modules/moment/locale/ar-kw.js",
	"./ar-ly": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "./node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "./node_modules/moment/locale/ar-ma.js",
	"./ar-sa": "./node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "./node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "./node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "./node_modules/moment/locale/ar-tn.js",
	"./ar.js": "./node_modules/moment/locale/ar.js",
	"./az": "./node_modules/moment/locale/az.js",
	"./az.js": "./node_modules/moment/locale/az.js",
	"./be": "./node_modules/moment/locale/be.js",
	"./be.js": "./node_modules/moment/locale/be.js",
	"./bg": "./node_modules/moment/locale/bg.js",
	"./bg.js": "./node_modules/moment/locale/bg.js",
	"./bm": "./node_modules/moment/locale/bm.js",
	"./bm.js": "./node_modules/moment/locale/bm.js",
	"./bn": "./node_modules/moment/locale/bn.js",
	"./bn.js": "./node_modules/moment/locale/bn.js",
	"./bo": "./node_modules/moment/locale/bo.js",
	"./bo.js": "./node_modules/moment/locale/bo.js",
	"./br": "./node_modules/moment/locale/br.js",
	"./br.js": "./node_modules/moment/locale/br.js",
	"./bs": "./node_modules/moment/locale/bs.js",
	"./bs.js": "./node_modules/moment/locale/bs.js",
	"./ca": "./node_modules/moment/locale/ca.js",
	"./ca.js": "./node_modules/moment/locale/ca.js",
	"./cs": "./node_modules/moment/locale/cs.js",
	"./cs.js": "./node_modules/moment/locale/cs.js",
	"./cv": "./node_modules/moment/locale/cv.js",
	"./cv.js": "./node_modules/moment/locale/cv.js",
	"./cy": "./node_modules/moment/locale/cy.js",
	"./cy.js": "./node_modules/moment/locale/cy.js",
	"./da": "./node_modules/moment/locale/da.js",
	"./da.js": "./node_modules/moment/locale/da.js",
	"./de": "./node_modules/moment/locale/de.js",
	"./de-at": "./node_modules/moment/locale/de-at.js",
	"./de-at.js": "./node_modules/moment/locale/de-at.js",
	"./de-ch": "./node_modules/moment/locale/de-ch.js",
	"./de-ch.js": "./node_modules/moment/locale/de-ch.js",
	"./de.js": "./node_modules/moment/locale/de.js",
	"./dv": "./node_modules/moment/locale/dv.js",
	"./dv.js": "./node_modules/moment/locale/dv.js",
	"./el": "./node_modules/moment/locale/el.js",
	"./el.js": "./node_modules/moment/locale/el.js",
	"./en-SG": "./node_modules/moment/locale/en-SG.js",
	"./en-SG.js": "./node_modules/moment/locale/en-SG.js",
	"./en-au": "./node_modules/moment/locale/en-au.js",
	"./en-au.js": "./node_modules/moment/locale/en-au.js",
	"./en-ca": "./node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "./node_modules/moment/locale/en-ca.js",
	"./en-gb": "./node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "./node_modules/moment/locale/en-gb.js",
	"./en-ie": "./node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "./node_modules/moment/locale/en-ie.js",
	"./en-il": "./node_modules/moment/locale/en-il.js",
	"./en-il.js": "./node_modules/moment/locale/en-il.js",
	"./en-nz": "./node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "./node_modules/moment/locale/en-nz.js",
	"./eo": "./node_modules/moment/locale/eo.js",
	"./eo.js": "./node_modules/moment/locale/eo.js",
	"./es": "./node_modules/moment/locale/es.js",
	"./es-do": "./node_modules/moment/locale/es-do.js",
	"./es-do.js": "./node_modules/moment/locale/es-do.js",
	"./es-us": "./node_modules/moment/locale/es-us.js",
	"./es-us.js": "./node_modules/moment/locale/es-us.js",
	"./es.js": "./node_modules/moment/locale/es.js",
	"./et": "./node_modules/moment/locale/et.js",
	"./et.js": "./node_modules/moment/locale/et.js",
	"./eu": "./node_modules/moment/locale/eu.js",
	"./eu.js": "./node_modules/moment/locale/eu.js",
	"./fa": "./node_modules/moment/locale/fa.js",
	"./fa.js": "./node_modules/moment/locale/fa.js",
	"./fi": "./node_modules/moment/locale/fi.js",
	"./fi.js": "./node_modules/moment/locale/fi.js",
	"./fo": "./node_modules/moment/locale/fo.js",
	"./fo.js": "./node_modules/moment/locale/fo.js",
	"./fr": "./node_modules/moment/locale/fr.js",
	"./fr-ca": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "./node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "./node_modules/moment/locale/fr-ch.js",
	"./fr.js": "./node_modules/moment/locale/fr.js",
	"./fy": "./node_modules/moment/locale/fy.js",
	"./fy.js": "./node_modules/moment/locale/fy.js",
	"./ga": "./node_modules/moment/locale/ga.js",
	"./ga.js": "./node_modules/moment/locale/ga.js",
	"./gd": "./node_modules/moment/locale/gd.js",
	"./gd.js": "./node_modules/moment/locale/gd.js",
	"./gl": "./node_modules/moment/locale/gl.js",
	"./gl.js": "./node_modules/moment/locale/gl.js",
	"./gom-latn": "./node_modules/moment/locale/gom-latn.js",
	"./gom-latn.js": "./node_modules/moment/locale/gom-latn.js",
	"./gu": "./node_modules/moment/locale/gu.js",
	"./gu.js": "./node_modules/moment/locale/gu.js",
	"./he": "./node_modules/moment/locale/he.js",
	"./he.js": "./node_modules/moment/locale/he.js",
	"./hi": "./node_modules/moment/locale/hi.js",
	"./hi.js": "./node_modules/moment/locale/hi.js",
	"./hr": "./node_modules/moment/locale/hr.js",
	"./hr.js": "./node_modules/moment/locale/hr.js",
	"./hu": "./node_modules/moment/locale/hu.js",
	"./hu.js": "./node_modules/moment/locale/hu.js",
	"./hy-am": "./node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "./node_modules/moment/locale/hy-am.js",
	"./id": "./node_modules/moment/locale/id.js",
	"./id.js": "./node_modules/moment/locale/id.js",
	"./is": "./node_modules/moment/locale/is.js",
	"./is.js": "./node_modules/moment/locale/is.js",
	"./it": "./node_modules/moment/locale/it.js",
	"./it-ch": "./node_modules/moment/locale/it-ch.js",
	"./it-ch.js": "./node_modules/moment/locale/it-ch.js",
	"./it.js": "./node_modules/moment/locale/it.js",
	"./ja": "./node_modules/moment/locale/ja.js",
	"./ja.js": "./node_modules/moment/locale/ja.js",
	"./jv": "./node_modules/moment/locale/jv.js",
	"./jv.js": "./node_modules/moment/locale/jv.js",
	"./ka": "./node_modules/moment/locale/ka.js",
	"./ka.js": "./node_modules/moment/locale/ka.js",
	"./kk": "./node_modules/moment/locale/kk.js",
	"./kk.js": "./node_modules/moment/locale/kk.js",
	"./km": "./node_modules/moment/locale/km.js",
	"./km.js": "./node_modules/moment/locale/km.js",
	"./kn": "./node_modules/moment/locale/kn.js",
	"./kn.js": "./node_modules/moment/locale/kn.js",
	"./ko": "./node_modules/moment/locale/ko.js",
	"./ko.js": "./node_modules/moment/locale/ko.js",
	"./ku": "./node_modules/moment/locale/ku.js",
	"./ku.js": "./node_modules/moment/locale/ku.js",
	"./ky": "./node_modules/moment/locale/ky.js",
	"./ky.js": "./node_modules/moment/locale/ky.js",
	"./lb": "./node_modules/moment/locale/lb.js",
	"./lb.js": "./node_modules/moment/locale/lb.js",
	"./lo": "./node_modules/moment/locale/lo.js",
	"./lo.js": "./node_modules/moment/locale/lo.js",
	"./lt": "./node_modules/moment/locale/lt.js",
	"./lt.js": "./node_modules/moment/locale/lt.js",
	"./lv": "./node_modules/moment/locale/lv.js",
	"./lv.js": "./node_modules/moment/locale/lv.js",
	"./me": "./node_modules/moment/locale/me.js",
	"./me.js": "./node_modules/moment/locale/me.js",
	"./mi": "./node_modules/moment/locale/mi.js",
	"./mi.js": "./node_modules/moment/locale/mi.js",
	"./mk": "./node_modules/moment/locale/mk.js",
	"./mk.js": "./node_modules/moment/locale/mk.js",
	"./ml": "./node_modules/moment/locale/ml.js",
	"./ml.js": "./node_modules/moment/locale/ml.js",
	"./mn": "./node_modules/moment/locale/mn.js",
	"./mn.js": "./node_modules/moment/locale/mn.js",
	"./mr": "./node_modules/moment/locale/mr.js",
	"./mr.js": "./node_modules/moment/locale/mr.js",
	"./ms": "./node_modules/moment/locale/ms.js",
	"./ms-my": "./node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "./node_modules/moment/locale/ms-my.js",
	"./ms.js": "./node_modules/moment/locale/ms.js",
	"./mt": "./node_modules/moment/locale/mt.js",
	"./mt.js": "./node_modules/moment/locale/mt.js",
	"./my": "./node_modules/moment/locale/my.js",
	"./my.js": "./node_modules/moment/locale/my.js",
	"./nb": "./node_modules/moment/locale/nb.js",
	"./nb.js": "./node_modules/moment/locale/nb.js",
	"./ne": "./node_modules/moment/locale/ne.js",
	"./ne.js": "./node_modules/moment/locale/ne.js",
	"./nl": "./node_modules/moment/locale/nl.js",
	"./nl-be": "./node_modules/moment/locale/nl-be.js",
	"./nl-be.js": "./node_modules/moment/locale/nl-be.js",
	"./nl.js": "./node_modules/moment/locale/nl.js",
	"./nn": "./node_modules/moment/locale/nn.js",
	"./nn.js": "./node_modules/moment/locale/nn.js",
	"./pa-in": "./node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "./node_modules/moment/locale/pa-in.js",
	"./pl": "./node_modules/moment/locale/pl.js",
	"./pl.js": "./node_modules/moment/locale/pl.js",
	"./pt": "./node_modules/moment/locale/pt.js",
	"./pt-br": "./node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "./node_modules/moment/locale/pt-br.js",
	"./pt.js": "./node_modules/moment/locale/pt.js",
	"./ro": "./node_modules/moment/locale/ro.js",
	"./ro.js": "./node_modules/moment/locale/ro.js",
	"./ru": "./node_modules/moment/locale/ru.js",
	"./ru.js": "./node_modules/moment/locale/ru.js",
	"./sd": "./node_modules/moment/locale/sd.js",
	"./sd.js": "./node_modules/moment/locale/sd.js",
	"./se": "./node_modules/moment/locale/se.js",
	"./se.js": "./node_modules/moment/locale/se.js",
	"./si": "./node_modules/moment/locale/si.js",
	"./si.js": "./node_modules/moment/locale/si.js",
	"./sk": "./node_modules/moment/locale/sk.js",
	"./sk.js": "./node_modules/moment/locale/sk.js",
	"./sl": "./node_modules/moment/locale/sl.js",
	"./sl.js": "./node_modules/moment/locale/sl.js",
	"./sq": "./node_modules/moment/locale/sq.js",
	"./sq.js": "./node_modules/moment/locale/sq.js",
	"./sr": "./node_modules/moment/locale/sr.js",
	"./sr-cyrl": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "./node_modules/moment/locale/sr.js",
	"./ss": "./node_modules/moment/locale/ss.js",
	"./ss.js": "./node_modules/moment/locale/ss.js",
	"./sv": "./node_modules/moment/locale/sv.js",
	"./sv.js": "./node_modules/moment/locale/sv.js",
	"./sw": "./node_modules/moment/locale/sw.js",
	"./sw.js": "./node_modules/moment/locale/sw.js",
	"./ta": "./node_modules/moment/locale/ta.js",
	"./ta.js": "./node_modules/moment/locale/ta.js",
	"./te": "./node_modules/moment/locale/te.js",
	"./te.js": "./node_modules/moment/locale/te.js",
	"./tet": "./node_modules/moment/locale/tet.js",
	"./tet.js": "./node_modules/moment/locale/tet.js",
	"./tg": "./node_modules/moment/locale/tg.js",
	"./tg.js": "./node_modules/moment/locale/tg.js",
	"./th": "./node_modules/moment/locale/th.js",
	"./th.js": "./node_modules/moment/locale/th.js",
	"./tl-ph": "./node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "./node_modules/moment/locale/tl-ph.js",
	"./tlh": "./node_modules/moment/locale/tlh.js",
	"./tlh.js": "./node_modules/moment/locale/tlh.js",
	"./tr": "./node_modules/moment/locale/tr.js",
	"./tr.js": "./node_modules/moment/locale/tr.js",
	"./tzl": "./node_modules/moment/locale/tzl.js",
	"./tzl.js": "./node_modules/moment/locale/tzl.js",
	"./tzm": "./node_modules/moment/locale/tzm.js",
	"./tzm-latn": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "./node_modules/moment/locale/tzm.js",
	"./ug-cn": "./node_modules/moment/locale/ug-cn.js",
	"./ug-cn.js": "./node_modules/moment/locale/ug-cn.js",
	"./uk": "./node_modules/moment/locale/uk.js",
	"./uk.js": "./node_modules/moment/locale/uk.js",
	"./ur": "./node_modules/moment/locale/ur.js",
	"./ur.js": "./node_modules/moment/locale/ur.js",
	"./uz": "./node_modules/moment/locale/uz.js",
	"./uz-latn": "./node_modules/moment/locale/uz-latn.js",
	"./uz-latn.js": "./node_modules/moment/locale/uz-latn.js",
	"./uz.js": "./node_modules/moment/locale/uz.js",
	"./vi": "./node_modules/moment/locale/vi.js",
	"./vi.js": "./node_modules/moment/locale/vi.js",
	"./x-pseudo": "./node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "./node_modules/moment/locale/x-pseudo.js",
	"./yo": "./node_modules/moment/locale/yo.js",
	"./yo.js": "./node_modules/moment/locale/yo.js",
	"./zh-cn": "./node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "./node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "./node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "./node_modules/moment/locale/zh-hk.js",
	"./zh-tw": "./node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "./node_modules/moment/locale/zh-tw.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/moment/locale sync recursive ^\\.\\/.*$";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"wrapper\">\r\n  <!-- Sidebar  -->\r\n  <div *ngIf=\"auth.isAuthenticatedWithout() == true\">\r\n    <nav id=\"sidebar\">\r\n      <div class=\"sidebar-header\" style=\"cursor: pointer\">\r\n\r\n      </div>\r\n\r\n      \r\n      <div class=\"sidebar-sticky\">\r\n        <ul class=\"list-unstyled \" *ngIf=\"user && user.role && user.role.urls\">\r\n          <ng-container  *ngFor=\"let item of user.role.urls\">\r\n            <li class=\"nav-item\" *ngIf=\"item.name\" >\r\n              <a class=\"nav-link active\" href=\"{{item.url}}\">\r\n                <i class=\"{{item.iClass}}\"></i>\r\n                {{item.name}} <span class=\"sr-only\"></span>\r\n              </a>\r\n            </li>\r\n          </ng-container>\r\n\r\n          <li class=\"nav-item\" > \r\n            <a class=\"nav-link active\" (click)=\"logout()\">\r\n              <i class=\"fas fa-sign-out-alt\"></i>\r\n              Cerrar sesión <span class=\"sr-only\"></span>\r\n            </a>\r\n          </li>\r\n          \r\n\r\n         <!--\r\n    \r\n          \r\n\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link active\" href=\"users\">\r\n              <i class=\"fas fa-users\"></i>\r\n              Usuarios <span class=\"sr-only\"></span>\r\n            </a>\r\n          </li>\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link active\" href=\"bay\">\r\n                <i class=\"fas fa-warehouse\"></i>\r\n              Taller <span class=\"sr-only\">(current)</span>\r\n            </a>\r\n          </li>\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link active\" href=\"activity\">\r\n              <i class=\"fas fa-dolly-flatbed\"></i>\r\n              Actividades <span class=\"sr-only\"></span>\r\n            </a>\r\n          </li>\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link active\" href=\"layout\">\r\n              <i class=\"far fa-object-group\"></i>\r\n              Distribución <span class=\"sr-only\"></span>\r\n            </a>\r\n          </li>\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link active\" href=\"component\">\r\n              <i class=\"fas fa-puzzle-piece\"></i>\r\n              Componentes <span class=\"sr-only\"></span>\r\n            </a>\r\n          </li>\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link active\" href=\"state\">\r\n              <i class=\"fas fa-adjust\"></i>\r\n              Estados <span class=\"sr-only\"></span>\r\n            </a>\r\n          </li>\r\n\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link active\" href=\"traffic/light\">\r\n              <i class=\"fas fa-traffic-light\"></i>\r\n              Semáforo <span class=\"sr-only\"></span>\r\n            </a>\r\n          </li>\r\n\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link active\" href=\"graphics\">\r\n              <i class=\"fas fa-tachometer-alt\"></i>\r\n              Gráficas <span class=\"sr-only\"></span>\r\n            </a>\r\n          </li>\r\n\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link active\" href=\"indicators\">\r\n                <i class=\"fas fa-sign\"></i>\r\n              Indicadores <span class=\"sr-only\"></span>\r\n            </a>\r\n          </li>\r\n\r\n         \r\n\r\n           <li class=\"nav-item\">\r\n            <a class=\"nav-link active\" href=\"gauge\">\r\n              <i class=\"fas fa-traffic-light\"></i>\r\n              Velocimetro <span class=\"sr-only\"></span>\r\n            </a>\r\n          </li>-->\r\n        </ul>\r\n\r\n        <!-- <h6 class=\"sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted\">\r\n            <span>Reportes</span>\r\n            <a class=\"d-flex align-items-center text-muted\" href=\"#\">\r\n              <span data-feather=\"plus-circle\"></span>\r\n            </a>\r\n          </h6>\r\n          <ul class=\"nav flex-column mb-2\">\r\n            <li class=\"nav-item\">\r\n              <a class=\"nav-link\" href=\"#\">\r\n                <span data-feather=\"file-text\"></span>\r\n                Current month\r\n              </a>\r\n            </li>\r\n             \r\n          </ul>-->\r\n\r\n      </div>\r\n\r\n\r\n    </nav>\r\n  </div>\r\n  <!-- Page Content  -->\r\n  <div id=\"content\"  >\r\n\r\n    <nav class=\"navbar navbar-expand-lg navbar-dark bg-dark \" *ngIf=\"auth.isAuthenticatedWithout() == true\">\r\n      <div class=\"container-fluid\">\r\n        <div >\r\n          <button id=\"sidebarCollapse\" class=\"btn btn-dark \" type=\"button\" data-toggle=\"collapse\"\r\n            data-target=\"#navbarSupportedContent\" aria-controls=\"navbarSupportedContent\">\r\n            <i class=\"fas fa-align-left\"></i>\r\n          </button>\r\n        </div>\r\n\r\n        <ul class=\"navbar-nav px-3\">\r\n          <div *ngIf=\"this.user && this.user.email && this.user.email =='superadmin@gecolsa.com'\">\r\n            <app-material-file-upload (complete)=\"onFileWithDataComplete($event)\" [text]=\"'Cargar Archivo'\"\r\n              [accept]=\"'.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'\">\r\n            </app-material-file-upload>\r\n          </div>\r\n        </ul>\r\n      </div>\r\n    </nav>\r\n\r\n    <main role=\"main\" class=\"col-sm-12 col-md-12 col-lg-12 \" style=\"margin-bottom: 5%;\">\r\n      <router-outlet></router-outlet>\r\n    </main>\r\n\r\n\r\n  </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/bar-graphic-modal/bar-graphic-modal.component.html":
/*!***************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/bar-graphic-modal/bar-graphic-modal.component.html ***!
  \***************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h1 mat-dialog-title> </h1>\r\n<div mat-dialog-content>\r\n    <app-bar-graphic \r\n    [barChartData]=\"barChartData\"\r\n    [barChartLabels]=\"barChartLabels\">\r\n\r\n    </app-bar-graphic>\r\n</div>\r\n<div mat-dialog-actions>\r\n  <button mat-button (click)=\"onNoClick()\">Cerrar</button>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/bar-graphic/bar-graphic.component.html":
/*!***************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/bar-graphic/bar-graphic.component.html ***!
  \***************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row-sm-12 row-lg-12 row-md-12\">\r\n  <div >\r\n    <div style=\"display: block\">\r\n      <canvas baseChart [datasets]=\"barChartData\" [labels]=\"barChartLabels\" [options]=\"barChartOptions\"\r\n        [plugins]=\"barChartPlugins\" [legend]=\"barChartLegend\" [chartType]=\"barChartType\"\r\n        (onClick)=\"chartClicked($event)\">\r\n\r\n      </canvas>\r\n    </div>\r\n    <!--  <button mat-button mat-raised-button color=\"primary\" (click)=\"randomize()\">Update</button>-->\r\n  </div >\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/bar-graphics-modal/bar-graphics-modal.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/bar-graphics-modal/bar-graphics-modal.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\r\n<div class=\"row\">\r\n    <h1 class=\"h5\"> {{data.title}} </h1>\r\n</div>\r\n<div class=\"row justify-content-center\">\r\n    \r\n   \r\n    <div *ngFor=\"let item of bars\" class=\"col-sm-12 col-lg-6 col-md-12 \">\r\n\r\n        <div mat-dialog-content>\r\n            <app-bar-graphic [barChartData]=\"item.barChartData\" [barChartLabels]=\"item.barChartLabels\">\r\n\r\n            </app-bar-graphic>\r\n        </div>\r\n\r\n    </div>\r\n\r\n\r\n\r\n    <div class=\"col-12\" mat-dialog-actions>\r\n        <button mat-button (click)=\"onNoClick()\">Cerrar</button>\r\n    </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/cake-graphic/cake-graphic.component.html":
/*!*****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/cake-graphic/cake-graphic.component.html ***!
  \*****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\r\n    <div>\r\n        <div class=\"chart\">\r\n            <canvas baseChart [data]=\"pieChartData\" [labels]=\"pieChartLabels\" [chartType]=\"pieChartType\"\r\n                [options]=\"pieChartOptions\" [plugins]=\"pieChartPlugins\" [colors]=\"pieChartColors\"\r\n                [legend]=\"pieChartLegend\">\r\n            </canvas>\r\n        </div>\r\n    </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/filter/filter.component.html":
/*!*****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/filter/filter.component.html ***!
  \*****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"modal fade\" id=\"FiltersWithArrays\" tabindex=\"-1\" data-backdrop=\"static\" data-keyboard=\"false\" role=\"dialog\"\r\n    aria-labelledby=\"filterModalTittle\" aria-hidden=\"true\">\r\n    <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\">\r\n                <h5 class=\"modal-title\" id=\"exampleModalLongTitle\">Filtros</h5>\r\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n                </button>\r\n            </div>\r\n            <div class=\"modal-body\">\r\n\r\n                <div class=\"form-group\" *ngFor=\"let item of tittles; let i = index\">\r\n                    <label for=\"exampleInputEmail1\"\r\n                        *ngIf=\"typeAttribute[i] != 'object' && typeAttribute[i]\">{{item}}</label>\r\n\r\n                    <div *ngIf=\"typeAttribute[i] == 'number'\">\r\n\r\n                        <div *ngIf=\"containsDTO(attributes[i]) == true\">\r\n                            <mat-form-field class=\"example-full-width\">\r\n                                <input matInput #message type=\"number\" class=\"form-control rounded-0\" id=\"{{item}}\"\r\n                                    placeholder=\"INGRESE {{item}}\" name=\"{{item}}\"\r\n                                    [(ngModel)]=\"itemFilter.dto[giveAttribute(attributes[i])]\">\r\n                                <mat-hint align=\"start\"><strong>OT asociada</strong> </mat-hint>\r\n\r\n                            </mat-form-field>\r\n\r\n                        </div>\r\n\r\n                        <div *ngIf=\"containsDTO(attributes[i]) == false\">\r\n                            <mat-form-field class=\"example-full-width\">\r\n                                <input type=\"number\" class=\"form-control rounded-0\" id=\"{{item}}\"\r\n                                    placeholder=\"INGRESE {{item}}\" name=\"{{item}}\"\r\n                                    [(ngModel)]=\"itemFilter[attributes[i]]\">\r\n                                <mat-hint align=\"start\"><strong>OT asociada</strong> </mat-hint>\r\n\r\n                            </mat-form-field>\r\n                        </div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n                    </div>\r\n\r\n                    <div *ngIf=\"typeAttribute[i] == 'text' || typeAttribute[i] == 'text/only'\">\r\n                        <input type=\"text\" class=\"form-control rounded-0\" id=\"{{item}}\" placeholder=\"INGRESE {{item}}\"\r\n                            name=\"{{item}}\" [(ngModel)]=\"itemFilter.dto[giveAttribute(attributes[i])]\"\r\n                            *ngIf=\"containsDTO(attributes[i]) == true\">\r\n                        <input type=\"text\" class=\"form-control rounded-0\" id=\"{{item}}\" placeholder=\"INGRESE {{item}}\"\r\n                            name=\"{{item}}\" [(ngModel)]=\"itemFilter[attributes[i]]\"\r\n                            *ngIf=\"containsDTO(attributes[i]) == false\">\r\n\r\n                    </div>\r\n\r\n                    <div *ngIf=\"typeAttribute[i] == 'date'\">\r\n                        <input type=\"date\" class=\"form-control rounded-0\" id=\"{{item}}\" placeholder=\"INGRESE {{item}}\"\r\n                            name=\"{{item}}\" [(ngModel)]=\"itemFilter.dto[giveAttribute(attributes[i])]\"\r\n                            *ngIf=\"containsDTO(attributes[i]) == true\">\r\n                        <input type=\"date\" class=\"form-control rounded-0\" id=\"{{item}}\" placeholder=\"INGRESE {{item}}\"\r\n                            name=\"{{item}}\" [(ngModel)]=\"itemFilter[attributes[i]]\"\r\n                            *ngIf=\"containsDTO(attributes[i]) == false\">\r\n                    </div>\r\n\r\n                    <div *ngIf=\"typeAttribute[i] == 'email'\">\r\n                        <input type=\"email\" class=\"form-control rounded-0\" id=\"{{item}}\" placeholder=\"INGRESE {{item}}\"\r\n                            name=\"{{item}}\" [(ngModel)]=\"itemFilter.dto[giveAttribute(attributes[i])]\"\r\n                            *ngIf=\"containsDTO(attributes[i]) == true\">\r\n                        <input type=\"email\" class=\"form-control rounded-0\" id=\"{{item}}\" placeholder=\"INGRESE {{item}}\"\r\n                            name=\"{{item}}\" [(ngModel)]=\"itemFilter[attributes[i]]\"\r\n                            *ngIf=\"containsDTO(attributes[i]) == false\">\r\n\r\n                    </div>\r\n\r\n\r\n\r\n                    <div *ngIf=\"typeAttribute[i] == 'deleted'\" class=\"form-check\">\r\n                        <input type=\"checkbox\" class=\"form-check-input\" id=\"materialChecked2\" id=\"{{item}}\"\r\n                            placeholder=\"Ingrese {{item}}\" name=\"{{item}}\" [(ngModel)]=\"itemFilter[attributes[i]]\">\r\n                        <label class=\"form-check-label\" for=\"materialChecked2\">{{item}}</label>\r\n                    </div>\r\n\r\n\r\n                    <div *ngIf=\"typeAttribute[i] == 'object' && arrayObject\">\r\n                        <div *ngFor=\"let objectItem of arrayObject let j = index\">\r\n                            <div *ngIf=\"objectItem\">\r\n                                <label\r\n                                    for=\"exampleInputEmail1\">{{tittles[(tittles.length-arrayObject.length)+(j)]}}</label>\r\n                                <div class=\"form-group\">\r\n                                    <select class=\"form-control\" [(ngModel)]=\"arrayResults[j]\" name=\"{{j}\" >\r\n                                                <option value=\"-1\">SELECCIONE {{tittles[(tittles.length-arrayObject.length)+(j)]}}</option>\r\n                                                <option *ngFor=\" let itemObject of arrayObject[j]\"\r\n                                        [value]=\"giveOnString(itemObject)\">\r\n                                        {{itemObject.name}}\r\n                                        </option>\r\n                                    </select>\r\n                                </div>\r\n                            </div>\r\n\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n\r\n\r\n\r\n            </div>\r\n            <div class=\"modal-footer\">\r\n                <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" #buttonClose>Cerrar</button>\r\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"filterObject()\">Filtrar</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/force-change-password/force-change-password.component.html":
/*!***********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/force-change-password/force-change-password.component.html ***!
  \***********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\" style=\"justify-content: center;\">\r\n    <div class=\"col-sm-6 col-md-6 col-lg-6\">\r\n\r\n        <div class=\"shadow-element \">\r\n            <mat-card>\r\n\r\n                <div class=\"card rounded-0 \">\r\n                    <div class=\"card-header\">\r\n                        <div *ngIf=\"user && user.email\">\r\n                            Usuario : {{user.email}}\r\n                        </div>\r\n                       \r\n                    </div>\r\n                    <div class=\"card-body\">\r\n                        <div class=\"col-12 item-margin\">\r\n                            <mat-form-field class=\"example-full-width\">\r\n                                <input matInput #message maxlength=\"50\" name=\"oldPassword\" type=\"password\"\r\n                                    placeholder=\"Escriba la actual contraseña\" [(ngModel)]=\"oldPassword\" >\r\n                                <mat-hint align=\"start\"><strong>Constraseña actual</strong> </mat-hint>\r\n\r\n                            </mat-form-field>\r\n                        </div>\r\n\r\n                        <div class=\"col-12 \">\r\n                            <mat-form-field class=\"example-full-width\">\r\n                                <input matInput #message maxlength=\"50\" name=\"newPassword\" type=\"password\"\r\n                                    placeholder=\"Escriba la nueva contraseña\" [(ngModel)]=\"newPassword\">\r\n                                <mat-hint align=\"start\"><strong>Nueva contraseña</strong> </mat-hint>\r\n\r\n                            </mat-form-field>\r\n                        </div>\r\n\r\n                        <div class=\"col-12 item-margin\">\r\n                            <mat-form-field class=\"example-full-width\">\r\n                                <input matInput #message maxlength=\"50\" name=\"confirmPassword\" type=\"password\"\r\n                                    placeholder=\"Confirme Contraseña\" [(ngModel)]=\"confirmPassword\">\r\n                                <mat-hint align=\"start\"><strong>Confirmar contraseña</strong> </mat-hint>\r\n\r\n                            </mat-form-field>\r\n                        </div>\r\n\r\n                        <div style=\"display: flex; justify-content: center;\">\r\n                            <button class=\" item-margin btn-change\" (click)=\"changePassword()\" mat-button>Cambiar Contraseña</button>\r\n\r\n                        </div>\r\n\r\n                        \r\n                    </div>\r\n                </div>\r\n\r\n\r\n            </mat-card>\r\n        </div>\r\n\r\n    </div>\r\n\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/home/home.component.html":
/*!*************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/home/home.component.html ***!
  \*************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\r\n\r\n    <div class=\"col-sm-12 col-md-6 col-lg-6 principal-elements \">\r\n        <div class=\"shadow-element\" style=\"margin-top: 5%;\">\r\n            <mat-card>\r\n                <img src=\"assets/img/logo_gecolsa.png\" class=\"card-img-top\" >\r\n                \r\n\r\n            </mat-card>\r\n\r\n        </div>\r\n\r\n    </div>\r\n    <div class=\"col-sm-12 col-md-6 col-lg-6 principal-elements \">\r\n        <div class=\"shadow-element\" style=\"margin-top:5%\">\r\n            <mat-card>\r\n               \r\n                <img src=\"assets/img/logo_banner.png\" class=\"card-img-top\" style=\"height: 67%; width: 67%; \">\r\n            </mat-card>\r\n\r\n        </div>\r\n\r\n    </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/just-info-dialog/just-info-dialog.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/just-info-dialog/just-info-dialog.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\r\n<h1 mat-dialog-title> {{data.tittle}}</h1>\r\n<div mat-dialog-content>\r\n  <p>{{data.info}}</p>\r\n</div>\r\n<div mat-dialog-actions>\r\n  <button mat-button (click)=\"onNoClick()\">Cerrar</button>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/loading/loading.component.html":
/*!*******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/loading/loading.component.html ***!
  \*******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div style=\"text-align: center;\">\r\n    <mat-card>\r\n        <mat-card-content>\r\n            <h3 *ngIf=\"!data || !data.message\" class=\"example-h2\">Espere mientras se carga la información</h3>\r\n            <h3 *ngIf=\"data && data.message\" class=\"example-h2\">{{data.message}}</h3>\r\n            \r\n\r\n            <mat-spinner style=\"left: 30%;\" class=\"example-margin\" [color]=\"color\" [value]=\"value\">\r\n\r\n            </mat-spinner>\r\n        </mat-card-content>\r\n    </mat-card>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/login/login.component.html":
/*!***************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/login/login.component.html ***!
  \***************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- Default form login -->\r\n<div style=\"padding-top: 2%;\" *ngIf=\"showed == true\">\r\n    <div class=\"card text-center col-6  form-signin shadowElement\">\r\n        <div class=\"card-header\">\r\n            INICIAR SESIÓN\r\n        </div>\r\n        <form class=\"text-center border border-light p-5 \" action=\"#!\">\r\n\r\n\r\n\r\n            <!-- Email -->\r\n            <input type=\"email\" id=\"defaultLoginFormEmail\" class=\"form-control mb-4\" placeholder=\"Usuario *\"\r\n                [(ngModel)]=\"user\" name=\"username\" maxlength=\"50\"> \r\n\r\n            <!-- Password -->\r\n            <input type=\"password\" id=\"defaultLoginFormPassword\" class=\"form-control mb-4\" placeholder=\"Constraseña *\"\r\n                [(ngModel)]=\"password\" name=\"password\" maxlength=\"30\">\r\n\r\n            <div class=\"remember\">\r\n\r\n                <!-- Default switch -->\r\n\r\n                <div class=\"row\">\r\n                    <div class=\"md-form\">\r\n                        <div class=\"material-switch\">\r\n                            <input id=\"switch-primary\" name=\"switch-primary\" type=\"checkbox\" [(ngModel)]=\"remember\">\r\n                            <label for=\"switch-primary\" class=\"primary-color\"></label>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-top: 2%;\">\r\n                    Recordarme\r\n                </div>\r\n            </div>\r\n\r\n            <!-- Sign in button -->\r\n            <button class=\"btn btn-info btn-block my-4\" type=\"submit\" (click)=\"login()\">Iniciar</button>\r\n\r\n\r\n            <!-- Social login -->\r\n\r\n        </form>\r\n\r\n\r\n        <div class=\"card-footer \">\r\n\r\n\r\n\r\n            <div class=\"row\">\r\n                <a (click)=\"goToSismoit()\">\r\n                    <p class=\"mt-5 mb-3 text-muted\" style=\"cursor:pointer\">&copy; Desarrollado sismoit.com</p>\r\n                </a>\r\n            </div>\r\n\r\n\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div style=\"padding-top: 2%;\" *ngIf=\"showed == false\">\r\n    saliendo\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/not-found/not-found.component.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/not-found/not-found.component.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>Lo sentimos</div>\r\n\r\n<p> no se encontro el recurso que desea buscar.</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/show-bay/show-bay.component.html":
/*!*********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/show-bay/show-bay.component.html ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h1 mat-dialog-title>Bahía {{bay.bayNumber}}</h1>\r\n<div mat-dialog-content>\r\n    <p *ngIf=\"bay.excludeBay\">Se encuentra excluida de los indicadores </p>\r\n    <p *ngIf=\"!bay.excludeBay\">No se encuentra excluida de los indicadores </p>\r\n\r\n    <mat-form-field [color]=\"'accent'\">\r\n        <input maxlength=\"5\" matInput type=\"text\" min=\"1\" maxlength=\"15\" placeholder=\"Nombre de bahia\"\r\n            [(ngModel)]=\"bay.bayNumber\">\r\n\r\n    </mat-form-field>\r\n\r\n    <mat-checkbox class=\"example-margin\" [(ngModel)]=\"bay.excludeBay\">Excluir de indicador</mat-checkbox>\r\n</div>\r\n<div mat-dialog-actions>\r\n    <button mat-button (click)=\"onNoClick()\">Cancelar</button>\r\n    <button mat-button [mat-dialog-close]=\"bay\" cdkFocusInitial>Editar</button>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/speedometer/speedometer.component.html":
/*!***************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/speedometer/speedometer.component.html ***!
  \***************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<rg-gauge-chart [canvasWidth]=\"canvasWidth\" [needleValue]=\"needleValue\" [centralLabel]=\"centralLabel\"\r\n  [options]=\"options\" [name]=\"name\" [bottomLabel]=\"bottomLabel\"></rg-gauge-chart>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/user/user.component.html":
/*!*************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/user/user.component.html ***!
  \*************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\r\n\r\n    <div class=\"col-sm-12 col-md-4 col-lg-4 principal-elements \">\r\n        <div class=\"shadow-element\">\r\n            <mat-card>\r\n\r\n                <div class=\"card\">\r\n                    <h5 class=\"card-header\">USUARIOS</h5>\r\n                    <div class=\"card-body\" style=\"height: 400px; overflow-y: auto;\">\r\n                        <form>\r\n                            <div class=\"col-12 item-margin\">\r\n                                <mat-form-field class=\"example-full-width\">\r\n                                    <input matInput #message maxlength=\"50\" name=\"name\" placeholder=\"Nombre del usuario\"\r\n                                        [(ngModel)]=\"user.name\">\r\n                                    <mat-hint align=\"start\"><strong>Nombre del usuario</strong> </mat-hint>\r\n\r\n                                </mat-form-field>\r\n                            </div>\r\n\r\n                            <div class=\"col-12 item-margin\">\r\n                                <mat-form-field class=\"example-full-width\">\r\n                                    <input matInput #message maxlength=\"50\" name=\"identUser\" type=\"number\"\r\n                                        placeholder=\"Identificación del usuario\" [(ngModel)]=\"user.userIdentification\">\r\n                                    <mat-hint align=\"start\"><strong>Identificación del usuario</strong> </mat-hint>\r\n\r\n                                </mat-form-field>\r\n                            </div>\r\n\r\n                            <div class=\"col-12 item-margin\" style=\"margin-bottom: 15%;\">\r\n                                <mat-form-field class=\"example-full-width\">\r\n                                    <input matInput #message maxlength=\"255\" name=\"emailUser\"\r\n                                        placeholder=\"Correo empresarial\" [(ngModel)]=\"user.email\">\r\n                                    <mat-hint align=\"start\"><strong>Correo empresarial</strong>\r\n                                    </mat-hint>\r\n                                    <mat-hint align=\"end\">{{message.value.length}} / 255</mat-hint>\r\n                                </mat-form-field>\r\n                            </div>\r\n\r\n                            <div class=\"col-12 item-margin\">\r\n                                <mat-form-field>\r\n                                    <mat-label>Roles</mat-label>\r\n                                    <select matNativeControl name=\"roleUser\" [(ngModel)]=\"user.role\">\r\n                                        <option *ngFor=\"let item of roles\" [ngValue]=\"item\">\r\n                                            {{item.name}}</option>\r\n                                    </select>\r\n                                </mat-form-field>\r\n                            </div>\r\n\r\n\r\n                            <div class=\"col-12 item-margin\">\r\n                                <mat-form-field>\r\n                                    <mat-label>Taller</mat-label>\r\n                                    <select matNativeControl name=\"garageUser\" [(ngModel)]=\"user.garage\">\r\n                                        <option *ngFor=\"let item of garages\" [ngValue]=\"item\">\r\n                                            {{item.name}}</option>\r\n                                    </select>\r\n                                </mat-form-field>\r\n                            </div>\r\n\r\n\r\n\r\n                        </form>\r\n                    </div>\r\n                    <div class=\"card-footer\">\r\n                        <div class=\"btn-group float-left\" role=\"group\">\r\n                            <button class=\"btn btn-secondary \" id=\"btnClean\" (click)=\"clear()\"><i\r\n                                    class=\"fas fa-file\"></i>\r\n                            </button>\r\n\r\n                            <button type=\"submit\" class=\"btn btn-secondary\" id=\"btnSave\" (click)=\"signUp()\"><i\r\n                                    class=\"fas fa-save\"></i> </button>\r\n\r\n\r\n\r\n\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </mat-card>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"col-sm-8 col-md-8 col-lg-8 \">\r\n        <div class=\"shadow-element\">\r\n            <mat-card>\r\n                <div class=\"card rounded-0\">\r\n                    <div class=\"card-header\">\r\n                        <h3 class=\"mb-0\">Usuarios\r\n\r\n                        </h3>\r\n                    </div>\r\n                    <div class=\"card-body\" style=\"height: 400px; overflow-y: auto;\">\r\n                        <table mat-table [dataSource]=\"dataSource\" class=\"mat-elevation-z8\">\r\n\r\n                            <!--- Note that these columns can be defined in any order.\r\n                                              The actual rendered columns are set as a property on the row definition\" -->\r\n\r\n                            <!-- Position Column -->\r\n                            <ng-container matColumnDef=\"id\">\r\n                                <th mat-header-cell *matHeaderCellDef> Id. </th>\r\n                                <td mat-cell *matCellDef=\"let element\"> {{element.id}} </td>\r\n                            </ng-container>\r\n\r\n                            <ng-container matColumnDef=\"ident\">\r\n                                <th mat-header-cell *matHeaderCellDef> Identificación </th>\r\n                                <td mat-cell *matCellDef=\"let element\"> {{element.userIdentification}} </td>\r\n                            </ng-container>\r\n\r\n                            <!-- Name Column -->\r\n                            <ng-container matColumnDef=\"name\">\r\n                                <th mat-header-cell *matHeaderCellDef> Nombre </th>\r\n                                <td mat-cell *matCellDef=\"let element\"> {{element.name}} </td>\r\n                            </ng-container>\r\n\r\n                            <!-- Weight Column -->\r\n                            <ng-container matColumnDef=\"role\">\r\n                                <th mat-header-cell *matHeaderCellDef> Rol </th>\r\n                                <td mat-cell *matCellDef=\"let element\"> {{element.role.name}} </td>\r\n                            </ng-container>\r\n\r\n                            <ng-container matColumnDef=\"garage\">\r\n                                <th mat-header-cell *matHeaderCellDef> Taller </th>\r\n                                <td mat-cell *matCellDef=\"let element\" > {{element.garage.name}} </td>\r\n                      \r\n                                \r\n                               \r\n                            </ng-container>\r\n\r\n                            <ng-container matColumnDef=\"edit\">\r\n                                <th mat-header-cell *matHeaderCellDef> Acción </th>\r\n                                <td mat-cell *matCellDef=\"let element\">\r\n                                    <button class=\"btn btn-primary\" id=\"btnDelete\" (click)=\"edit(element)\"><i\r\n                                            class=\"fas fa-edit\"></i>\r\n                                    </button>\r\n\r\n\r\n                                </td>\r\n                            </ng-container>\r\n\r\n\r\n\r\n                            <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n                            <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n                        </table>\r\n\r\n                    </div>\r\n\r\n                </div>\r\n\r\n            </mat-card>\r\n        </div>\r\n\r\n\r\n\r\n    </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/activity/activity.component.html":
/*!***************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/activity/activity.component.html ***!
  \***************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\r\n\r\n    <div class=\"col-sm-4 col-md-4 col-lg-4\">\r\n\r\n        <div class=\"shadow-element\">\r\n            <mat-card>\r\n\r\n                <div class=\"card rounded-0\">\r\n                    <div class=\"card-header\">\r\n\r\n\r\n                        <div class=\"row\">\r\n                            <div class=\"col-8\">\r\n                                <h3 class=\"mb-0\">ACTIVIDAD</h3>\r\n                            </div>\r\n\r\n                            <div class=\"col-4\">\r\n                                <button mat-button (click)=\"downloadReport()\" class=\"btn-primary\">Reporte</button>\r\n                            </div>\r\n\r\n                        </div>\r\n\r\n                    </div>\r\n                    <div class=\"card-body\" style=\"height: 400px; overflow-y: auto;\">\r\n                        <form>\r\n                            <div class=\"col-12 item-margin\">\r\n                                <mat-form-field class=\"example-full-width\">\r\n                                    <input [disabled]=\"activity.id\" matInput #message maxlength=\"50\" name=\"workorder\"\r\n                                        placeholder=\"Orden de trabajo\" [(ngModel)]=\"activity.workOrder\">\r\n                                    <mat-hint align=\"start\"><strong>OT asociada</strong> </mat-hint>\r\n\r\n                                </mat-form-field>\r\n                            </div>\r\n\r\n                            <div class=\"col-12 item-margin\" style=\"margin-bottom: 15%;\">\r\n                                <mat-form-field class=\"example-full-width\">\r\n                                    <input matInput #message maxlength=\"255\" name=\"description\"\r\n                                        placeholder=\"Descripción\" [(ngModel)]=\"activity.description\">\r\n                                    <mat-hint align=\"start\"><strong>Añada una descripción de la actividad</strong>\r\n                                    </mat-hint>\r\n                                    <mat-hint align=\"end\">{{message.value.length}} / 255</mat-hint>\r\n                                </mat-form-field>\r\n                            </div>\r\n\r\n                            <div class=\"col-12 item-margin\">\r\n                                <mat-form-field>\r\n                                    <mat-label>Componente</mat-label>\r\n                                    <select matNativeControl name=\"component\" [(ngModel)]=\"componentSelected\">\r\n                                        <option *ngFor=\"let item of components\" [ngValue]=\"item\">\r\n                                            {{item.code}}/{{item.name}}</option>\r\n                                    </select>\r\n                                </mat-form-field>\r\n                            </div>\r\n\r\n                            <div class=\"col-12 item-margin\">\r\n                                <mat-form-field>\r\n                                    <mat-label>Estado de actividad</mat-label>\r\n                                    <select matNativeControl name=\"state\" [(ngModel)]=\"stateSelected\">\r\n                                        <option *ngFor=\"let item of states\" [ngValue]=\"item\">\r\n                                            {{item.code}}/{{item.name}}</option>\r\n                                    </select>\r\n                                </mat-form-field>\r\n                            </div>\r\n\r\n                           <!-- <div class=\"col-12 item-margin\">\r\n                                <mat-form-field>\r\n                                    <mat-label>Taller</mat-label>\r\n                                    <select matNativeControl name=\"garage\" [(ngModel)]=\"garageSelected\"\r\n                                        (change)=\"listBaysByGarage($event)\">\r\n                                        <option *ngFor=\"let item of garages\" [ngValue]=\"item\">\r\n                                            {{item.name}}/{{item.city}}</option>\r\n                                    </select>\r\n                                </mat-form-field>\r\n                            </div>-->\r\n\r\n                            <div class=\"col-12 item-margin\">\r\n                                <mat-form-field>\r\n                                    <mat-label>Bahía </mat-label>\r\n                                    <select matNativeControl name=\"bay\" [(ngModel)]=\"baySelected\">\r\n                                        <option *ngFor=\"let item of bays\" [ngValue]=\"item\">\r\n                                            {{item.bayNumber}}/{{getSate(item)}}</option>\r\n                                    </select>\r\n                                </mat-form-field>\r\n                            </div>\r\n\r\n\r\n\r\n                        </form>\r\n                    </div>\r\n                    <div class=\"card-footer\">\r\n                        <div class=\"btn-group float-left\" role=\"group\">\r\n                            <button class=\"btn btn-secondary \" id=\"btnClean\" (click)=\"clear()\"><i\r\n                                    class=\"fas fa-file\"></i>\r\n                            </button>\r\n\r\n                            <button type=\"submit\" class=\"btn btn-secondary\" id=\"btnSave\" (click)=\"saveActivity()\"><i\r\n                                    class=\"fas fa-save\"></i> </button>\r\n\r\n\r\n\r\n\r\n                        </div>\r\n                    </div>\r\n                    <!--/card-block-->\r\n                </div>\r\n\r\n            </mat-card>\r\n        </div>\r\n\r\n\r\n    </div>\r\n\r\n    <div class=\"col-sm-8 col-md-8 col-lg-8 \">\r\n        <div class=\"shadow-element\">\r\n            <mat-card>\r\n                <div class=\"card rounded-0\">\r\n                    <div class=\"card-header\">\r\n                        <div class=\"row\">\r\n                            <div class=\"col-8\">\r\n                                <h3 class=\"mb-0\">ACTIVIDADES\r\n    \r\n                                </h3>\r\n                            </div>\r\n    \r\n                            <div class=\"col-4\">\r\n    \r\n                                <div class=\"btn-group\" role=\"group\" style=\"float: right;\">\r\n    \r\n    \r\n                                    <button class=\"btn btn-primary\" id=\"filter\" data-target=\"#FiltersWithArrays\"\r\n                                        data-toggle=\"modal\">\r\n                                        <i class=\"fas fa-edit\"></i>\r\n                                        Filtrar\r\n                                    </button>\r\n    \r\n    \r\n                                </div>\r\n    \r\n                            </div>\r\n    \r\n                        </div>\r\n                    </div>\r\n                    <div class=\"card-body\" style=\"height: 400px; overflow-y: auto;\">\r\n\r\n                        <table mat-table [dataSource]=\"dataSource\" multiTemplateDataRows class=\"mat-elevation-z8\">\r\n                            <ng-container matColumnDef=\"{{column}}\" *ngFor=\"let column of columnsToDisplay\">\r\n                                <th mat-header-cell *matHeaderCellDef> {{column}} </th>\r\n                                <td mat-cell *matCellDef=\"let element\"> {{getValue( column,element)}} </td>\r\n\r\n                            </ng-container>\r\n\r\n                            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->\r\n                            <ng-container matColumnDef=\"expandedDetail\">\r\n                                <td mat-cell *matCellDef=\"let element\" [attr.colspan]=\"columnsToDisplay.length\">\r\n                                    <div class=\"example-element-detail\"\r\n                                        [@detailExpand]=\"element == expandedElement ? 'expanded' : 'collapsed'\">\r\n                                        <div class=\"col-12\">\r\n                                            <div class=\"row element-margin\">\r\n                                                <div class=\"col-6 \">\r\n                                                    <span class=\"field\">Id:</span><span>{{element.id}}</span>\r\n                                                </div>\r\n\r\n                                                <div class=\"col-6\" *ngIf=\"element.workOrder\">\r\n                                                    <span class=\"field\">Orden de\r\n                                                        trabajo:</span><span>{{element.workOrder}}</span>\r\n                                                </div>\r\n                                                <div class=\"col-6\" *ngIf=\"!element.workOrder\">\r\n                                                    <span class=\"field\">Orden de trabajo:</span><span>No esta\r\n                                                        definido</span>\r\n                                                </div>\r\n                                            </div>\r\n\r\n\r\n                                            <div class=\"row element-margin\">\r\n                                                <div class=\"col-6  \">\r\n                                                    <span class=\"field\">Estado:</span><span>{{element.stateName}}</span>\r\n                                                </div>\r\n                                                <div class=\"col-6\">\r\n                                                    <span\r\n                                                        class=\"field\">Taller:</span><span>{{element.garageName}}</span>\r\n                                                </div>\r\n\r\n                                            </div>\r\n                                            <div class=\"row element-margin\">\r\n                                                <div class=\"col-6\">\r\n                                                    <span class=\"field\">Bahía:</span><span>{{element.bayNumber}}</span>\r\n                                                </div>\r\n                                                <div class=\"col-6\">\r\n                                                    <span\r\n                                                        class=\"field\">Componente:</span><span>{{element.componentName}}</span>\r\n                                                </div>\r\n\r\n\r\n                                            </div>\r\n                                            <div class=\"row\">\r\n                                                <div class=\"col-10\">\r\n                                                    <span>{{element.description}}</span>\r\n                                                </div>\r\n                                                <div class=\"btn-group float-left\" role=\"group\">\r\n\r\n                                                    <button class=\"btn btn-primary\" id=\"btnDelete\"\r\n                                                        (click)=\"delete(element)\"><i class=\"fas fa-calendar-check\"></i>\r\n                                                    </button>\r\n                                                    <button class=\"btn btn-black\" id=\"btnEdit\"\r\n                                                        (click)=\"edit(element)\"><i class=\"fas fa-edit\"></i>\r\n                                                    </button>\r\n\r\n                                                </div>\r\n\r\n                                            </div>\r\n                                        </div>\r\n\r\n\r\n\r\n\r\n\r\n                                    </div>\r\n                                </td>\r\n                            </ng-container>\r\n\r\n                            <tr mat-header-row *matHeaderRowDef=\"columnsToDisplay\"></tr>\r\n                            <tr mat-row *matRowDef=\"let element; columns: columnsToDisplay;\" class=\"example-element-row\"\r\n                                [class.example-expanded-row]=\"expandedElement === element\"\r\n                                (click)=\"expandedElement = expandedElement === element ? null : element\">\r\n                            </tr>\r\n                            <tr mat-row *matRowDef=\"let row; columns: ['expandedDetail']\" class=\"example-detail-row\">\r\n                            </tr>\r\n                        </table>\r\n                    </div>\r\n\r\n                </div>\r\n\r\n            </mat-card>\r\n        </div>\r\n\r\n\r\n\r\n    </div>\r\n\r\n\r\n\r\n</div>\r\n\r\n\r\n<div *ngIf=\"initialized >= 2\">\r\n    <app-filter [tittles]=\"tittlesFilter\" [itemFilter]=\"onFilter\" [attributes]=\"attributesFilter\"\r\n    [arrayObject]=\"arrayObject\" [arrayResults]=\"arrayResults\" [typeAttribute]=\"typeFilters\"\r\n    (filter)=\"filter($event)\">\r\n\r\n    </app-filter>\r\n\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/bay/bay.component.html":
/*!*****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/bay/bay.component.html ***!
  \*****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!--<div class=\"row\">\r\n\r\n    <div class=\"row\">\r\n\r\n        <div class=\"col-sm-12 col-md-12 col-lg-12\">\r\n                <img *ngIf=\"imgURL\" [src]=\"imgURL\" style=\"height: 80%;\">\r\n        </div>\r\n\r\n\r\n    </div>\r\n    <div class=\"row\">\r\n\r\n        <div class=\"card \">\r\n\r\n            <div class=\"col-5\">\r\n                    <div style=\"text-align:center\">\r\n                            <app-material-file-upload (complete)=\"onFileComplete($event)\"></app-material-file-upload>\r\n                    </div>\r\n            </div>\r\n\r\n           \r\n        </div>\r\n\r\n    </div>\r\n\r\n\r\n</div> -->\r\n\r\n<div *ngIf=\"addGarage == 0\">\r\n\r\n    <div class=\"shadow-element \">\r\n        <mat-card>\r\n            <div class=\"row item-title\" *ngIf=\"this.garages.length == 0\">\r\n                <span class=\"label label-default\">No tiene talleres creados</span>\r\n\r\n            </div>\r\n\r\n            <div class=\"row\" *ngIf=\"garages.length > 0\">\r\n\r\n\r\n                <div *ngFor=\"let item of garages\">\r\n                    <div class=\"card mr-3 ml-3 mt-2\" style=\"width: 10rem; min-width: 8rem; height: 320px;\">\r\n                        <img width=\"100%\" width=\"100%\" style=\"height: 150px;\" [src]=\"item.urlLayout\"\r\n                            class=\"card-img-top\">\r\n                        <div class=\"card-body\">\r\n                            <h5 class=\"card-title\">{{giveMeName(item.name)}}</h5>\r\n                            <p class=\"card-text\">{{giveMeName(item.city,10)}}</p>\r\n                            <!-- <a href=\"#\" class=\"btn btn-primary\">Go somewhere</a>-->\r\n                        </div>\r\n                        <div class=\"justify-content-center d-flex\">\r\n\r\n                            <button mat-button color=\"accent\" (click)=\"deleteBay(item)\" style=\" cursor: pointer;\"><i\r\n                                    class=\"fas fa-trash icon-size\"></i></button>\r\n\r\n                            <button mat-button color=\"accent\" (click)=\"editBay(item)\" class=\"mr-2\"\r\n                                style=\" cursor: pointer;\"><i class=\"fas fa-edit icon-size\"></i></button>\r\n\r\n                        </div>\r\n                    </div>\r\n\r\n                </div>\r\n\r\n\r\n            </div>\r\n\r\n\r\n\r\n        </mat-card>\r\n    </div>\r\n\r\n    <div class=\"col-sm-12 col-md-12 col-lg-12 button-group-style\">\r\n\r\n\r\n        <button mat-button class=\"button-padding\" mat-fab color=\"accent\" (click)=\"newGarage()\"><i\r\n                class=\"fas fa-warehouse icon-size\"></i></button>\r\n\r\n\r\n\r\n    </div>\r\n\r\n</div>\r\n\r\n<div *ngIf=\"addGarage == 1\">\r\n\r\n\r\n\r\n    <mat-horizontal-stepper [linear]=\"isLinear\" #stepper color=\"accent\">\r\n        <mat-step [stepControl]=\"firstFormGroup\" [completed]=\"isFirstStepComplete()\">\r\n\r\n            <ng-template matStepLabel>Carga de distribución</ng-template>\r\n            <div class=\"col-sm-12 col-md-12 col-lg-12\">\r\n\r\n                <div class=\"row \">\r\n                    <mat-card class=\"col-sm-12 col-md-12 col-lg-12\">\r\n\r\n                        <div class=\"row\">\r\n                            <div class=\"col-6 \">\r\n\r\n                                <div class=\"row item-title\">\r\n                                    <span class=\"label label-default\">Distribución del taller</span>\r\n\r\n                                </div>\r\n                                <div class=\"row item-title item-col\">\r\n                                    <app-material-img-upload (complete)=\"onFileComplete($event)\" [accept]=\"'image/*'\">\r\n                                    </app-material-img-upload>\r\n                                </div>\r\n\r\n                            </div>\r\n                            <div class=\"col-6\">\r\n                                <div class=\"row item-title\">\r\n                                    <span class=\"label label-default\">Información del taller</span>\r\n\r\n                                </div>\r\n                                <div class=\"row item-col\">\r\n                                    <div class=\"col-6\">\r\n                                        <mat-form-field class=\"example-full-width\">\r\n                                            <input matInput #message maxlength=\"50\" placeholder=\"Nombre *\"\r\n                                                [(ngModel)]=\"garage.name\">\r\n                                            <mat-hint align=\"start\"><strong>Nombre del taller</strong> </mat-hint>\r\n\r\n                                        </mat-form-field>\r\n                                    </div>\r\n\r\n                                    <div class=\"col-6\">\r\n                                        <mat-form-field class=\"example-full-width\">\r\n                                            <input matInput #message maxlength=\"50\" placeholder=\"Wip Equivalencia *\"\r\n                                                [(ngModel)]=\"garage.wipEquivalence\">\r\n                                            <mat-hint align=\"start\"><strong>Equivalencia del nombre en el wip</strong> </mat-hint>\r\n\r\n                                        </mat-form-field>\r\n                                    </div>\r\n\r\n                                    <div class=\"col-6\">\r\n                                        <mat-form-field class=\"example-full-width\">\r\n                                            <input matInput #message maxlength=\"50\" placeholder=\"Ciudad *\"\r\n                                                [(ngModel)]=\"garage.city\">\r\n                                            <mat-hint align=\"start\"><strong>Ciudad donde se encuentra el taller</strong>\r\n                                            </mat-hint>\r\n\r\n                                        </mat-form-field>\r\n                                    </div>\r\n\r\n                                </div>\r\n\r\n                                <div class=\"row\">\r\n\r\n                                </div>\r\n\r\n\r\n\r\n                            </div>\r\n                        </div>\r\n\r\n                    </mat-card>\r\n\r\n                </div>\r\n\r\n                <div class=\"row item-col\" *ngIf=\"imgURL\" style=\"text-align: center;\">\r\n                    <mat-card class=\"col-sm-12 col-md-12 col-lg-12\">\r\n                        <div class=\"row item-title\">\r\n                            <span class=\"label label-default\">Imagen cargada</span>\r\n\r\n                        </div>\r\n\r\n                        <div class=\"row item-col\" style=\"display: block;\">\r\n\r\n                            <img [src]=\"imgURL\" height=\"25%\" width=\"25%\">\r\n\r\n\r\n                        </div>\r\n\r\n\r\n                    </mat-card>\r\n\r\n                </div>\r\n\r\n                <div class=\"col-sm-12 col-md-12 col-lg-12 button-group-style\">\r\n\r\n\r\n\r\n                    <button mat-button class=\"button-padding\" mat-fab color=\"accent\" (click)=\"cancel()\"><i\r\n                            class=\"fas fa-window-close icon-size\"></i></button>\r\n\r\n\r\n\r\n\r\n                </div>\r\n\r\n            </div>\r\n        </mat-step>\r\n        <mat-step [stepControl]=\"secondFormGroup\" [completed]=\"isSecondStepComplete()\">\r\n            <ng-template matStepLabel>Definir las bahías</ng-template>\r\n\r\n            <mat-card *ngIf=\"imgURL\">\r\n                <div class=\"row item-col\" style=\"display: block;\">\r\n\r\n                    <div style=\"width: 80%; height: 80%; position: relative;\">\r\n\r\n\r\n                        <div *ngIf=\"bays.length > 0\" style=\"height: 100%; width: 100%;\">\r\n\r\n                            <ng-container *ngFor=\"let item of bays\">\r\n                                <div (click)=\"showInfoBay(item)\" (mousedown)=\"moveBayRequired(item,$event)\"\r\n                                    *ngIf=\"item.style\" class=\"point btn\" style=\"cursor: pointer;\"\r\n                                    [ngStyle]=\"giveStyle(item.style)\">\r\n\r\n                                </div>\r\n                            </ng-container>\r\n                        </div>\r\n\r\n                        <img (mouseover)=\"movingOnBay($event)\" [src]=\"imgURL\" height=\"100%\" width=\"100%\"\r\n                            (click)=\"onClickImgBay($event)\" [ngStyle]=\"putCursorPointer()\"\r\n                            (mouseup)=\"finishMoveBay($event)\">\r\n                    </div>\r\n\r\n                </div>\r\n\r\n\r\n\r\n                <div class=\"col-sm-12 col-md-12 col-lg-12 button-group-style\">\r\n\r\n                    <button mat-button matStepperPrevious mat-fab color=\"basic\"><i\r\n                            class=\"fas fa-arrow-left\"></i></button>\r\n\r\n\r\n                    <button mat-button class=\"button-padding\" mat-fab color=\"accent\" (click)=\"defineBay()\"><i\r\n                            class=\"fas fa-inbox icon-size\"></i></button>\r\n\r\n                    <button *ngIf=\" bays.length != 0\" mat-button class=\"button-padding\" mat-fab color=\"accent\"\r\n                        (click)=\"restartBays()\"><i class=\"fas fa-history icon-size\"></i></button>\r\n\r\n                    <button *ngIf=\" bays.length != 0\" mat-button class=\"button-padding\" mat-fab color=\"accent\"\r\n                        (click)=\"deletedLastOne()\"><i class=\"fas fa-eraser icon-size\"></i></button>\r\n\r\n                    <button mat-button matStepperNext class=\"button-padding\" mat-fab color=\"basic\"><i\r\n                            class=\"fas fa-arrow-right\"></i></button>\r\n\r\n\r\n                </div>\r\n            </mat-card>\r\n\r\n            <mat-card *ngIf=\"!imgURL\">\r\n                <div class=\"row item-title\">\r\n                    <span class=\"label label-default\">Imagen no definida</span>\r\n\r\n                </div>\r\n\r\n\r\n\r\n                <div class=\"col-sm-12 col-md-12 col-lg-12 button-group-style\">\r\n\r\n                    <button mat-button matStepperPrevious mat-fab color=\"basic\"><i\r\n                            class=\"fas fa-arrow-left\"></i></button>\r\n\r\n\r\n                    <button mat-button matStepperNext class=\"button-padding\" mat-fab color=\"basic\"><i\r\n                            class=\"fas fa-arrow-right\"></i></button>\r\n\r\n\r\n                </div>\r\n            </mat-card>\r\n\r\n        </mat-step>\r\n        <mat-step>\r\n            <ng-template matStepLabel>Listo</ng-template>\r\n            <div *ngIf=\"!garage.name ||!garage.city\">\r\n\r\n\r\n                <div class=\"row item-title\">\r\n                    <span class=\"label label-warning\">Falta información por llenar</span>\r\n\r\n                </div>\r\n\r\n            </div>\r\n            <div *ngIf=\"garage.name || garage.city\">\r\n                <h3> Se creara un taller con la siguiente información</h3>\r\n            </div>\r\n\r\n\r\n            <div class=\"row\">\r\n\r\n                <div class=\"col-6\">\r\n                    <div class=\"col-12 item-info\">\r\n                        <div>\r\n                            <span class=\"label label-accent col-6\">Taller:</span> <span\r\n                                class=\"answer-item col-6\">{{garage.name}}</span>\r\n\r\n                        </div>\r\n\r\n                    </div>\r\n\r\n                    <div class=\"col-12 item-info\">\r\n                        <div>\r\n                            <span class=\"label label-accent col-6\">Ciudad:</span> <span\r\n                                class=\"answer-item col-6\">{{garage.city}}</span>\r\n\r\n                        </div>\r\n\r\n                    </div>\r\n\r\n                    <div class=\"col-12 item-info\">\r\n                        <div>\r\n                            <span class=\"label label-accent col-6\">Numero de bahías:</span> <span\r\n                                class=\"answer-item col-6\">{{bays.length}}</span>\r\n\r\n                        </div>\r\n\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-6\">\r\n                    <div class=\"row item-col\" style=\"display: block;\">\r\n                        <div style=\"width: 100%; height: 100%; position: relative;margin-bottom: 100px;\">\r\n\r\n\r\n\r\n\r\n\r\n\r\n                            <div *ngIf=\" bays && bays.length > 0\" style=\"height: 100%; width: 100%;\">\r\n\r\n                                <ng-container *ngFor=\"let item of bays\">\r\n                                    <div *ngIf=\"item.style\" class=\"point\" [ngStyle]=\"giveStyle(item.style)\"\r\n                                        (click)=\"mouseDown($event)\">\r\n\r\n                                    </div>\r\n                                </ng-container>\r\n                            </div>\r\n\r\n\r\n                            <img [src]=\"imgURL\" height=\"100%\" width=\"100%\">\r\n\r\n\r\n                        </div>\r\n                    </div>\r\n\r\n                </div>\r\n\r\n\r\n            </div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n            <div class=\"col-sm-12 col-md-12 col-lg-12 button-group-style\">\r\n\r\n                <button mat-button matStepperPrevious mat-fab color=\"basic\"><i class=\"fas fa-arrow-left\"></i></button>\r\n\r\n\r\n                <button mat-button class=\"button-padding\" mat-fab color=\"accent\" (click)=\"saveGarage()\"><i\r\n                        class=\"fas fa-save icon-size\"></i></button>\r\n\r\n\r\n            </div>\r\n\r\n\r\n        </mat-step>\r\n    </mat-horizontal-stepper>\r\n\r\n\r\n\r\n</div>\r\n\r\n\r\n\r\n<!-- Button trigger modal -->\r\n<button #btnAditionalInfo id=\"btnAditionalInfo\" type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\"\r\n    data-target=\"#exampleModal\" style=\"opacity: 0;\">\r\n\r\n</button>\r\n\r\n\r\n\r\n<div class=\"modal fade\" id=\"exampleModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\"\r\n    aria-hidden=\"true\">\r\n    <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\">\r\n                <h5 class=\"modal-title\" id=\"exampleModalLabel\">¿Estas Seguro que deseas agregar una bahía?</h5>\r\n                <button #btnCloseModal id=\"btnCloseModal\" type=\"button\" class=\"close\" data-dismiss=\"modal\"\r\n                    aria-label=\"Close\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n                </button>\r\n            </div>\r\n            <div class=\"modal-body\" style=\"text-align: center;\">\r\n                <mat-form-field [color]=\"'accent'\">\r\n                    <input maxlength=\"5\" matInput type=\"text\" min=\"1\" maxlength=\"15\" placeholder=\"Nombre de bahia\"\r\n                        [(ngModel)]=\"bay.bayNumber\">\r\n\r\n                </mat-form-field>\r\n\r\n                <mat-checkbox class=\"example-margin\" [(ngModel)]=\"bay.excludeBay\">Excluir de indicador</mat-checkbox>\r\n            </div>\r\n            <div class=\"modal-footer\">\r\n                <button mat-button data-dismiss=\"modal\">Cerrar</button>\r\n                <button mat-raised-button color=\"accent\" (click)=\"saveBay()\">Guardar</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/indicador-speed/indicador-speed.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/indicador-speed/indicador-speed.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row-sm-12 row-lg-12 row-md-12\">\r\n\r\n    <div class=\"row-sm-12 row-lg-12 row-md-12 d-flex\">\r\n\r\n        <div class=\"col-6 item-margin justify-content-center d-flex\">\r\n            <mat-form-field>\r\n                <mat-label>Taller</mat-label>\r\n                <select matNativeControl required name=\"garage\" [(ngModel)]=\"garageSelected\"\r\n                    (change)=\"listIndicatorsByGarageAll()\">\r\n                    <option [ngValue]=\"generalGarage\"> General</option>\r\n                    <option *ngFor=\"let item of garages\" [ngValue]=\"item\">\r\n                        {{item.name}}/{{item.city}}</option>\r\n                </select>\r\n            </mat-form-field>\r\n        </div>\r\n        <div class=\"col-6 item-margin text-center mt-3  top-2\">\r\n            <button mat-button class=\"btn-primary\" (click)=\"generateHistoryReport()\">Generar Historico</button>\r\n\r\n        </div>\r\n\r\n    </div>\r\n\r\n\r\n    <div class=\"row-sm-12 row-lg-12 row-md-12 shadow-element text-align-center\"\r\n        style=\"text-align: center; display: block;\">\r\n\r\n        <mat-card>\r\n\r\n            <div *ngIf=\"indicators\">\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12 col-lg-6 col-ms-12\" *ngFor=\"let item of indicators\">\r\n                        <div style=\"margin: 2%;\">\r\n                            <mat-card *ngIf=\"!item.error\">\r\n                                <mat-card-content>\r\n                                    <div *ngIf=\"item.typeIndicator == 'SPEEDOMETER'\" class=\"d-flex justify-content-center\">\r\n                                        <app-speedometer [needleValue]=\"item.response[0].resultString\"\r\n                                            [name]=\"item.response[0].name\"\r\n                                            [bottomLabel]=\"item.response[0].resultString\">\r\n\r\n\r\n                                        </app-speedometer>\r\n                                    </div>\r\n                                </mat-card-content>\r\n                                <mat-card-actions>\r\n                                    <button mat-button (click)=\"showInfoOnDialog(item)\"><i\r\n                                            class=\"fas fa-info-circle icon-size\"></i></button>\r\n                                    <button mat-button (click)=\"showTendencyDialog(item)\"><i\r\n                                            class=\"fas fa-chart-line icon-size\"></i></button>\r\n                                </mat-card-actions>\r\n                            </mat-card>\r\n\r\n                            <mat-card *ngIf=\"item.error\">\r\n                                <h4> {{item.error}}</h4>\r\n                                <mat-card-actions>\r\n                                    <button mat-button (click)=\"showInfoOnDialog(item)\"><i\r\n                                            class=\"fas fa-info-circle icon-size\"></i></button>\r\n                                    <button mat-button (click)=\"showTendencyDialog(item)\"><i\r\n                                            class=\"fas fa-chart-line icon-size\"></i></button>\r\n                                </mat-card-actions>\r\n                            </mat-card>\r\n\r\n\r\n\r\n                        </div>\r\n\r\n                    </div>\r\n                </div>\r\n\r\n\r\n            </div>\r\n\r\n            <div *ngIf=\"!indicators\">\r\n                <span class=\"label label-default\">Debe seleccionar un taller</span>\r\n            </div>\r\n\r\n        </mat-card>\r\n\r\n    </div>\r\n\r\n\r\n\r\n    <div *ngIf=\"showCake == true\" class=\"row-sm-12 row-lg-12 row-md-12 shadow-element mt-2\"\r\n        style=\"text-align: center; display: block; \">\r\n\r\n        <mat-card>\r\n            <div class=\"row\">\r\n\r\n                <div class=\"col-md-12 col-lg-6 col-ms-12\" *ngIf=\"errorShowCake == false\">\r\n                    <app-cake-graphic [pieChartLabels]=\"resultsLabels\" [pieChartData]=\"resultsCake\"\r\n                        [pieChartColors]=\"colorsCake\">\r\n\r\n                    </app-cake-graphic>\r\n                </div>\r\n\r\n\r\n                <div class=\"col-md-12 col-lg-6 col-ms-12\" *ngIf=\"errorShowCake == true\">\r\n                    <mat-card>\r\n                        <h4>No se encontraron clientes internos y externos </h4>\r\n\r\n                    </mat-card>\r\n                </div>\r\n\r\n                <div class=\"col-md-12 col-lg-6 col-ms-12\" *ngIf=\"errorShowCakeBay == false\">\r\n                    <app-cake-graphic [pieChartLabels]=\"resultsLabelsBay\" [pieChartData]=\"resultsCakeBay\"\r\n                        [pieChartColors]=\"colorsBays\">\r\n\r\n                    </app-cake-graphic>\r\n                </div>\r\n\r\n                <div class=\"col-md-12 col-lg-6 col-ms-12\" *ngIf=\"errorShowCakeBay == true\">\r\n                    <mat-card>\r\n                        <h4>No se encontraron bahías definidas</h4>\r\n\r\n                    </mat-card>\r\n                </div>\r\n\r\n            </div>\r\n        </mat-card>\r\n    </div>\r\n\r\n    <div class=\"row-sm-12 row-lg-12 row-md-12 shadow-element text-align-center  mt-2\"\r\n        style=\"text-align: center; display: block;\">\r\n\r\n        <mat-card>\r\n            <div *ngIf=\"arrayBarsGraphics && arrayBarsGraphics.length > 0\">\r\n                <div class=\"row\">\r\n\r\n                    <div class=\"col-md-12 col-lg-6 col-ms-12\" *ngFor=\"let bar of arrayBarsGraphics\">\r\n                        <div style=\"margin: 2%;\">\r\n                            <mat-card *ngIf=\"!bar.error\">\r\n                                \r\n                                    <div mat-dialog-content>\r\n                                        <app-bar-graphic [barChartData]=\"bar.info\" [barChartLabels]=\"bar.labels\"\r\n                                            [lengendOption]=\"legendOptions\">\r\n\r\n                                        </app-bar-graphic>\r\n                                    </div>\r\n\r\n                                <mat-card-actions>\r\n                                    <button mat-button (click)=\"showInfoOnDialog(bar.indicator)\"><i\r\n                                            class=\"fas fa-info-circle icon-size\"></i></button>\r\n                                    <button mat-button (click)=\"showHistoryDialog(bar.indicator)\"><i\r\n                                            class=\"fas fa-chart-line icon-size\"></i></button>\r\n                                </mat-card-actions>\r\n                            </mat-card>\r\n\r\n                            <mat-card *ngIf=\"bar.error\">\r\n                                <h4> {{bar.error}}</h4>\r\n                                <mat-card-actions>\r\n                                    <button mat-button (click)=\"showInfoOnDialog(bar.indicator)\"><i\r\n                                            class=\"fas fa-info-circle icon-size\"></i></button>\r\n                                    <button mat-button (click)=\"showHistoryDialog(bar.indicator)\"><i\r\n                                            class=\"fas fa-chart-line icon-size\"></i></button>\r\n                                </mat-card-actions>\r\n                            </mat-card>\r\n\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </mat-card>\r\n    </div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/indicator-master/indicator-master.component.html":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/indicator-master/indicator-master.component.html ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!--<div class=\"row\">\n\n    <div class=\"col-sm-4 col-md-4 col-lg-4\">\n\n        <div class=\"shadow-element\">\n            <mat-card>\n\n                <div class=\"card rounded-0\">\n                    <div class=\"card-header\">\n                        <h3 class=\"mb-0\">INDICADOR</h3>\n                    </div>\n                    <div class=\"card-body\">\n                        <form>\n                            <div class=\"col-12 item-margin\">\n                                <mat-form-field class=\"example-full-width\">\n                                    <input matInput #message maxlength=\"50\" name=\"code\" placeholder=\"Codigo *\"\n                                        [(ngModel)]=\"component.code\">\n                                    <mat-hint align=\"start\"><strong>Código de indicador </strong> </mat-hint>\n\n                                </mat-form-field>\n                            </div>\n\n                            <div class=\"col-12 item-margin\">\n                                <mat-form-field class=\"example-full-width\">\n                                    <input matInput #message maxlength=\"50\" name=\"name\" placeholder=\"Nombre *\"\n                                        [(ngModel)]=\"component.name\">\n                                    <mat-hint align=\"start\"><strong>Nombre de indicador </strong> </mat-hint>\n\n                                </mat-form-field>\n                            </div>\n\n\n                        </form>\n                    </div>\n                    <div class=\"card-footer\">\n                        <div class=\"btn-group float-left\" role=\"group\">\n                            <button class=\"btn btn-secondary \" id=\"btnClean\" (click)=\"clear()\"><i\n                                    class=\"fas fa-file\"></i>\n                            </button>\n\n                            <button type=\"submit\" class=\"btn btn-secondary\" id=\"btnSave\" (click)=\"save()\"><i\n                                    class=\"fas fa-save\"></i> </button>\n\n                            <button class=\"btn btn-primary\" id=\"btnDelete\" (click)=\"delete()\"><i\n                                    class=\"fas fa-trash\"></i>\n                            </button>\n\n\n                        </div>\n                    </div>\n\n                </div>\n\n            </mat-card>\n        </div>\n\n\n    </div>\n\n    <div class=\"col-sm-8 col-md-8 col-lg-8 \">\n        <div class=\"shadow-element\">\n            <mat-card>\n                <div class=\"card rounded-0\">\n                    <div class=\"card-header\">\n                        <h3 class=\"mb-0\">COMPONENTES\n\n                        </h3>\n                    </div>\n                    <div class=\"card-body\" style=\"height: 400px; overflow-y: auto;\">\n                        <table mat-table [dataSource]=\"components\" class=\"mat-elevation-z8\">\n\n\n                            <ng-container matColumnDef=\"id\">\n                                <th mat-header-cell *matHeaderCellDef> Id. </th>\n                                <td mat-cell *matCellDef=\"let element\"> {{element.id}} </td>\n                            </ng-container>\n\n                            <ng-container matColumnDef=\"code\">\n                                <th mat-header-cell *matHeaderCellDef> Código </th>\n                                <td mat-cell *matCellDef=\"let element\"> {{element.code}} </td>\n                            </ng-container>\n\n                            <ng-container matColumnDef=\"name\">\n                                <th mat-header-cell *matHeaderCellDef> Nombre </th>\n                                <td mat-cell *matCellDef=\"let element\"> {{element.name}} </td>\n                            </ng-container>\n\n                            <ng-container matColumnDef=\"edit\">\n                                    <th mat-header-cell *matHeaderCellDef> Accion </th>\n                                    <td mat-cell *matCellDef=\"let element\">\n                                        <button class=\"btn btn-primary\" id=\"btnDelete\" ><i class=\"fas fa-edit\"></i>\n                                        </button>\n    \n                                        \n                                    </td>\n                            </ng-container>\n\n\n                            <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\n                            <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\n                        </table>\n\n                    </div>\n\n                </div>\n\n            </mat-card>\n        </div>\n\n\n\n    </div>\n\n\n\n</div>-->");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/layout/layout.component.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/layout/layout.component.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div *ngIf=\"!garage\">\r\n    <div class=\"shadow-element\">\r\n        <mat-card>\r\n            <div class=\"row item-title\" *ngIf=\"this.garages.length == 0\">\r\n                <span class=\"label label-default\">No tiene talleres creados</span>\r\n\r\n            </div>\r\n\r\n            <div class=\"row\" *ngIf=\"garages.length > 0\">\r\n\r\n\r\n                <div *ngFor=\"let item of garages\">\r\n                    <div  class=\"card mr-3 ml-3 mt-2\" style=\"width: 10rem; min-width: 8rem; height: 320px;\" (click)=\"getLayoutByGarage(item)\">\r\n                        <img [src]=\"item.urlLayout\" width=\"100%\" width=\"100%\" style=\"height: 150px;\" class=\"card-img-top\">\r\n                        <div class=\"card-body\">\r\n                            <h5 class=\"card-title\">{{giveMeName(item.name)}}</h5>\r\n                            <p class=\"card-text\">{{giveMeName(item.city,10)}}</p>\r\n                            <!-- <a href=\"#\" class=\"btn btn-primary\">Go somewhere</a>-->\r\n                        </div>\r\n                        <button mat-button (click)=\"getLayoutByGarage(item)\">Ver</button>\r\n                    </div>\r\n                </div>\r\n\r\n\r\n            </div>\r\n\r\n        </mat-card>\r\n    </div>\r\n\r\n</div>\r\n\r\n\r\n<div *ngIf=\"garage\">\r\n\r\n    <div class=\"row\">\r\n        <mat-card *ngFor=\"let item of states\" style=\"font-size:smaller; height: fit-content; margin: 0.5%;\">\r\n            <div class=\"col-12\">\r\n                {{item.name}}\r\n            </div>\r\n            <div class=\"col-3 \">\r\n                <div class=\"point-color\" [ngStyle]=\"getStyleState(item)\"> </div>\r\n            </div>\r\n        </mat-card>\r\n\r\n    </div>\r\n\r\n    <div class=\"row item-col\" style=\"height: 90%;display: block;\">\r\n\r\n        <div style=\"width: 100%; height: 100%; position: relative;\">\r\n\r\n\r\n            <div *ngIf=\"bays.length > 0\" style=\"height: 100%; width: 100%;\">\r\n\r\n                <ng-container *ngFor=\"let item of bays\">\r\n\r\n                    <div *ngIf=\"!item.color\" data-toggle=\"modal\" data-target=\"#exampleModalCenter\">\r\n                        <div *ngIf=\"item.bayState == 'LIBRE'\" class=\"point point-free\" [ngStyle]=\"giveStyle(item.style)\"\r\n                            (click)=\"getInfoBay(item)\">\r\n\r\n                        </div>\r\n                        <div *ngIf=\"item.bayState == 'ALMACENAMIENTO'\" class=\"point point-store\"\r\n                            [ngStyle]=\"giveStyle(item.style)\" (click)=\"getInfoBay(item)\">\r\n\r\n                        </div>\r\n                        <div *ngIf=\"item.bayState == 'PROCESO'\" class=\"point point-process\"\r\n                            [ngStyle]=\"giveStyle(item.style)\" (click)=\"getInfoBay(item)\">\r\n                        </div>\r\n                    </div>\r\n                    <!-- data-target=\"#exampleModalCenter\"-->\r\n                    <div *ngIf=\"item.color\" (click)=\"getInfoBay(item)\" data-toggle=\"modal\"\r\n                        data-target=\"#exampleModalCenter\">\r\n\r\n                        <div *ngIf=\"item.excludeBay == true\" style=\"text-align: center; font-weight: bolder;\">\r\n                            <div class=\"point point-store\" [ngStyle]=\"giveStyleWithColor(item.style, item.color)\"\r\n                                (click)=\"getInfoBay(item)\">\r\n                                {{item.activities.length}}\r\n                            </div>\r\n                        </div>\r\n                        <div *ngIf=\"item.excludeBay == false\">\r\n                            <div class=\"point point-store\" [ngStyle]=\"giveStyleWithColor(item.style, item.color)\"\r\n                                (click)=\"getInfoBay(item)\">\r\n\r\n                            </div>\r\n                        </div>\r\n\r\n\r\n                    </div>\r\n                </ng-container>\r\n            </div>\r\n\r\n            <img *ngIf=\"editingPositionBay== false\" [src]=\"imgURL\" height=\"90%\" width=\"100%\">\r\n\r\n            <img *ngIf=\"editingPositionBay== true\" [src]=\"imgURL\" height=\"90%\" width=\"100%\" style=\"cursor: pointer;\"\r\n                (click)=\"onClickImgBay($event)\">\r\n\r\n        </div>\r\n\r\n\r\n\r\n\r\n    </div>\r\n\r\n\r\n    <div class=\"col-sm-12 col-md-12 col-lg-12 button-group-style\">\r\n        <button mat-button class=\"button-padding\" mat-fab color=\"accent\" (click)=\"goBack()\"><i\r\n                class=\"fas fa-arrow-left icon-size\"></i></button>\r\n    </div>\r\n</div>\r\n\r\n\r\n<div class=\"modal fade\" id=\"exampleModalCenter\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalCenterTitle\"\r\n    aria-hidden=\"true\">\r\n    <div class=\"modal-dialog modal-dialog-centered modal-lg\" role=\"document\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\">\r\n                <h5 class=\"modal-title\" id=\"exampleModalLongTitle\">Bahía: {{infoBay.bayNumber}}</h5>\r\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n                </button>\r\n            </div>\r\n            <div class=\"modal-body\">\r\n                <div *ngIf=\"infoBay.excludeBay == true\">\r\n                    <div style=\"text-align: center; margin-bottom: 3%;\">\r\n                        <span class=\"label label-default\">Estado:</span>\r\n                        <h4 *ngIf=\"infoBay.stateString\">{{infoBay.stateString}}</h4>\r\n                        <h4 *ngIf=\"!infoBay.stateString\">LIBRE</h4>\r\n                    </div>\r\n\r\n\r\n                    <div *ngFor=\"let item of infoBay.activities\">\r\n                        <mat-accordion>\r\n\r\n                            <mat-expansion-panel (opened)=\"item.panelOpenState = true\"\r\n                                (closed)=\"item.panelOpenState = false\">\r\n                                <mat-expansion-panel-header (click)=\"showAdditionalInfo(item)\">\r\n                                    <mat-panel-title>\r\n                                        <span class=\"label label-default\" style=\"margin-right: 3%;\">OT:</span>\r\n                                        <p *ngIf=\"item.workOrder\">{{item.workOrder}}</p>\r\n                                    </mat-panel-title>\r\n\r\n                                </mat-expansion-panel-header>\r\n                                <div *ngIf=\"item.workOrder && workOrderAditionalInfo \">\r\n                                    <div class=\"col-12\">\r\n                                        <div class=\"row element-margin\">\r\n                                            <div class=\"col-4 \">\r\n                                                <span\r\n                                                    class=\"field\">Taller:</span><span>{{workOrderAditionalInfo.zona}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4 \">\r\n                                                <span\r\n                                                    class=\"field\">Bodega:</span><span>{{workOrderAditionalInfo.store}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4 \">\r\n                                                <span class=\"field\">OT:</span><span>{{workOrderAditionalInfo.ot}}</span>\r\n                                            </div>\r\n\r\n                                        </div>\r\n\r\n\r\n                                        <div class=\"row element-margin\">\r\n                                            <div class=\"col-4  \">\r\n                                                <span\r\n                                                    class=\"field\">Modelo:</span><span>{{workOrderAditionalInfo.model}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span\r\n                                                    class=\"field\">Serial:</span><span>{{workOrderAditionalInfo.serial}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span\r\n                                                    class=\"field\">Cliente:</span><span>{{workOrderAditionalInfo.customer}}</span>\r\n                                            </div>\r\n\r\n                                        </div>\r\n                                        <div class=\"row element-margin\">\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">Tipo cliente:</span>\r\n                                                <span *ngIf=\"workOrderAditionalInfo.custType == 'X'\">EXTERNO</span>\r\n                                                <span *ngIf=\"workOrderAditionalInfo.custType != 'X'\">INTERNO</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span\r\n                                                    class=\"field\">Código:</span><span>{{workOrderAditionalInfo.codigo}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">Partes Wip:\r\n                                                </span><span>{{workOrderAditionalInfo.wipParts}}</span>\r\n                                            </div>\r\n\r\n                                        </div>\r\n\r\n\r\n                                        <div class=\"row element-margin\">\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">Wip Misc:</span>\r\n                                                <span>{{workOrderAditionalInfo.wipMisc}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">Labor\r\n                                                    Wip:</span><span>{{workOrderAditionalInfo.wipLabor}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\"> Wip:\r\n                                                </span><span>{{workOrderAditionalInfo.wip}}</span>\r\n                                            </div>\r\n\r\n                                        </div>\r\n\r\n                                        <div class=\"row element-margin\">\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">Fecha Abierto:</span>\r\n                                                <span>{{workOrderAditionalInfo.openDate}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">Fecha\r\n                                                    prom:</span><span>{{workOrderAditionalInfo.promDate}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\"> Días abierto:\r\n                                                </span><span>{{workOrderAditionalInfo.openDays}}</span>\r\n                                            </div>\r\n\r\n                                        </div>\r\n\r\n                                        <div class=\"row element-margin\">\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">Control de tarea :</span>\r\n                                                <span>{{workOrderAditionalInfo.jobCtrl}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span\r\n                                                    class=\"field\">Propietario:</span><span>{{workOrderAditionalInfo.owner}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\"> Fecha cierre:\r\n                                                </span><span>{{workOrderAditionalInfo.dateFinsh}}</span>\r\n                                            </div>\r\n\r\n                                        </div>\r\n\r\n                                        <div class=\"row\">\r\n                                            <div class=\"col-10\">\r\n                                                <span>{{workOrderAditionalInfo.observs}}</span>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                                <div *ngIf=\"!item.workOrder \">\r\n                                    <span class=\"label label-default\" style=\"margin-right: 3%;\">F. Creación:</span>\r\n                                    <p>\r\n                                        {{item.createdAt}}\r\n                                    </p>\r\n                                </div>\r\n                                <div *ngIf=\"item.workOrder && !workOrderAditionalInfo \">\r\n                                    \r\n                                    <span class=\"label label-default\" style=\"margin-right: 3%;\">F. Creación:</span>\r\n                                    <p>\r\n                                        {{item.createdAt}}\r\n                                    </p>\r\n                                </div>\r\n                                <div class=\"row\">\r\n                                    <div  class=\"col-6\" *ngIf=\"isforTerminate() == true\" style=\"text-align: center;\">\r\n                                        <button mat-button (click)=\"terminateActivity(item)\" color=\"accent\"\r\n                                            style=\"color:black; background: #fbbc04;\">Finalizar</button>\r\n                                    </div>\r\n                    \r\n                                    <div class=\"col-6\" style=\"text-align: center;\">\r\n                                        <button mat-button (click)=\"reassign(item)\" color=\"accent\"\r\n                                            style=\"color:black; background: #fbbc04;\">Reasignar</button>\r\n                                    </div>\r\n                                </div>\r\n\r\n\r\n                            </mat-expansion-panel>\r\n                        </mat-accordion>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"infoBay.excludeBay == false\">\r\n\r\n\r\n                    <div class=\"row element-margin\">\r\n                        <div class=\"col-4\">\r\n                            <span class=\"field  label-default\">Estado de bahía :</span>\r\n                            <span *ngIf=\"infoBay.stateString\">{{infoBay.stateString}}</span>\r\n                            <span *ngIf=\"!infoBay.stateString\">Libre</span>\r\n                        </div>\r\n\r\n\r\n                    </div>\r\n\r\n                    <div *ngIf=\"infoBay.activities && infoBay.activities[0]\">\r\n                        <span class=\"field\" *ngIf=\"infoBay.activities \"> Actividad:\r\n                        </span>\r\n                        <div class=\"row element-margin\">\r\n                            <div class=\"col-4\">\r\n                                <span class=\"field  label-default\">OT :</span>\r\n                                <span>{{infoBay.activities[0].workOrder}}</span>\r\n                            </div>\r\n                            <div class=\"col-4\">\r\n                                <span\r\n                                    class=\"field  label-default\">Fecha:</span><span>{{infoBay.activities[0].createdAt}}</span>\r\n                            </div>\r\n                            <div class=\"col-4\">\r\n                                <span  class=\"field  label-default\">\r\n                                    <span>{{infoBay.activities[0].description}}</span>  \r\n                                </span>\r\n                            </div>\r\n\r\n\r\n                        </div>\r\n\r\n                    </div>\r\n\r\n                </div>\r\n\r\n                <div *ngIf=\"reassignActivity\" style=\"margin-top: 5%;\">\r\n                    <span class=\"label \">Elija una bahia a la cual desea reasignar la actividad </span>\r\n\r\n                    <div class=\"col-12 item-margin\">\r\n                        <mat-form-field>\r\n                            <mat-label>Bahía </mat-label>\r\n                            <select matNativeControl name=\"bay\" [(ngModel)]=\"baySelected\">\r\n                                <option *ngFor=\"let item of bays\" [ngValue]=\"item\">\r\n                                    {{item.bayNumber}}/{{getSate(item)}}</option>\r\n                            </select>\r\n                        </mat-form-field>\r\n                    </div>\r\n\r\n                    <div>\r\n                        <button mat-button (click)=\"reassignBay()\" color=\"accent\"\r\n                            style=\"color:black; background: #fbbc04;\">Reasignar</button>\r\n                    </div>\r\n\r\n                </div>\r\n            </div>\r\n            <div class=\"modal-footer\">\r\n                <div *ngIf=\"isforTerminate() == true\">\r\n                    <button mat-button (click)=\"terminateActivity()\" color=\"accent\"\r\n                        style=\"color:black; background: #fbbc04;\">Finalizar</button>\r\n                </div>\r\n\r\n                <div *ngIf=\"infoBay && infoBay.activities && infoBay.activities.length == 1\">\r\n                    <button mat-button (click)=\"reassign(infoBay.activities[0])\" color=\"accent\"\r\n                        style=\"color:black; background: #fbbc04;\">Reasignar</button>\r\n                </div>\r\n\r\n                <div>\r\n                    <button id=\"btnEdit\" (click)=\"changeEditing()\" type=\"button\"\r\n                        class=\"btn btn-secondary\">Editar</button>\r\n                </div>\r\n\r\n\r\n                <button id=\"btnCloseModal\" #btnCloseModal type=\"button\" class=\"btn btn-secondary\"\r\n                    data-dismiss=\"modal\">Cerrar</button>\r\n            </div>\r\n\r\n        </div>\r\n    </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/number-indicators/number-indicators.component.html":
/*!*********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/number-indicators/number-indicators.component.html ***!
  \*********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"col-sm-12 col-md-12 col-lg-12\">\r\n\r\n    <div class=\"row\">\r\n\r\n        <div class=\"col-12 item-margin\">\r\n            <mat-form-field>\r\n                <mat-label>Taller</mat-label>\r\n                <select matNativeControl required name=\"garage\" [(ngModel)]=\"garageSelected\"\r\n                    (change)=\"listIndicatorsByGarageAll()\">\r\n                    <option *ngFor=\"let item of garages\" [ngValue]=\"item\">\r\n                        {{item.name}}/{{item.city}}</option>\r\n                </select>\r\n            </mat-form-field>\r\n        </div>\r\n\r\n    </div>\r\n\r\n\r\n    <div class=\"row shadow-element\" style=\"text-align: center; display: block;\">\r\n\r\n        <mat-card>\r\n\r\n            <div *ngIf=\"indicators\" style=\"display: flex;\">\r\n\r\n                <div *ngFor=\"let item of indicators\">\r\n                    <div class=\"col-sm-12 col-md-12 col-lg-12\" style=\"margin: 2%;\">\r\n                        <mat-card>\r\n                            <mat-card-content>\r\n                                <div class=\"row\">\r\n                                    <span class=\"label label-default\">{{item.response[0].name}}</span>\r\n                                </div>\r\n                                <div class=\"row\" style=\"text-align: center; display: inline-block;\">\r\n                                    <h3>{{item.response[0].resultString}}{{item.type}}</h3>\r\n                                </div>\r\n                            </mat-card-content>\r\n                            <mat-card-actions>\r\n                                <button mat-button (click)=\"showInfoOnDialog(item)\"><i\r\n                                        class=\"fas fa-info-circle icon-size\"></i></button>\r\n                                <button mat-button (click)=\"showTendencyDialog(item)\"><i\r\n                                        class=\"fas fa-chart-line icon-size\"></i></button>\r\n                            </mat-card-actions>\r\n                        </mat-card>\r\n\r\n\r\n\r\n                    </div>\r\n\r\n                </div>\r\n\r\n            </div>\r\n\r\n            <div *ngIf=\"!indicators\">\r\n                <span class=\"label label-default\">Debe seleccionar un taller</span>\r\n            </div>\r\n\r\n\r\n\r\n        </mat-card>\r\n\r\n    </div>\r\n\r\n\r\n\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/piece/piece.component.html":
/*!*********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/piece/piece.component.html ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\r\n\r\n    <div class=\"col-sm-4 col-md-4 col-lg-4\">\r\n\r\n        <div class=\"shadow-element\">\r\n            <mat-card>\r\n\r\n                <div class=\"card rounded-0\">\r\n                    <div class=\"card-header\">\r\n                        <h3 class=\"mb-0\">COMPONENTE</h3>\r\n                    </div>\r\n                    <div class=\"card-body\">\r\n                        <form>\r\n                            <div class=\"col-12 item-margin\">\r\n                                <mat-form-field class=\"example-full-width\">\r\n                                    <input matInput #message maxlength=\"50\" name=\"code\" placeholder=\"Codigo *\"\r\n                                        [(ngModel)]=\"component.code\">\r\n                                    <mat-hint align=\"start\"><strong>Código de componente </strong> </mat-hint>\r\n\r\n                                </mat-form-field>\r\n                            </div>\r\n\r\n                            <div class=\"col-12 item-margin\">\r\n                                <mat-form-field class=\"example-full-width\">\r\n                                    <input matInput #message maxlength=\"50\" name=\"name\" placeholder=\"Nombre *\"\r\n                                        [(ngModel)]=\"component.name\">\r\n                                    <mat-hint align=\"start\"><strong>Nombre de componente </strong> </mat-hint>\r\n\r\n                                </mat-form-field>\r\n                            </div>\r\n\r\n\r\n                        </form>\r\n                    </div>\r\n                    <div class=\"card-footer\">\r\n                        <div class=\"btn-group float-left\" role=\"group\">\r\n                            <button class=\"btn btn-secondary \" id=\"btnClean\" (click)=\"clear()\"><i\r\n                                    class=\"fas fa-file\"></i>\r\n                            </button>\r\n\r\n                            <button type=\"submit\" class=\"btn btn-secondary\" id=\"btnSave\" (click)=\"save()\"><i\r\n                                    class=\"fas fa-save\"></i> </button>\r\n\r\n                            <button class=\"btn btn-primary\" id=\"btnDelete\" (click)=\"delete()\"><i\r\n                                    class=\"fas fa-trash\"></i>\r\n                            </button>\r\n\r\n\r\n                        </div>\r\n                    </div>\r\n                    <!--/card-block-->\r\n                </div>\r\n\r\n            </mat-card>\r\n        </div>\r\n\r\n\r\n    </div>\r\n\r\n    <div class=\"col-sm-8 col-md-8 col-lg-8 \">\r\n        <div class=\"shadow-element\">\r\n            <mat-card>\r\n                <div class=\"card rounded-0\">\r\n                    <div class=\"card-header\">\r\n                        <h3 class=\"mb-0\">COMPONENTES\r\n\r\n                        </h3>\r\n                    </div>\r\n                    <div class=\"card-body\" style=\"height: 400px; overflow-y: auto;\">\r\n                        <table mat-table [dataSource]=\"components\" class=\"mat-elevation-z8\">\r\n\r\n                            <!--- Note that these columns can be defined in any order.\r\n                                          The actual rendered columns are set as a property on the row definition\" -->\r\n\r\n                            <!-- Position Column -->\r\n                            <ng-container matColumnDef=\"id\">\r\n                                <th mat-header-cell *matHeaderCellDef> Id. </th>\r\n                                <td mat-cell *matCellDef=\"let element\"> {{element.id}} </td>\r\n                            </ng-container>\r\n\r\n                            <!-- Name Column -->\r\n                            <ng-container matColumnDef=\"code\">\r\n                                <th mat-header-cell *matHeaderCellDef> Código </th>\r\n                                <td mat-cell *matCellDef=\"let element\"> {{element.code}} </td>\r\n                            </ng-container>\r\n\r\n                            <!-- Weight Column -->\r\n                            <ng-container matColumnDef=\"name\">\r\n                                <th mat-header-cell *matHeaderCellDef> Nombre </th>\r\n                                <td mat-cell *matCellDef=\"let element\"> {{element.name}} </td>\r\n                            </ng-container>\r\n\r\n                            <ng-container matColumnDef=\"edit\">\r\n                                    <th mat-header-cell *matHeaderCellDef> Accion </th>\r\n                                    <td mat-cell *matCellDef=\"let element\">\r\n                                        <button class=\"btn btn-primary\" id=\"btnDelete\" (click)=\"edit(element)\"><i class=\"fas fa-edit\"></i>\r\n                                        </button>\r\n    \r\n                                        \r\n                                    </td>\r\n                            </ng-container>\r\n\r\n\r\n                            <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n                            <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n                        </table>\r\n\r\n                    </div>\r\n\r\n                </div>\r\n\r\n            </mat-card>\r\n        </div>\r\n\r\n\r\n\r\n    </div>\r\n\r\n\r\n\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/state/state.component.html":
/*!*********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/state/state.component.html ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\r\n\r\n    <div class=\"col-sm-4 col-md-4 col-lg-4\">\r\n\r\n        <div class=\"shadow-element\">\r\n            <mat-card>\r\n\r\n                <div class=\"card rounded-0\">\r\n                    <div class=\"card-header\">\r\n                        <h3 class=\"mb-0\">ESTADO</h3>\r\n                    </div>\r\n                    <div class=\"card-body\">\r\n                        <form>\r\n                            <div class=\"col-12 item-margin\">\r\n                                <mat-form-field class=\"example-full-width\">\r\n                                    <input matInput #message maxlength=\"50\" name=\"code\" placeholder=\"Codigo *\"\r\n                                        [(ngModel)]=\"state.code\">\r\n                                    <mat-hint align=\"start\"><strong>Código de estado </strong> </mat-hint>\r\n\r\n                                </mat-form-field>\r\n                            </div>\r\n\r\n                            <div class=\"col-12 item-margin\">\r\n                                <mat-form-field class=\"example-full-width\">\r\n                                    <input matInput #message maxlength=\"50\" name=\"name\" placeholder=\"Nombre *\"\r\n                                        [(ngModel)]=\"state.name\">\r\n                                    <mat-hint align=\"start\"><strong>Nombre de de estado </strong> </mat-hint>\r\n\r\n                                </mat-form-field>\r\n                            </div>\r\n\r\n                            <div class=\"col-12 item-margin\">\r\n                                <input class=\"picker\" name=\"color\" [(colorPicker)]=\"state.color\" [style.background]=\"color\" placeholder=\"Elija un color\" [(ngModel)]=\"state.color\"/>\r\n                            </div>\r\n\r\n\r\n                        </form>\r\n                    </div>\r\n                    <div class=\"card-footer\">\r\n                        <div class=\"btn-group float-left\" role=\"group\">\r\n                            <button class=\"btn btn-secondary \" id=\"btnClean\" (click)=\"clear()\"><i\r\n                                    class=\"fas fa-file\"></i>\r\n                            </button>\r\n\r\n                            <button type=\"submit\" class=\"btn btn-secondary\" id=\"btnSave\" (click)=\"save()\"><i\r\n                                    class=\"fas fa-save\"></i> </button>\r\n\r\n                            <button class=\"btn btn-primary\" id=\"btnDelete\" (click)=\"delete()\"><i\r\n                                    class=\"fas fa-trash\"></i>\r\n                            </button>\r\n\r\n\r\n                        </div>\r\n                    </div>\r\n                    <!--/card-block-->\r\n                </div>\r\n\r\n            </mat-card>\r\n        </div>\r\n\r\n\r\n    </div>\r\n\r\n    <div class=\"col-sm-8 col-md-8 col-lg-8 \">\r\n        <div class=\"shadow-element\">\r\n            <mat-card>\r\n                <div class=\"card rounded-0\">\r\n                    <div class=\"card-header\">\r\n                        <h3 class=\"mb-0\">ESTADOS\r\n\r\n                        </h3>\r\n                    </div>\r\n                    <div class=\"card-body\" style=\"height: 400px; overflow-y: auto;\">\r\n                        <table mat-table [dataSource]=\"dataSource\" class=\"mat-elevation-z8\">\r\n\r\n                            <!--- Note that these columns can be defined in any order.\r\n                                              The actual rendered columns are set as a property on the row definition\" -->\r\n\r\n                          \r\n\r\n                            <!-- Name Column -->\r\n                            <ng-container matColumnDef=\"code\">\r\n                                <th mat-header-cell *matHeaderCellDef> Código </th>\r\n                                <td mat-cell *matCellDef=\"let element\"> {{element.code}} </td>\r\n                            </ng-container>\r\n\r\n                            <!-- Weight Column -->\r\n                            <ng-container matColumnDef=\"name\">\r\n                                <th mat-header-cell *matHeaderCellDef> Nombre </th>\r\n                                <td mat-cell *matCellDef=\"let element\"> {{element.name}} </td>\r\n                            </ng-container>\r\n\r\n                            <ng-container matColumnDef=\"color\">\r\n                                <th mat-header-cell *matHeaderCellDef> Color </th>\r\n                                <td mat-cell *matCellDef=\"let element\"> {{element.color}} </td>\r\n                            </ng-container>\r\n\r\n                            <ng-container matColumnDef=\"edit\">\r\n                                <th mat-header-cell *matHeaderCellDef> Accion </th>\r\n                                <td mat-cell *matCellDef=\"let element\">\r\n                                    <button class=\"btn btn-primary\" id=\"btnDelete\" (click)=\"edit(element)\"><i\r\n                                            class=\"fas fa-edit\"></i>\r\n                                    </button>\r\n\r\n\r\n                                </td>\r\n                            </ng-container>\r\n\r\n\r\n\r\n                            <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n                            <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n                        </table>\r\n\r\n                    </div>\r\n\r\n                </div>\r\n\r\n            </mat-card>\r\n        </div>\r\n\r\n\r\n\r\n    </div>\r\n\r\n\r\n\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/traffic-light/traffic-light.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/traffic-light/traffic-light.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"col-sm-12 col-md-12 col-lg-12 \">\r\n    <div class=\"shadow-element\">\r\n        <mat-card>\r\n            <div class=\"card rounded-0\">\r\n                <div class=\"card-header\">\r\n                    <div class=\"row\">\r\n                        <div class=\"col-8\">\r\n                            <h3 class=\"mb-0\">ORDENES DE TRABAJO\r\n\r\n                            </h3>\r\n                        </div>\r\n\r\n                        <div class=\"col-4\">\r\n\r\n                            <div class=\"btn-group\" role=\"group\" style=\"float: right;\">\r\n\r\n\r\n                                <button class=\"btn btn-primary\" id=\"filter\" data-target=\"#FiltersWithArrays\"\r\n                                    data-toggle=\"modal\">\r\n                                    <i class=\"fas fa-edit\"></i>\r\n                                    Filtrar\r\n                                </button>\r\n\r\n\r\n                            </div>\r\n\r\n                        </div>\r\n\r\n                    </div>\r\n\r\n\r\n\r\n\r\n                </div>\r\n                <div class=\"card-body\" style=\"height: 400px; overflow-y: auto;\">\r\n\r\n                    <table mat-table [dataSource]=\"dataSource\" multiTemplateDataRows class=\"mat-elevation-z8\">\r\n                        <ng-container matColumnDef=\"{{column}}\" *ngFor=\"let column of columnsToDisplay\">\r\n                            <th mat-header-cell *matHeaderCellDef> {{column}} </th>\r\n                            <td mat-cell *matCellDef=\"let element\"> {{getValue( column,element)}} </td>\r\n\r\n                        </ng-container>\r\n\r\n                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->\r\n                        <ng-container matColumnDef=\"expandedDetail\">\r\n                            <td mat-cell *matCellDef=\"let element\" [attr.colspan]=\"columnsToDisplay.length\">\r\n                                <div class=\"example-element-detail\"\r\n                                    [@detailExpand]=\"element == expandedElement ? 'expanded' : 'collapsed'\">\r\n                                    <div class=\"col-12\">\r\n                                        <div class=\"row element-margin\">\r\n                                            <div class=\"col-4 \">\r\n                                                <span class=\"field\">ZONE:</span><span>{{element.zona}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4 \">\r\n                                                <span class=\"field\">STORE:</span><span>{{element.store}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4 \">\r\n                                                <span class=\"field\">OT:</span><span>{{element.ot}}</span>\r\n                                            </div>\r\n\r\n                                        </div>\r\n\r\n\r\n                                        <div class=\"row element-margin\">\r\n                                            <div class=\"col-4  \">\r\n                                                <span class=\"field\">MODEL:</span><span>{{element.model}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">SERIAL:</span><span>{{element.serial}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">CUSTOMER:</span><span>{{element.customer}}</span>\r\n                                            </div>\r\n\r\n                                        </div>\r\n                                        <div class=\"row element-margin\">\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">CUST_TYPE:</span>\r\n                                                <span *ngIf=\"element.custType == 'X'\">EXTERNO</span>\r\n                                                <span *ngIf=\"element.custType == 'C' ||\r\n                                                element.custType == 'A' || element.custType == 'B' ||\r\n                                                element.custType == 'E' ||  element.custType == 'G' ||\r\n                                                element.custType == 'S' || element.custType == 'U' \">INTERNO</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">CODIGO:</span><span>{{element.codigo}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">WIP_PARTS</span><span>{{element.wipParts}}</span>\r\n                                            </div>\r\n\r\n                                        </div>\r\n\r\n\r\n                                        <div class=\"row element-margin\">\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">WIP_MISC:</span>\r\n                                                <span>{{element.wipMisc}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">WIP_LABOR:</span><span>{{element.wipLabor}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\"> WIP </span><span>{{element.wip}}</span>\r\n                                            </div>\r\n\r\n                                        </div>\r\n\r\n                                        <div class=\"row element-margin\">\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">OPEN_DATE:</span>\r\n                                                <span>{{element.openDate}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">PROM_DATE:</span><span>{{element.promDate}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\"> OPEN_DAYS\r\n                                                </span><span>{{element.openDays}}</span>\r\n                                            </div>\r\n\r\n                                        </div>\r\n\r\n                                        <div class=\"row element-margin\">\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">JOBCTRL:</span>\r\n                                                <span>{{element.jobCtrl}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">OWNER:</span><span>{{element.owner}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-4\">\r\n                                                <span class=\"field\">DATE_FINSH\r\n                                                </span><span>{{element.dateFinsh}}</span>\r\n                                            </div>\r\n\r\n                                        </div>\r\n\r\n                                        <div class=\"row\">\r\n                                            <div class=\"col-10\">\r\n                                                <span>{{element.observs}}</span>\r\n                                            </div>\r\n                                            <div class=\"btn-group float-left\" role=\"group\">\r\n\r\n\r\n\r\n                                                <button class=\"btn btn-primary\" id=\"btnAssignBay\" data-toggle=\"modal\"\r\n                                                    data-target=\"#asignBayModal\" data-backdrop=\"static\"\r\n                                                    data-keyboard=\"false\" (click)=\"selectWorkOrder(element)\">\r\n                                                    <i class=\"fas fa-boxes\"></i>\r\n                                                </button>\r\n\r\n\r\n                                            </div>\r\n\r\n                                        </div>\r\n                                    </div>\r\n\r\n\r\n\r\n\r\n\r\n                                </div>\r\n                            </td>\r\n                        </ng-container>\r\n\r\n                        <tr mat-header-row *matHeaderRowDef=\"columnsToDisplay\"></tr>\r\n                        <tr mat-row *matRowDef=\"let element; columns: columnsToDisplay;\" class=\"example-element-row\"\r\n                            [class.example-expanded-row]=\"expandedElement === element\"\r\n                            (click)=\"expandedElement = expandedElement === element ? null : element\">\r\n                        </tr>\r\n                        <tr mat-row *matRowDef=\"let row; columns: ['expandedDetail']\" class=\"example-detail-row\">\r\n                        </tr>\r\n                    </table>\r\n                </div>\r\n\r\n            </div>\r\n\r\n        </mat-card>\r\n    </div>\r\n\r\n\r\n\r\n</div>\r\n\r\n\r\n<div>\r\n    <app-filter [tittles]=\"tittlesFilter\" [itemFilter]=\"onFilter\" [attributes]=\"attributesFilter\"\r\n        [typeAttribute]=\"typeFilters\" (filter)=\"filter($event)\">\r\n\r\n    </app-filter>\r\n</div>\r\n\r\n\r\n\r\n<div class=\"modal fade\" id=\"asignBayModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"asignBayModalTitle\"\r\n    aria-hidden=\"true\">\r\n    <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\">\r\n                <h5 class=\"modal-title\" id=\"exampleModalLongTitle\">Asignar OT a Bahía</h5>\r\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" #btnCloseModal\r\n                    id=\"btnCloseModal\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n                </button>\r\n            </div>\r\n            <div class=\"modal-body\">\r\n                <mat-card>\r\n\r\n\r\n                    <div class=\"col-12 item-margin\" style=\"margin-bottom: 15%;\">\r\n                        <mat-form-field class=\"example-full-width\">\r\n                            <input matInput #message maxlength=\"255\" name=\"description\" placeholder=\"Descripción\"\r\n                                [(ngModel)]=\"activity.description\">\r\n                            <mat-hint align=\"start\"><strong>Añada una descripción de la actividad</strong>\r\n                            </mat-hint>\r\n                            <mat-hint align=\"end\">{{message.value.length}} / 255</mat-hint>\r\n                        </mat-form-field>\r\n                    </div>\r\n\r\n                    <div class=\"col-12 item-margin\">\r\n                        <mat-form-field>\r\n                            <mat-label>Componente</mat-label>\r\n                            <select matNativeControl name=\"component\" [(ngModel)]=\"componentSelected\">\r\n                                <option *ngFor=\"let item of components\" [ngValue]=\"item\">\r\n                                    {{item.code}}/{{item.name}}</option>\r\n                            </select>\r\n                        </mat-form-field>\r\n                    </div>\r\n\r\n                    <div class=\"col-12 item-margin\">\r\n                        <mat-form-field>\r\n                            <mat-label>Estado de actividad</mat-label>\r\n                            <select matNativeControl required name=\"state\" [(ngModel)]=\"stateSelected\">\r\n                                <option *ngFor=\"let item of states\" [ngValue]=\"item\">\r\n                                    {{item.code}}/{{item.name}}</option>\r\n                            </select>\r\n                        </mat-form-field>\r\n                    </div>\r\n                    \r\n\r\n                    <div class=\"col-12 item-margin\">\r\n                        <mat-form-field>\r\n                            <mat-label>Bahía</mat-label>\r\n                            <select matNativeControl required name=\"bay\" [(ngModel)]=\"baySelected\">\r\n                                <option *ngFor=\"let item of bays\" [ngValue]=\"item\">\r\n                                    {{item.bayNumber}}/{{getSate(item)}}</option>\r\n                            </select>\r\n                        </mat-form-field>\r\n                    </div>\r\n\r\n                </mat-card>\r\n            </div>\r\n            <div class=\"modal-footer\">\r\n                <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\">Cerrar</button>\r\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"assignOTtoWorkOrder()\">Asignar</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/graphproof/graphproof.component.html":
/*!********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/graphproof/graphproof.component.html ***!
  \********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>graphproof works!</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/material/material-file-upload/material-file-upload.component.html":
/*!*************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/material/material-file-upload/material-file-upload.component.html ***!
  \*************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<button mat-button  (click)=\"onClick()\">\r\n        <mat-icon>file_upload</mat-icon>\r\n        {{text}}\r\n  </button>\r\n  <br/>\r\n  <ul>\r\n       \r\n  </ul>\r\n  <input type=\"file\" id=\"fileUpload\" name=\"fileUpload\" multiple=\"multiple\"  \r\n  \r\n   accept=\"{{accept}}\" style=\"display:none;\"/>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/material/material-img-upload/material-img-upload.component.html":
/*!***********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/material/material-img-upload/material-img-upload.component.html ***!
  \***********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<button mat-button  (click)=\"onClick()\">\r\n        <mat-icon>file_upload</mat-icon>\r\n        {{text}}\r\n  </button>\r\n  <br/>\r\n  <ul>\r\n       \r\n  </ul>\r\n  <input type=\"file\" id=\"fileUpload\" name=\"fileUpload\" multiple=\"multiple\"  \r\n  \r\n   accept=\"{{accept}}\" style=\"display:none;\"/>");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: routes, AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routes", function() { return routes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _core_bar_graphic_bar_graphic_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./core/bar-graphic/bar-graphic.component */ "./src/app/core/bar-graphic/bar-graphic.component.ts");
/* harmony import */ var _core_force_change_password_force_change_password_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./core/force-change-password/force-change-password.component */ "./src/app/core/force-change-password/force-change-password.component.ts");
/* harmony import */ var _core_home_home_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./core/home/home.component */ "./src/app/core/home/home.component.ts");
/* harmony import */ var _core_auth_guard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./core/auth.guard */ "./src/app/core/auth.guard.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _dash_board_bay_bay_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./dash-board/bay/bay.component */ "./src/app/dash-board/bay/bay.component.ts");
/* harmony import */ var _dash_board_activity_activity_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./dash-board/activity/activity.component */ "./src/app/dash-board/activity/activity.component.ts");
/* harmony import */ var _dash_board_layout_layout_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./dash-board/layout/layout.component */ "./src/app/dash-board/layout/layout.component.ts");
/* harmony import */ var _dash_board_piece_piece_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./dash-board/piece/piece.component */ "./src/app/dash-board/piece/piece.component.ts");
/* harmony import */ var _dash_board_state_state_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./dash-board/state/state.component */ "./src/app/dash-board/state/state.component.ts");
/* harmony import */ var _core_login_login_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./core/login/login.component */ "./src/app/core/login/login.component.ts");
/* harmony import */ var _dash_board_traffic_light_traffic_light_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./dash-board/traffic-light/traffic-light.component */ "./src/app/dash-board/traffic-light/traffic-light.component.ts");
/* harmony import */ var _core_not_found_not_found_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./core/not-found/not-found.component */ "./src/app/core/not-found/not-found.component.ts");
/* harmony import */ var _dash_board_indicador_speed_indicador_speed_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./dash-board/indicador-speed/indicador-speed.component */ "./src/app/dash-board/indicador-speed/indicador-speed.component.ts");
/* harmony import */ var _dash_board_number_indicators_number_indicators_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./dash-board/number-indicators/number-indicators.component */ "./src/app/dash-board/number-indicators/number-indicators.component.ts");
/* harmony import */ var _core_user_user_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./core/user/user.component */ "./src/app/core/user/user.component.ts");


















const routes = [
    {
        path: 'home',
        component: _core_home_home_component__WEBPACK_IMPORTED_MODULE_3__["HomeComponent"],
        canActivate: [_core_auth_guard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]]
    },
    {
        path: 'login',
        component: _core_login_login_component__WEBPACK_IMPORTED_MODULE_12__["LoginComponent"]
    },
    {
        path: 'bay',
        component: _dash_board_bay_bay_component__WEBPACK_IMPORTED_MODULE_7__["BayComponent"],
        canActivate: [_core_auth_guard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]]
    },
    {
        path: 'activity',
        component: _dash_board_activity_activity_component__WEBPACK_IMPORTED_MODULE_8__["ActivityComponent"],
        canActivate: [_core_auth_guard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]]
    },
    {
        path: 'layout',
        component: _dash_board_layout_layout_component__WEBPACK_IMPORTED_MODULE_9__["LayoutComponent"],
        canActivate: [_core_auth_guard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]]
    },
    {
        path: 'component',
        component: _dash_board_piece_piece_component__WEBPACK_IMPORTED_MODULE_10__["PieceComponent"],
        canActivate: [_core_auth_guard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]]
    },
    {
        path: 'state',
        component: _dash_board_state_state_component__WEBPACK_IMPORTED_MODULE_11__["StateComponent"],
        canActivate: [_core_auth_guard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]]
    },
    {
        path: 'traffic/light',
        component: _dash_board_traffic_light_traffic_light_component__WEBPACK_IMPORTED_MODULE_13__["TrafficLightComponent"],
        canActivate: [_core_auth_guard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]]
    },
    {
        path: 'graphics',
        component: _dash_board_indicador_speed_indicador_speed_component__WEBPACK_IMPORTED_MODULE_15__["IndicadorSpeedComponent"],
        canActivate: [_core_auth_guard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]]
    },
    {
        path: 'indicators',
        component: _dash_board_number_indicators_number_indicators_component__WEBPACK_IMPORTED_MODULE_16__["NumberIndicatorsComponent"],
        canActivate: [_core_auth_guard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]]
    },
    {
        path: 'users',
        component: _core_user_user_component__WEBPACK_IMPORTED_MODULE_17__["UserComponent"],
        canActivate: [_core_auth_guard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]]
    },
    {
        path: 'not-found',
        component: _core_not_found_not_found_component__WEBPACK_IMPORTED_MODULE_14__["NotFoundComponent"],
        canActivate: [_core_auth_guard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]]
    },
    {
        path: 'change/password',
        component: _core_force_change_password_force_change_password_component__WEBPACK_IMPORTED_MODULE_2__["ForceChangePasswordComponent"],
        canActivate: [_core_auth_guard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]]
    },
    {
        path: 'bar',
        component: _core_bar_graphic_bar_graphic_component__WEBPACK_IMPORTED_MODULE_1__["BarGraphicComponent"],
        canActivate: [_core_auth_guard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]]
    },
    {
        path: '**',
        redirectTo: 'not-found'
    }
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_5__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_6__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_6__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("ul li a:hover:after {\r\n    opacity: 1;\r\n    visibility: visible;\r\n    height: 100%;\r\n}\r\n\r\n\r\nul li a:after {\r\n    display: block;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n    margin: auto;\r\n    width: 100%;\r\n    height: 1px;\r\n    content: '.';\r\n    color: transparent;\r\n    background: #1d1d1c;\r\n    visibility: none;\r\n    opacity: 0;\r\n    z-index: -1;\r\n  }\r\n\r\n\r\nul li a:hover {\r\n    color: #91640F;\r\n  }\r\n\r\n\r\nul li a {\r\n    position:relative;\r\n    z-index: 1;\r\n  }\r\n\r\n\r\n@-webkit-keyframes fill {\r\n    0% {\r\n      width: 0%;\r\n      height: 1px;\r\n    }\r\n    50% {\r\n      width: 100%;\r\n      height: 1px;\r\n    }\r\n    100% {\r\n      width: 100%;\r\n      height: 100%;\r\n      background: #333;\r\n    }\r\n  }\r\n\r\n\r\n@-webkit-keyframes circle {\r\n    0% {\r\n      width: 1px;\r\n      top: 0;\r\n      left: 0;\r\n      bottom: 0;\r\n      right: 0;\r\n      margin: auto;\r\n      height: 1px;\r\n      z-index: -1;\r\n      background: #eee;\r\n      border-radius: 100%;\r\n    }\r\n    100% {\r\n      background: #aaa;\r\n      height: 5000%;\r\n      width: 5000%;\r\n      z-index: -1;\r\n      top: 0;\r\n      bottom: 0;\r\n      left: 0;\r\n      right: 0;\r\n      margin: auto;\r\n      border-radius: 0;\r\n    }\r\n  }\r\n\r\n\r\nnav ul li a,\r\nnav ul li a:after,\r\nnav ul li a:before {\r\n  transition: all .5s;\r\n}\r\n\r\n\r\nnav ul li a:hover {\r\n  color: white;\r\n}\r\n\r\n\r\n.icon-size{\r\n    font-size: 150%;\r\n}\r\n  \r\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _core_model_user__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./core/model/user */ "./src/app/core/model/user.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _core_service_work_order_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./core/service/work-order.service */ "./src/app/core/service/work-order.service.ts");
/* harmony import */ var _core_service_message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./core/service/message.service */ "./src/app/core/service/message.service.ts");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _core_loading_loading_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./core/loading/loading.component */ "./src/app/core/loading/loading.component.ts");
/* harmony import */ var _core_service_auth_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./core/service/auth.service */ "./src/app/core/service/auth.service.ts");








let AppComponent = class AppComponent {
    constructor(workOrderService, messageHanlder, dialog, auth) {
        this.workOrderService = workOrderService;
        this.messageHanlder = messageHanlder;
        this.dialog = dialog;
        this.auth = auth;
    }
    ngOnInit() {
        this.chargeInfo();
    }
    logout() {
        this.auth.logout();
    }
    ngAfterViewInit() {
        this.chargeInfo();
    }
    chargeInfo() {
        this.user = new _core_model_user__WEBPACK_IMPORTED_MODULE_1__["User"]();
        let mail = localStorage.getItem("mailBays");
        console.log(mail, "aqui esta este mail");
        if (mail) {
            this.auth.find(mail).subscribe(data => {
                this.user = data;
            }, error => {
                if (error.error.message && error.error.message != "No value present") {
                    this.messageHanlder.errorHandler(error);
                }
            });
            if (this.setTimeOut) {
                window.clearTimeout(this.setTimeOut);
            }
        }
        else {
            this.setTimeOut = setTimeout(() => {
                this.chargeInfo();
            }, 3000);
        }
    }
    goToSismoit() {
        window.open("https://gecolsa.com/");
    }
    onFileWithDataComplete(data) {
        console.log(data);
        this.showDialog();
        this.workOrderService.saveFile(data).subscribe(data => {
            this.messageHanlder.commonMessage("Archivo guardado correctamente", "success");
            this.closeDialog();
        }, error => {
            this.closeDialog();
            if (error.error.message) {
                this.messageHanlder.commonMessage(error.error.message, "error", "Error");
            }
            else {
                this.messageHanlder.commonMessage("El archivo se está terminando de cargar", "info");
            }
        });
    }
    canIUploadFile() {
        return this.user && this.user.email && this.user.email == 'superadmin@gecolsa.com';
    }
    showDialog() {
        this.dialogRef = this.dialog.open(_core_loading_loading_component__WEBPACK_IMPORTED_MODULE_6__["LoadingComponent"], { width: '30%', disableClose: true });
    }
    closeDialog() {
        this.dialog.closeAll();
    }
};
AppComponent.ctorParameters = () => [
    { type: _core_service_work_order_service__WEBPACK_IMPORTED_MODULE_3__["WorkOrderService"] },
    { type: _core_service_message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_5__["MatDialog"] },
    { type: _core_service_auth_service__WEBPACK_IMPORTED_MODULE_7__["AuthService"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _core_http_interceptor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./core/http-interceptor */ "./src/app/core/http-interceptor.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _dash_board_dash_board_module__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./dash-board/dash-board.module */ "./src/app/dash-board/dash-board.module.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _material_material_module__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./material/material.module */ "./src/app/material/material.module.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var angularfire2_storage__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! angularfire2/storage */ "./node_modules/angularfire2/storage/index.js");
/* harmony import */ var angularfire2_storage__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(angularfire2_storage__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _core_core_module__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./core/core.module */ "./src/app/core/core.module.ts");
/* harmony import */ var _graphproof_graphproof_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./graphproof/graphproof.component */ "./src/app/graphproof/graphproof.component.ts");














let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"],
            _graphproof_graphproof_component__WEBPACK_IMPORTED_MODULE_13__["GraphproofComponent"],
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__["BrowserModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_4__["AppRoutingModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_8__["FormsModule"],
            _dash_board_dash_board_module__WEBPACK_IMPORTED_MODULE_6__["DashBoardModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_7__["BrowserAnimationsModule"],
            _material_material_module__WEBPACK_IMPORTED_MODULE_9__["MaterialModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_10__["HttpClientModule"],
            _core_core_module__WEBPACK_IMPORTED_MODULE_12__["CoreModule"]
        ],
        providers: [{
                provide: angularfire2_storage__WEBPACK_IMPORTED_MODULE_11__["AngularFireStorage"]
            },
            {
                provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_10__["HTTP_INTERCEPTORS"],
                useClass: _core_http_interceptor__WEBPACK_IMPORTED_MODULE_1__["HttpInteceptor"],
                multi: true
            }],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/core/auth.guard.ts":
/*!************************************!*\
  !*** ./src/app/core/auth.guard.ts ***!
  \************************************/
/*! exports provided: AuthGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthGuard", function() { return AuthGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! src/app/core/service/message.service */ "./src/app/core/service/message.service.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _service_auth_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./service/auth.service */ "./src/app/core/service/auth.service.ts");





let AuthGuard = class AuthGuard {
    constructor(auth, router, messageHandler) {
        this.auth = auth;
        this.router = router;
        this.messageHandler = messageHandler;
    }
    canActivate(next, state) {
        if (!this.auth.isAuthenticatedWithout()) {
            this.router.navigate(['login']);
            return false;
        }
        return true;
        /*      return true;
      
      
          return new Promise((resolve, reject) => {
            this.auth.isAuthPromise(state.url.replace("/", "")).then(data => {
              console.log("resuelto",data)
              resolve(true);
            }).catch(error => {
              console.log(error);
              resolve(false);
            });
          })
      
          /return
         
      
         let result = this.auth.isAuthenticated(state.url.replace("/",""))
          console.log("state",state.url,result)
          if(result == false) {
       
            this.messageHandler.commonMessage("no esta autorizado para acceder a este recurso","info","Lo sentimos ")
            let token =      localStorage.getItem("token")
            if(token){
              this.router.navigate(['home'])
            }else{
              console.log("aqui cerrando")
              this.router.navigate(['login']);
            }
            
            
            return false;
            
          }else{
            console.log(result,"auth")
        
          return true;
          }*/
    }
};
AuthGuard.ctorParameters = () => [
    { type: _service_auth_service__WEBPACK_IMPORTED_MODULE_4__["AuthService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_1__["MessageService"] }
];
AuthGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    })
], AuthGuard);



/***/ }),

/***/ "./src/app/core/bar-graphic-modal/bar-graphic-modal.component.css":
/*!************************************************************************!*\
  !*** ./src/app/core/bar-graphic-modal/bar-graphic-modal.component.css ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvcmUvYmFyLWdyYXBoaWMtbW9kYWwvYmFyLWdyYXBoaWMtbW9kYWwuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/core/bar-graphic-modal/bar-graphic-modal.component.ts":
/*!***********************************************************************!*\
  !*** ./src/app/core/bar-graphic-modal/bar-graphic-modal.component.ts ***!
  \***********************************************************************/
/*! exports provided: BarGraphicModalComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BarGraphicModalComponent", function() { return BarGraphicModalComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");






let BarGraphicModalComponent = class BarGraphicModalComponent {
    constructor(dialogRef, data, decimalPipe) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.decimalPipe = decimalPipe;
        this.barChartData = [
            { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
        ];
        this.barChartLabels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
        this.barChartData = this.data.data;
        this.barChartData.forEach(elem => {
            let array = [];
            elem.data.forEach(item => {
                item = decimalPipe.transform(item, '1.2-2');
                array.push(item);
            });
            elem.data = array;
        });
        this.barChartLabels = this.data.labels;
    }
    onNoClick() {
        this.dialogRef.close();
    }
    ngOnInit() {
    }
};
BarGraphicModalComponent.ctorParameters = () => [
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_1__["DecimalPipe"] }
];
BarGraphicModalComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"])({
        selector: 'app-bar-graphic-modal',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./bar-graphic-modal.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/bar-graphic-modal/bar-graphic-modal.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./bar-graphic-modal.component.css */ "./src/app/core/bar-graphic-modal/bar-graphic-modal.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"]))
], BarGraphicModalComponent);



/***/ }),

/***/ "./src/app/core/bar-graphic/bar-graphic.component.css":
/*!************************************************************!*\
  !*** ./src/app/core/bar-graphic/bar-graphic.component.css ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvcmUvYmFyLWdyYXBoaWMvYmFyLWdyYXBoaWMuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/core/bar-graphic/bar-graphic.component.ts":
/*!***********************************************************!*\
  !*** ./src/app/core/bar-graphic/bar-graphic.component.ts ***!
  \***********************************************************/
/*! exports provided: BarGraphicComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BarGraphicComponent", function() { return BarGraphicComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var chartjs_plugin_datalabels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! chartjs-plugin-datalabels */ "./node_modules/chartjs-plugin-datalabels/dist/chartjs-plugin-datalabels.js");
/* harmony import */ var chartjs_plugin_datalabels__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(chartjs_plugin_datalabels__WEBPACK_IMPORTED_MODULE_2__);



let BarGraphicComponent = class BarGraphicComponent {
    constructor() {
        this.lengendOption = {
            align: 'center',
            position: 'top'
        };
        this.barChartOptions = {
            responsive: true,
            // We use these empty structures as placeholders for dynamic theming.
            scales: {
                xAxes: [{}], yAxes: [{
                        ticks: { maxTicksLimit: 5, padding: 5 }
                    }]
            },
            plugins: {
                datalabels: {
                    anchor: 'end',
                    align: 'end',
                },
            },
            legend: this.lengendOption,
            layout: { padding: { top: 20 } }
        };
        this.barChartLabels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
        this.barChartType = 'bar';
        this.barChartLegend = true;
        this.barChartPlugins = [chartjs_plugin_datalabels__WEBPACK_IMPORTED_MODULE_2__];
        this.barChartData = [
            { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
        ];
    }
    ngOnInit() {
        this.barChartOptions.legend = this.lengendOption;
    }
    // events
    chartClicked({ event, active }) {
    }
    chartHovered({ event, active }) {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], BarGraphicComponent.prototype, "lengendOption", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], BarGraphicComponent.prototype, "barChartLabels", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], BarGraphicComponent.prototype, "barChartData", void 0);
BarGraphicComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-bar-graphic',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./bar-graphic.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/bar-graphic/bar-graphic.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./bar-graphic.component.css */ "./src/app/core/bar-graphic/bar-graphic.component.css")).default]
    })
], BarGraphicComponent);



/***/ }),

/***/ "./src/app/core/bar-graphics-modal/bar-graphics-modal.component.css":
/*!**************************************************************************!*\
  !*** ./src/app/core/bar-graphics-modal/bar-graphics-modal.component.css ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvcmUvYmFyLWdyYXBoaWNzLW1vZGFsL2Jhci1ncmFwaGljcy1tb2RhbC5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/core/bar-graphics-modal/bar-graphics-modal.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/core/bar-graphics-modal/bar-graphics-modal.component.ts ***!
  \*************************************************************************/
/*! exports provided: BarGraphicsModalComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BarGraphicsModalComponent", function() { return BarGraphicsModalComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");




let BarGraphicsModalComponent = class BarGraphicsModalComponent {
    constructor(dialogRef, data, decimalPipe) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.decimalPipe = decimalPipe;
        this.barChartData = [
            { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
        ];
        this.barChartLabels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
        this.bars = data.data;
        this.bars.forEach(bar => {
            bar.barChartData.forEach(elem => {
                let array = [];
                elem.data.forEach(item => {
                    item = decimalPipe.transform(item, '1.2-2');
                    array.push(item);
                });
                elem.data = array;
            });
        });
        this.legendOption = data.legendOption;
    }
    onNoClick() {
        this.dialogRef.close();
    }
    ngOnInit() {
    }
};
BarGraphicsModalComponent.ctorParameters = () => [
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_1__["DecimalPipe"] }
];
BarGraphicsModalComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"])({
        selector: 'app-bar-graphics-modal',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./bar-graphics-modal.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/bar-graphics-modal/bar-graphics-modal.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./bar-graphics-modal.component.css */ "./src/app/core/bar-graphics-modal/bar-graphics-modal.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"]))
], BarGraphicsModalComponent);



/***/ }),

/***/ "./src/app/core/cake-graphic/cake-graphic.component.css":
/*!**************************************************************!*\
  !*** ./src/app/core/cake-graphic/cake-graphic.component.css ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvcmUvY2FrZS1ncmFwaGljL2Nha2UtZ3JhcGhpYy5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/core/cake-graphic/cake-graphic.component.ts":
/*!*************************************************************!*\
  !*** ./src/app/core/cake-graphic/cake-graphic.component.ts ***!
  \*************************************************************/
/*! exports provided: CakeGraphicComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CakeGraphicComponent", function() { return CakeGraphicComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var chartjs_plugin_datalabels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! chartjs-plugin-datalabels */ "./node_modules/chartjs-plugin-datalabels/dist/chartjs-plugin-datalabels.js");
/* harmony import */ var chartjs_plugin_datalabels__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(chartjs_plugin_datalabels__WEBPACK_IMPORTED_MODULE_2__);



let CakeGraphicComponent = class CakeGraphicComponent {
    constructor() {
        this.pieChartOptions = {
            responsive: true,
            legend: {
                position: 'right',
                labels: {
                    boxWidth: 12,
                    padding: 8,
                    fontSize: 12,
                },
            },
            plugins: {
                datalabels: {
                    formatter: (value, ctx) => {
                        let sum = 0;
                        let dataArr = ctx.chart.data.datasets[0].data;
                        dataArr.forEach(element => {
                            sum += element;
                        });
                        let percentage = ((value * 100) / sum).toFixed(2) + "%";
                        return percentage;
                        //const label = ctx.chart.data.labels[ctx.dataIndex];
                        //return label;
                    },
                },
            }
        };
        this.pieChartLabels = [['Download', 'Sales'], ['In', 'Store', 'Sales'], 'Mail Sales'];
        this.pieChartData = [300, 500, 100];
        this.pieChartType = 'pie';
        this.pieChartLegend = true;
        this.pieChartPlugins = [chartjs_plugin_datalabels__WEBPACK_IMPORTED_MODULE_2__];
        this.pieChartColors = [
            {
                backgroundColor: ['rgba(255,0,0,0.3)', 'rgba(0,255,0,0.3)', 'rgba(0,0,255,0.3)'],
            },
        ];
    }
    ngOnInit() {
    }
    // events
    chartClicked({ event, active }) {
        console.log(event, active);
    }
    chartHovered({ event, active }) {
        console.log(event, active);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CakeGraphicComponent.prototype, "pieChartLabels", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CakeGraphicComponent.prototype, "pieChartData", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CakeGraphicComponent.prototype, "pieChartColors", void 0);
CakeGraphicComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-cake-graphic',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./cake-graphic.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/cake-graphic/cake-graphic.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./cake-graphic.component.css */ "./src/app/core/cake-graphic/cake-graphic.component.css")).default]
    })
], CakeGraphicComponent);



/***/ }),

/***/ "./src/app/core/core.module.ts":
/*!*************************************!*\
  !*** ./src/app/core/core.module.ts ***!
  \*************************************/
/*! exports provided: CoreModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreModule", function() { return CoreModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _show_bay_show_bay_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./show-bay/show-bay.component */ "./src/app/core/show-bay/show-bay.component.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _login_login_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./login/login.component */ "./src/app/core/login/login.component.ts");
/* harmony import */ var _material_material_module__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../material/material.module */ "./src/app/material/material.module.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _filter_filter_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./filter/filter.component */ "./src/app/core/filter/filter.component.ts");
/* harmony import */ var _loading_loading_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./loading/loading.component */ "./src/app/core/loading/loading.component.ts");
/* harmony import */ var _speedometer_speedometer_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./speedometer/speedometer.component */ "./src/app/core/speedometer/speedometer.component.ts");
/* harmony import */ var angular_gauge_chart__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! angular-gauge-chart */ "./node_modules/angular-gauge-chart/fesm2015/angular-gauge-chart.js");
/* harmony import */ var _not_found_not_found_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./not-found/not-found.component */ "./src/app/core/not-found/not-found.component.ts");
/* harmony import */ var _cake_graphic_cake_graphic_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./cake-graphic/cake-graphic.component */ "./src/app/core/cake-graphic/cake-graphic.component.ts");
/* harmony import */ var ng2_charts__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ng2-charts */ "./node_modules/ng2-charts/fesm2015/ng2-charts.js");
/* harmony import */ var _user_user_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./user/user.component */ "./src/app/core/user/user.component.ts");
/* harmony import */ var _home_home_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./home/home.component */ "./src/app/core/home/home.component.ts");
/* harmony import */ var _force_change_password_force_change_password_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./force-change-password/force-change-password.component */ "./src/app/core/force-change-password/force-change-password.component.ts");
/* harmony import */ var _just_info_dialog_just_info_dialog_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./just-info-dialog/just-info-dialog.component */ "./src/app/core/just-info-dialog/just-info-dialog.component.ts");
/* harmony import */ var _bar_graphic_bar_graphic_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./bar-graphic/bar-graphic.component */ "./src/app/core/bar-graphic/bar-graphic.component.ts");
/* harmony import */ var _bar_graphic_modal_bar_graphic_modal_component__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./bar-graphic-modal/bar-graphic-modal.component */ "./src/app/core/bar-graphic-modal/bar-graphic-modal.component.ts");
/* harmony import */ var _bar_graphics_modal_bar_graphics_modal_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./bar-graphics-modal/bar-graphics-modal.component */ "./src/app/core/bar-graphics-modal/bar-graphics-modal.component.ts");





















let CoreModule = class CoreModule {
};
CoreModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [_login_login_component__WEBPACK_IMPORTED_MODULE_4__["LoginComponent"], _filter_filter_component__WEBPACK_IMPORTED_MODULE_7__["FilterComponent"], _loading_loading_component__WEBPACK_IMPORTED_MODULE_8__["LoadingComponent"],
            _speedometer_speedometer_component__WEBPACK_IMPORTED_MODULE_9__["SpeedometerComponent"], _not_found_not_found_component__WEBPACK_IMPORTED_MODULE_11__["NotFoundComponent"], _cake_graphic_cake_graphic_component__WEBPACK_IMPORTED_MODULE_12__["CakeGraphicComponent"],
            _user_user_component__WEBPACK_IMPORTED_MODULE_14__["UserComponent"], _home_home_component__WEBPACK_IMPORTED_MODULE_15__["HomeComponent"], _force_change_password_force_change_password_component__WEBPACK_IMPORTED_MODULE_16__["ForceChangePasswordComponent"], _just_info_dialog_just_info_dialog_component__WEBPACK_IMPORTED_MODULE_17__["JustInfoDialogComponent"],
            _bar_graphic_bar_graphic_component__WEBPACK_IMPORTED_MODULE_18__["BarGraphicComponent"], _bar_graphic_modal_bar_graphic_modal_component__WEBPACK_IMPORTED_MODULE_19__["BarGraphicModalComponent"], _bar_graphics_modal_bar_graphics_modal_component__WEBPACK_IMPORTED_MODULE_20__["BarGraphicsModalComponent"], _show_bay_show_bay_component__WEBPACK_IMPORTED_MODULE_1__["ShowBayComponent"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_3__["CommonModule"], _material_material_module__WEBPACK_IMPORTED_MODULE_5__["MaterialModule"], _angular_forms__WEBPACK_IMPORTED_MODULE_6__["FormsModule"], angular_gauge_chart__WEBPACK_IMPORTED_MODULE_10__["GaugeChartModule"], ng2_charts__WEBPACK_IMPORTED_MODULE_13__["ChartsModule"]
        ],
        exports: [
            _login_login_component__WEBPACK_IMPORTED_MODULE_4__["LoginComponent"], _just_info_dialog_just_info_dialog_component__WEBPACK_IMPORTED_MODULE_17__["JustInfoDialogComponent"], _bar_graphic_modal_bar_graphic_modal_component__WEBPACK_IMPORTED_MODULE_19__["BarGraphicModalComponent"], _bar_graphic_bar_graphic_component__WEBPACK_IMPORTED_MODULE_18__["BarGraphicComponent"], _bar_graphics_modal_bar_graphics_modal_component__WEBPACK_IMPORTED_MODULE_20__["BarGraphicsModalComponent"],
            _filter_filter_component__WEBPACK_IMPORTED_MODULE_7__["FilterComponent"], _material_material_module__WEBPACK_IMPORTED_MODULE_5__["MaterialModule"], _loading_loading_component__WEBPACK_IMPORTED_MODULE_8__["LoadingComponent"], angular_gauge_chart__WEBPACK_IMPORTED_MODULE_10__["GaugeChartModule"], _speedometer_speedometer_component__WEBPACK_IMPORTED_MODULE_9__["SpeedometerComponent"], _cake_graphic_cake_graphic_component__WEBPACK_IMPORTED_MODULE_12__["CakeGraphicComponent"],
            _show_bay_show_bay_component__WEBPACK_IMPORTED_MODULE_1__["ShowBayComponent"]
        ],
        entryComponents: [_loading_loading_component__WEBPACK_IMPORTED_MODULE_8__["LoadingComponent"], _just_info_dialog_just_info_dialog_component__WEBPACK_IMPORTED_MODULE_17__["JustInfoDialogComponent"], _bar_graphic_modal_bar_graphic_modal_component__WEBPACK_IMPORTED_MODULE_19__["BarGraphicModalComponent"],
            _bar_graphics_modal_bar_graphics_modal_component__WEBPACK_IMPORTED_MODULE_20__["BarGraphicsModalComponent"], _show_bay_show_bay_component__WEBPACK_IMPORTED_MODULE_1__["ShowBayComponent"]],
        providers: [_angular_common__WEBPACK_IMPORTED_MODULE_3__["DecimalPipe"]]
    })
], CoreModule);



/***/ }),

/***/ "./src/app/core/filter/filter.component.css":
/*!**************************************************!*\
  !*** ./src/app/core/filter/filter.component.css ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvcmUvZmlsdGVyL2ZpbHRlci5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/core/filter/filter.component.ts":
/*!*************************************************!*\
  !*** ./src/app/core/filter/filter.component.ts ***!
  \*************************************************/
/*! exports provided: FilterComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FilterComponent", function() { return FilterComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let FilterComponent = class FilterComponent {
    constructor() {
        //titulos de los filtros
        this.tittles = [];
        //tipo de atributos que tien cuando presentan en este array un objeto es creado un seleccionable con cada uno de los objetos en el arrayObject
        this.typeAttribute = [];
        //array de resultados de lo que se seleciona en los combo box creados para el array de objetos
        this.arrayResults = [];
        //item donde con el que se emite la informacion por evento recordar que el objeto debe tener el formato {deleted: false/true, ....dto:{objeto principal}}
        this.filter = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
    }
    set tag(input) {
        if (!input)
            return;
        else
            this.buttonClose = input;
    }
    ngOnInit() {
        console.log("object", this.arrayObject);
    }
    //se contruye el objeto con la propiedad principal donde queda almacenado en formato {...,dto:{objeto principal}, si exitsten objetos se envian con el titulo asignado : objeto en string seleccionado}
    filterObject() {
        let textResult = '{' + '"principal":' + JSON.stringify(this.itemFilter);
        if (this.arrayObject) {
            textResult += ',';
            for (let index = 0; index < this.arrayResults.length; index++) {
                textResult += '"' + this.tittles[(this.tittles.length - this.arrayObject.length) + (index)] + '":' + JSON.stringify(this.arrayResults[index]);
                if (index < this.arrayResults.length - 1) {
                    textResult += ',';
                }
                else {
                    textResult += '}';
                }
            }
        }
        else {
            textResult += '}';
        }
        console.log(textResult, "enviado");
        console.log(JSON.parse(textResult));
        this.filter.emit(JSON.parse(textResult));
        this.buttonClose.nativeElement.click();
    }
    giveOnString(itemObject) {
        return JSON.stringify(itemObject);
    }
    containsDTO(item) {
        let s = item.includes("dto");
        return s;
    }
    giveAttribute(item) {
        let result = item.split(".");
        if (result.length > 1) {
            return result[1];
        }
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], FilterComponent.prototype, "tittles", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], FilterComponent.prototype, "typeAttribute", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], FilterComponent.prototype, "attributes", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], FilterComponent.prototype, "arrayObject", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], FilterComponent.prototype, "arrayResults", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], FilterComponent.prototype, "itemFilter", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], FilterComponent.prototype, "filter", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('buttonClose', { read: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"], static: false })
], FilterComponent.prototype, "tag", null);
FilterComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-filter',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./filter.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/filter/filter.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./filter.component.css */ "./src/app/core/filter/filter.component.css")).default]
    })
], FilterComponent);



/***/ }),

/***/ "./src/app/core/force-change-password/force-change-password.component.css":
/*!********************************************************************************!*\
  !*** ./src/app/core/force-change-password/force-change-password.component.css ***!
  \********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".example-form {\r\n    min-width: 150px;\r\n    max-width: 500px;\r\n    width: 100%;\r\n}\r\n\r\n.example-full-width {\r\n    width: 100%;\r\n}\r\n\r\n.btn-change {\r\n    background: #fbbc04;\r\n    margin-top: 5%;\r\n    border-radius: 8px;\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    \r\n}\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29yZS9mb3JjZS1jaGFuZ2UtcGFzc3dvcmQvZm9yY2UtY2hhbmdlLXBhc3N3b3JkLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxnQkFBZ0I7SUFDaEIsZ0JBQWdCO0lBQ2hCLFdBQVc7QUFDZjs7QUFFQTtJQUNJLFdBQVc7QUFDZjs7QUFFQTtJQUNJLG1CQUFtQjtJQUNuQixjQUFjO0lBR2Qsa0JBQWtCO0lBQ2xCLGtCQUFrQjtJQUNsQix5QkFBeUI7O0FBRTdCIiwiZmlsZSI6InNyYy9hcHAvY29yZS9mb3JjZS1jaGFuZ2UtcGFzc3dvcmQvZm9yY2UtY2hhbmdlLXBhc3N3b3JkLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuZXhhbXBsZS1mb3JtIHtcclxuICAgIG1pbi13aWR0aDogMTUwcHg7XHJcbiAgICBtYXgtd2lkdGg6IDUwMHB4O1xyXG4gICAgd2lkdGg6IDEwMCU7XHJcbn1cclxuXHJcbi5leGFtcGxlLWZ1bGwtd2lkdGgge1xyXG4gICAgd2lkdGg6IDEwMCU7XHJcbn1cclxuXHJcbi5idG4tY2hhbmdlIHtcclxuICAgIGJhY2tncm91bmQ6ICNmYmJjMDQ7XHJcbiAgICBtYXJnaW4tdG9wOiA1JTtcclxuICAgIC13ZWJraXQtYm9yZGVyLXJhZGl1czogOHB4O1xyXG4gICAgLW1vei1ib3JkZXItcmFkaXVzOiA4cHg7XHJcbiAgICBib3JkZXItcmFkaXVzOiA4cHg7XHJcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XHJcbiAgICB0ZXh0LXRyYW5zZm9ybTogdXBwZXJjYXNlO1xyXG4gICAgXHJcbn0iXX0= */");

/***/ }),

/***/ "./src/app/core/force-change-password/force-change-password.component.ts":
/*!*******************************************************************************!*\
  !*** ./src/app/core/force-change-password/force-change-password.component.ts ***!
  \*******************************************************************************/
/*! exports provided: ForceChangePasswordComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ForceChangePasswordComponent", function() { return ForceChangePasswordComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _model_user__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../model/user */ "./src/app/core/model/user.ts");
/* harmony import */ var _service_message_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../service/message.service */ "./src/app/core/service/message.service.ts");
/* harmony import */ var _service_auth_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./../service/auth.service */ "./src/app/core/service/auth.service.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");





let ForceChangePasswordComponent = class ForceChangePasswordComponent {
    constructor(authService, messageHandler) {
        this.authService = authService;
        this.messageHandler = messageHandler;
    }
    ngOnInit() {
        this.user = new _model_user__WEBPACK_IMPORTED_MODULE_1__["User"]();
        this.user = this.authService.getUser();
        if (!this.user) {
            let userMail = localStorage.getItem("mailBays");
            if (userMail) {
                this.authService.find(userMail).subscribe(data => {
                    if (data) {
                        this.user = data;
                    }
                }, error => {
                    this.messageHandler.errorHandler(error);
                });
            }
        }
    }
    changePassword() {
        let msn = this.valid();
        if ("" == msn) {
            console.log(this.newPassword, this.oldPassword, this.confirmPassword);
            this.authService.changePassword(this.user.email, this.newPassword, this.oldPassword).subscribe(data => {
                this.messageHandler.commonMessage("Contraseña actualizada correctamente", "success", "");
                this.newPassword = "";
                this.confirmPassword = "";
                this.oldPassword = "";
            }, error => {
                this.messageHandler.errorHandler(error);
            });
        }
        else {
            this.messageHandler.commonMessage(msn, "info", "");
        }
    }
    valid() {
        let msn = "";
        if (!this.oldPassword) {
            msn += "Debe ingresar la contraseña anterior;";
        }
        if (!this.newPassword) {
            msn += "Debe especificar la nueva contraseña;";
        }
        if (!this.confirmPassword || this.confirmPassword != this.newPassword) {
            msn += "Las contraseñas deben coincidir;";
        }
        if (!this.user) {
            msn += "Usuario no definido";
        }
        console.log(this.oldPassword, this.user.password);
        return msn;
    }
};
ForceChangePasswordComponent.ctorParameters = () => [
    { type: _service_auth_service__WEBPACK_IMPORTED_MODULE_3__["AuthService"] },
    { type: _service_message_service__WEBPACK_IMPORTED_MODULE_2__["MessageService"] }
];
ForceChangePasswordComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["Component"])({
        selector: 'app-force-change-password',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./force-change-password.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/force-change-password/force-change-password.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./force-change-password.component.css */ "./src/app/core/force-change-password/force-change-password.component.css")).default]
    })
], ForceChangePasswordComponent);



/***/ }),

/***/ "./src/app/core/home/home.component.css":
/*!**********************************************!*\
  !*** ./src/app/core/home/home.component.css ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvcmUvaG9tZS9ob21lLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/core/home/home.component.ts":
/*!*********************************************!*\
  !*** ./src/app/core/home/home.component.ts ***!
  \*********************************************/
/*! exports provided: HomeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeComponent", function() { return HomeComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");



let HomeComponent = class HomeComponent {
    constructor(router) {
        this.router = router;
    }
    ngOnInit() {
        let item = localStorage.getItem("refreshBay");
        if (!item) {
            localStorage.setItem("refreshBay", "no");
            window.location.reload();
        }
    }
};
HomeComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] }
];
HomeComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-home',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/home/home.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home.component.css */ "./src/app/core/home/home.component.css")).default]
    })
], HomeComponent);



/***/ }),

/***/ "./src/app/core/http-interceptor.ts":
/*!******************************************!*\
  !*** ./src/app/core/http-interceptor.ts ***!
  \******************************************/
/*! exports provided: HttpInteceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpInteceptor", function() { return HttpInteceptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let HttpInteceptor = class HttpInteceptor {
    constructor() { }
    intercept(req, next) {
        if (!this.token) {
            this.token = localStorage.getItem('tokenBays');
        }
        if (!this.token) {
            this.token = '';
        }
        let tokenizetReq = req.clone({
            setHeaders: {
                Authorization: this.token
            }
        });
        return next.handle(tokenizetReq);
    }
};
HttpInteceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], HttpInteceptor);



/***/ }),

/***/ "./src/app/core/just-info-dialog/just-info-dialog.component.css":
/*!**********************************************************************!*\
  !*** ./src/app/core/just-info-dialog/just-info-dialog.component.css ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvcmUvanVzdC1pbmZvLWRpYWxvZy9qdXN0LWluZm8tZGlhbG9nLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/core/just-info-dialog/just-info-dialog.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/core/just-info-dialog/just-info-dialog.component.ts ***!
  \*********************************************************************/
/*! exports provided: JustInfoDialogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JustInfoDialogComponent", function() { return JustInfoDialogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");



let JustInfoDialogComponent = class JustInfoDialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    onNoClick() {
        this.dialogRef.close();
    }
    ngOnInit() {
    }
};
JustInfoDialogComponent.ctorParameters = () => [
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_1__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_1__["MAT_DIALOG_DATA"],] }] }
];
JustInfoDialogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-just-info-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./just-info-dialog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/just-info-dialog/just-info-dialog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./just-info-dialog.component.css */ "./src/app/core/just-info-dialog/just-info-dialog.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_1__["MAT_DIALOG_DATA"]))
], JustInfoDialogComponent);



/***/ }),

/***/ "./src/app/core/loading/loading.component.css":
/*!****************************************************!*\
  !*** ./src/app/core/loading/loading.component.css ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvcmUvbG9hZGluZy9sb2FkaW5nLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/core/loading/loading.component.ts":
/*!***************************************************!*\
  !*** ./src/app/core/loading/loading.component.ts ***!
  \***************************************************/
/*! exports provided: LoadingComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoadingComponent", function() { return LoadingComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");



let LoadingComponent = class LoadingComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.color = 'accent';
        this.value = 50;
    }
    ngOnInit() {
    }
};
LoadingComponent.ctorParameters = () => [
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] }
];
LoadingComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-loading',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./loading.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/loading/loading.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./loading.component.css */ "./src/app/core/loading/loading.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"]))
], LoadingComponent);



/***/ }),

/***/ "./src/app/core/login/login.component.css":
/*!************************************************!*\
  !*** ./src/app/core/login/login.component.css ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("html,\r\nbody {\r\n  height: 100%;\r\n}\r\n\r\nbody {\r\n  display: flex;\r\n  align-items: center;\r\n  padding-top: 40px;\r\n  padding-bottom: 40px;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.form-signin {\r\n  width: 100%;\r\n  max-width: 330px;\r\n  padding: 15px;\r\n  margin: auto;\r\n}\r\n\r\n.form-signin .checkbox {\r\n  font-weight: 400;\r\n}\r\n\r\n.form-signin .form-control {\r\n  position: relative;\r\n  box-sizing: border-box;\r\n  height: auto;\r\n  padding: 10px;\r\n  font-size: 16px;\r\n}\r\n\r\n.form-signin .form-control:focus {\r\n  z-index: 2;\r\n}\r\n\r\n.form-signin input[type=\"email\"] {\r\n  margin-bottom: -1px;\r\n  border-bottom-right-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n.form-signin input[type=\"password\"] {\r\n  margin-bottom: 10px;\r\n  border-top-left-radius: 0;\r\n  border-top-right-radius: 0;\r\n}\r\n\r\n.shadowElement{\r\n  box-shadow: 17px 9px 24px 1px rgba(0,0,0,0.75);\r\n}\r\n\r\n.btn-info{\r\n    background: #fbbc04;\r\n    color: white;\r\n}\r\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/core/login/login.component.ts":
/*!***********************************************!*\
  !*** ./src/app/core/login/login.component.ts ***!
  \***********************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return LoginComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _service_message_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../service/message.service */ "./src/app/core/service/message.service.ts");
/* harmony import */ var _service_auth_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../service/auth.service */ "./src/app/core/service/auth.service.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./../../../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! sweetalert2 */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");







let LoginComponent = class LoginComponent {
    constructor(auth, router, messageHandler) {
        this.auth = auth;
        this.router = router;
        this.messageHandler = messageHandler;
        this.remember = false;
        this.showed = true;
    }
    ngOnInit() {
        let loggued = localStorage.getItem("logged");
        let remember = localStorage.getItem("rememberBays");
        let token = localStorage.getItem("tokenBays");
        if (remember && remember == "true") {
            if (loggued && loggued == "true" && token != null && token != "") {
                this.router.navigate(['home']);
            }
            else {
                this.user = localStorage.getItem('mailBays');
                this.password = localStorage.getItem("passwordBays");
                this.remember = true;
            }
        }
        else if (token && token != "") {
            this.showed = false;
            this.auth.logout();
        }
        else {
            localStorage.clear();
            this.router.navigate(['login']);
        }
    }
    login() {
        if (!this.password || !this.user) {
            sweetalert2__WEBPACK_IMPORTED_MODULE_5___default.a.fire(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["messages"].errorTittle, 'Ingrese usuario y contraseña', 'error');
            return;
        }
        this.auth.signin({ usernameOrEmail: this.user, password: this.password }).subscribe(res => {
            if (res.accessToken) {
                if (this.user) {
                    this.auth.find(this.user).subscribe(user => {
                        localStorage.setItem('tokenBays', res.accessToken);
                        localStorage.setItem('loggedBays', "true");
                        localStorage.setItem('userIdBays', "" + user.id);
                        localStorage.setItem('mailBays', "" + user.email);
                        if (this.remember == true) {
                            localStorage.setItem('usernameBays', "" + this.user);
                            localStorage.setItem('passwordBays', "" + this.password);
                            localStorage.setItem('rememberBays', "true");
                        }
                        else {
                            localStorage.removeItem("usernameBays");
                            localStorage.removeItem("rememberBays");
                            localStorage.removeItem("passwordBays");
                        }
                        this.auth.setUser(user);
                        this.router.navigate(['home']);
                    });
                }
            }
        }, err => {
            this.messageHandler.errorHandler(err);
        });
        this.router.navigate(['login']);
    }
    goToSismoit() {
        window.open("https://sismoit.com/");
    }
};
LoginComponent.ctorParameters = () => [
    { type: _service_auth_service__WEBPACK_IMPORTED_MODULE_2__["AuthService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_6__["Router"] },
    { type: _service_message_service__WEBPACK_IMPORTED_MODULE_1__["MessageService"] }
];
LoginComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["Component"])({
        selector: 'app-login',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/login/login.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login.component.css */ "./src/app/core/login/login.component.css")).default]
    })
], LoginComponent);



/***/ }),

/***/ "./src/app/core/model/listDTO.ts":
/*!***************************************!*\
  !*** ./src/app/core/model/listDTO.ts ***!
  \***************************************/
/*! exports provided: ListDTO */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListDTO", function() { return ListDTO; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class ListDTO {
    constructor(element) {
        this.page = 0;
        this.size = 3000;
        this.dto = element;
    }
}


/***/ }),

/***/ "./src/app/core/model/user-date-audit.ts":
/*!***********************************************!*\
  !*** ./src/app/core/model/user-date-audit.ts ***!
  \***********************************************/
/*! exports provided: UserDateAudit */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserDateAudit", function() { return UserDateAudit; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class UserDateAudit {
}


/***/ }),

/***/ "./src/app/core/model/user.ts":
/*!************************************!*\
  !*** ./src/app/core/model/user.ts ***!
  \************************************/
/*! exports provided: User */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "User", function() { return User; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _user_date_audit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./user-date-audit */ "./src/app/core/model/user-date-audit.ts");


class User extends _user_date_audit__WEBPACK_IMPORTED_MODULE_1__["UserDateAudit"] {
}


/***/ }),

/***/ "./src/app/core/model/workorder.ts":
/*!*****************************************!*\
  !*** ./src/app/core/model/workorder.ts ***!
  \*****************************************/
/*! exports provided: WorkOrder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WorkOrder", function() { return WorkOrder; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _user_date_audit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./user-date-audit */ "./src/app/core/model/user-date-audit.ts");


class WorkOrder extends _user_date_audit__WEBPACK_IMPORTED_MODULE_1__["UserDateAudit"] {
}


/***/ }),

/***/ "./src/app/core/not-found/not-found.component.css":
/*!********************************************************!*\
  !*** ./src/app/core/not-found/not-found.component.css ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvcmUvbm90LWZvdW5kL25vdC1mb3VuZC5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/core/not-found/not-found.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/core/not-found/not-found.component.ts ***!
  \*******************************************************/
/*! exports provided: NotFoundComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotFoundComponent", function() { return NotFoundComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");



let NotFoundComponent = class NotFoundComponent {
    constructor(router) {
        this.router = router;
    }
    ngOnInit() {
        setTimeout(() => {
            this.router.navigate(['home']);
        }, 5000);
    }
};
NotFoundComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] }
];
NotFoundComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-not-found',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./not-found.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/not-found/not-found.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./not-found.component.css */ "./src/app/core/not-found/not-found.component.css")).default]
    })
], NotFoundComponent);



/***/ }),

/***/ "./src/app/core/service/auth.service.ts":
/*!**********************************************!*\
  !*** ./src/app/core/service/auth.service.ts ***!
  \**********************************************/
/*! exports provided: AuthService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthService", function() { return AuthService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! sweetalert2 */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./message.service */ "./src/app/core/service/message.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");







let AuthService = class AuthService {
    constructor(http, router, messageHandler) {
        this.http = http;
        this.router = router;
        this.messageHandler = messageHandler;
        this.path = "auth";
    }
    getUser() {
        return this.user;
    }
    setUser(user) {
        this.user = user;
    }
    isAuthenticatedWithout() {
        const token = localStorage.getItem('tokenBays');
        if (!token || token === '') {
            return false;
        }
        return true;
    }
    isAuthPromise(comingUrl) {
        const token = localStorage.getItem('tokenBays');
        if (!token || token === '') {
            return Promise.resolve(false);
        }
        let userMail = localStorage.getItem("mailBays");
        if (userMail) {
            this.doIhaveAccess({ url: comingUrl }).subscribe(data => {
                console.log(data);
                return Promise.resolve(true);
                ;
            }, error => {
                this.messageHandler.errorHandler(error);
                return Promise.resolve(false);
                ;
            });
        }
        else {
            this.messageHandler.commonMessage("No se encuentra un usuario en la sesión", "info", "Sin autenticar");
            return Promise.resolve(false);
            ;
        }
    }
    isAuthenticated(comingUrl) {
        const token = localStorage.getItem('tokenBays');
        if (!token || token === '') {
            return false;
        }
        /* if (userMail) {
           this.doIhaveAccess({url:comingUrl}).subscribe(data => {
     
            return true;
     
           }, error => {
             this.messageHandler.errorHandler(error);
             return false;
           })
     
         } else {
           this.messageHandler.commonMessage("No se encuentra un usuario en la sesión", "info", "Sin autenticar");
           return false;
         }
       
        */
        let result = false;
        if (this.user) {
            this.user.role.urls.forEach(element => {
                if (element.url == comingUrl) {
                    result = true;
                }
            });
        }
        else {
            let email = localStorage.getItem("mailBays");
            if (email && email != "") {
                this.find(email).subscribe(data => {
                    this.user = data;
                }, error => {
                    this.messageHandler.commonMessage("Debe iniciar sesión de nuevo", "error", "Lo sentimos");
                });
            }
        }
        return result;
    }
    find(email) {
        console.log("email", email);
        return this.http.get(src_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].url + 'auth/id/' + email);
    }
    doIhaveAccess(url) {
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].url + this.path + '/access/permission', url);
    }
    getRoles() {
        return this.http.get(src_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].url + this.path + "/roles");
    }
    signup(request) {
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].url + this.path + "/signup", request);
    }
    list(dto) {
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].url + this.path + "/list", dto);
    }
    signin(request) {
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].url + 'auth/signin', request);
    }
    changePassword(email, password, oldPassowrd) {
        return this.http.get(src_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].url + this.path + "/change/password/" + password + "/" + email + "/" + oldPassowrd);
    }
    logout() {
        sweetalert2__WEBPACK_IMPORTED_MODULE_2___default.a.fire({
            title: "¿Cerrar sesión?",
            text: "Cerrará la sesión de shop bay",
            icon: 'info',
            cancelButtonText: "No",
            confirmButtonText: "Si",
            showCancelButton: true,
        }).then(accepted => {
            console.log(accepted);
            if (accepted.value && accepted.value == true) {
                this.forceLogOut();
            }
            else {
                this.router.navigate(["home"]);
            }
        });
    }
    forceLogOut() {
        localStorage.removeItem('tokenBays');
        localStorage.removeItem("loggedBays");
        localStorage.removeItem('passwordBays');
        localStorage.removeItem("rememberBays");
        localStorage.removeItem('mailBays');
        localStorage.removeItem("userIdBays");
        localStorage.removeItem("refreshBay");
        this.router.navigate(['login']);
    }
};
AuthService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpClient"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_3__["MessageService"] }
];
AuthService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_5__["Injectable"])({
        providedIn: 'root'
    })
], AuthService);



/***/ }),

/***/ "./src/app/core/service/base.service.ts":
/*!**********************************************!*\
  !*** ./src/app/core/service/base.service.ts ***!
  \**********************************************/
/*! exports provided: BaseService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseService", function() { return BaseService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");




let BaseService = class BaseService {
    constructor(http) {
        this.http = http;
    }
    save(item) {
        console.log(this.path);
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].url + this.path + '/save', item);
    }
    list(listDto) {
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].url + this.path + '/list', listDto);
    }
    delete(item) {
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].url + this.path + '/delete', item);
    }
    find(item) {
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].url + this.path + '/find/id', item);
    }
};
BaseService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
BaseService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], BaseService);



/***/ }),

/***/ "./src/app/core/service/message.service.ts":
/*!*************************************************!*\
  !*** ./src/app/core/service/message.service.ts ***!
  \*************************************************/
/*! exports provided: MessageService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MessageService", function() { return MessageService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! sweetalert2 */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_2__);



let MessageService = class MessageService {
    constructor() { }
    errorHandler(res) {
        let msn = "";
        if (res.status && res.status == 404) {
            this.commonMessage("Recurso no encontrado", "error");
        }
        else if (res) {
            if (res.error) {
                if (res.error.errors) {
                    for (let errmsn of res.error.errors) {
                        msn += errmsn.defaultMessage;
                    }
                }
                else if (res.error.message) {
                    msn = res.error.message;
                }
                else if (res.message) {
                    if (res.message.includes("Http failure response for http")) {
                        msn = "Error desconocido comuniquese con soporte técnico ";
                    }
                    else {
                        msn = res.message;
                    }
                }
                else {
                    msn = "error desconocido comuniquese con soporte tecnico";
                }
                if (msn.includes("not authorized")) {
                    msn = "Usuario y/o contraseña invalido";
                }
            }
            else {
                msn += "error desconocido comuniquese con soporte tecnico";
            }
            this.commonMessage(msn, "error");
        }
    }
    commonMessage(message, type, tittle = message.errorTittle) {
        let array = message.split(";");
        let messageToShow = "";
        if (array.length > 1) {
            array.forEach(element => {
                messageToShow += "<br>*" + element;
            });
        }
        else {
            messageToShow = message;
        }
        sweetalert2__WEBPACK_IMPORTED_MODULE_2___default.a.fire(tittle, messageToShow, type);
    }
};
MessageService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], MessageService);



/***/ }),

/***/ "./src/app/core/service/work-order.service.ts":
/*!****************************************************!*\
  !*** ./src/app/core/service/work-order.service.ts ***!
  \****************************************************/
/*! exports provided: WorkOrderService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WorkOrderService", function() { return WorkOrderService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _base_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./base.service */ "./src/app/core/service/base.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");





let WorkOrderService = class WorkOrderService extends _base_service__WEBPACK_IMPORTED_MODULE_2__["BaseService"] {
    constructor(http) {
        super(http);
        this.path = "workorder";
    }
    saveFile(file) {
        let form = new FormData();
        form.append('file', file);
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].url + this.path + "/upload", form, { headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpHeaders"]({ timeout: '360000' }) });
    }
    findbyOt(ot) {
        return this.http.get(src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].url + this.path + "/find/ot/" + ot);
    }
};
WorkOrderService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
WorkOrderService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], WorkOrderService);



/***/ }),

/***/ "./src/app/core/show-bay/show-bay.component.css":
/*!******************************************************!*\
  !*** ./src/app/core/show-bay/show-bay.component.css ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvcmUvc2hvdy1iYXkvc2hvdy1iYXkuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/core/show-bay/show-bay.component.ts":
/*!*****************************************************!*\
  !*** ./src/app/core/show-bay/show-bay.component.ts ***!
  \*****************************************************/
/*! exports provided: ShowBayComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShowBayComponent", function() { return ShowBayComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _dash_board_model_bay__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../../dash-board/model/bay */ "./src/app/dash-board/model/bay.ts");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");




let ShowBayComponent = class ShowBayComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.bay = new _dash_board_model_bay__WEBPACK_IMPORTED_MODULE_1__["Bay"]();
        this.bay.bayNumber = data.bay.bayNumber;
        this.bay.excludeBay = data.bay.excludeBay;
    }
    onNoClick() {
        this.dialogRef.close();
    }
    ngOnInit() {
        console.log(this.bay, "asdfasadsfasdfjja vkjsdfjdkjfkn  j f  asfkjasddf", this.data);
    }
};
ShowBayComponent.ctorParameters = () => [
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] }
];
ShowBayComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"])({
        selector: 'app-show-bay',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./show-bay.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/show-bay/show-bay.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./show-bay.component.css */ "./src/app/core/show-bay/show-bay.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"]))
], ShowBayComponent);



/***/ }),

/***/ "./src/app/core/speedometer/speedometer.component.css":
/*!************************************************************!*\
  !*** ./src/app/core/speedometer/speedometer.component.css ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvcmUvc3BlZWRvbWV0ZXIvc3BlZWRvbWV0ZXIuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/core/speedometer/speedometer.component.ts":
/*!***********************************************************!*\
  !*** ./src/app/core/speedometer/speedometer.component.ts ***!
  \***********************************************************/
/*! exports provided: SpeedometerComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpeedometerComponent", function() { return SpeedometerComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let SpeedometerComponent = class SpeedometerComponent {
    constructor() {
        this.canvasWidth = 300;
        this.needleValue = 65;
        this.centralLabel = '';
        this.name = 'Nombre Velocimetro';
        this.bottomLabel = '65';
        this.options = {
            hasNeedle: true,
            needleColor: 'gray',
            needleUpdateSpeed: 3000,
            arcColors: null,
            arcDelimiters: null,
            rangeLabel: ['0%', '100%'],
            needleStartValue: 0,
        };
        this.arcColor = ['rgb(255, 0, 0)', 'rgb(238,255,0)', 'rgb(0,255,30)'];
        this.arcDelimiter = [30, 80];
    }
    ngOnInit() {
        this.options.arcColors = this.arcColor;
        this.options.arcDelimiters = this.arcDelimiter;
        this.bottomLabel = this.bottomLabel + "%";
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SpeedometerComponent.prototype, "needleValue", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SpeedometerComponent.prototype, "name", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SpeedometerComponent.prototype, "bottomLabel", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SpeedometerComponent.prototype, "arcColor", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SpeedometerComponent.prototype, "arcDelimiter", void 0);
SpeedometerComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-speedometer',
        encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./speedometer.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/speedometer/speedometer.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./speedometer.component.css */ "./src/app/core/speedometer/speedometer.component.css")).default]
    })
], SpeedometerComponent);



/***/ }),

/***/ "./src/app/core/user/user.component.css":
/*!**********************************************!*\
  !*** ./src/app/core/user/user.component.css ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".principal-elements{\r\n    padding-left : 2%;\r\n    padding-right: 2%;\r\n    padding-bottom: 2%;\r\n}\r\n\r\n\r\ntable {\r\n    width: 100%;\r\n  }\r\n\r\n\r\n.btn-primary:hover {\r\n    color: #fff;\r\n    background-color: #343a40;\r\n   \r\n}\r\n\r\n\r\n.btn-primary{\r\n    background: #fbbc04;\r\n    border: none;\r\n}\r\n\r\n\r\n.picker{\r\n  border-radius: 77px 77px 77px 77px;\r\n  -moz-border-radius: 77px 77px 77px 77px;\r\n  -webkit-border-radius: 77px 77px 77px 77px;\r\n  border: 0px solid #000000;\r\n  background: #fbbc04 ;\r\n  text-align: center;\r\n  margin-top: 5%;\r\n\r\n\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29yZS91c2VyL3VzZXIuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLGlCQUFpQjtJQUNqQixpQkFBaUI7SUFDakIsa0JBQWtCO0FBQ3RCOzs7QUFHQTtJQUNJLFdBQVc7RUFDYjs7O0FBR0E7SUFDRSxXQUFXO0lBQ1gseUJBQXlCOztBQUU3Qjs7O0FBRUE7SUFDSSxtQkFBbUI7SUFDbkIsWUFBWTtBQUNoQjs7O0FBRUE7RUFDRSxrQ0FBa0M7RUFDbEMsdUNBQXVDO0VBQ3ZDLDBDQUEwQztFQUMxQyx5QkFBeUI7RUFDekIsb0JBQW9CO0VBQ3BCLGtCQUFrQjtFQUNsQixjQUFjOzs7QUFHaEIiLCJmaWxlIjoic3JjL2FwcC9jb3JlL3VzZXIvdXNlci5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnByaW5jaXBhbC1lbGVtZW50c3tcclxuICAgIHBhZGRpbmctbGVmdCA6IDIlO1xyXG4gICAgcGFkZGluZy1yaWdodDogMiU7XHJcbiAgICBwYWRkaW5nLWJvdHRvbTogMiU7XHJcbn1cclxuXHJcblxyXG50YWJsZSB7XHJcbiAgICB3aWR0aDogMTAwJTtcclxuICB9XHJcblxyXG5cclxuICAuYnRuLXByaW1hcnk6aG92ZXIge1xyXG4gICAgY29sb3I6ICNmZmY7XHJcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjMzQzYTQwO1xyXG4gICBcclxufVxyXG5cclxuLmJ0bi1wcmltYXJ5e1xyXG4gICAgYmFja2dyb3VuZDogI2ZiYmMwNDtcclxuICAgIGJvcmRlcjogbm9uZTtcclxufVxyXG5cclxuLnBpY2tlcntcclxuICBib3JkZXItcmFkaXVzOiA3N3B4IDc3cHggNzdweCA3N3B4O1xyXG4gIC1tb3otYm9yZGVyLXJhZGl1czogNzdweCA3N3B4IDc3cHggNzdweDtcclxuICAtd2Via2l0LWJvcmRlci1yYWRpdXM6IDc3cHggNzdweCA3N3B4IDc3cHg7XHJcbiAgYm9yZGVyOiAwcHggc29saWQgIzAwMDAwMDtcclxuICBiYWNrZ3JvdW5kOiAjZmJiYzA0IDtcclxuICB0ZXh0LWFsaWduOiBjZW50ZXI7XHJcbiAgbWFyZ2luLXRvcDogNSU7XHJcblxyXG5cclxufVxyXG4iXX0= */");

/***/ }),

/***/ "./src/app/core/user/user.component.ts":
/*!*********************************************!*\
  !*** ./src/app/core/user/user.component.ts ***!
  \*********************************************/
/*! exports provided: UserComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserComponent", function() { return UserComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _model_user__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../model/user */ "./src/app/core/model/user.ts");
/* harmony import */ var _dash_board_service_garage_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../../dash-board/service/garage.service */ "./src/app/dash-board/service/garage.service.ts");
/* harmony import */ var _service_message_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./../service/message.service */ "./src/app/core/service/message.service.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _service_auth_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../service/auth.service */ "./src/app/core/service/auth.service.ts");






let UserComponent = class UserComponent {
    constructor(authService, messageHandler, garageService) {
        this.authService = authService;
        this.messageHandler = messageHandler;
        this.garageService = garageService;
        this.displayedColumns = ['id', 'ident', 'name', 'role', 'garage', 'edit'];
    }
    ngOnInit() {
        this.user = new _model_user__WEBPACK_IMPORTED_MODULE_1__["User"]();
        this.roles = new Array();
        this.users = new Array();
        this.dataSource = new Array();
        this.getRoles();
        this.listGarages();
        this.list();
    }
    getRoles() {
        this.authService.getRoles().subscribe(data => {
            this.roles = data;
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    signUp() {
        let msn = this.valid();
        if ("" == msn) {
            this.authService.signup(this.user).subscribe(data => {
                this.clear();
                this.list();
                this.messageHandler.commonMessage("Usuario registrado con exito", "success", "Registro completo");
            }, error => {
                this.messageHandler.errorHandler(error);
            });
        }
        else {
            this.messageHandler.commonMessage(msn, "info", "Información erronea");
        }
    }
    valid() {
        let msn = "";
        if (this.user) {
            if (!this.user.name)
                msn += "Debe especificar un nombre de usuario;";
            if (!this.user.email) {
                msn += "Debe especificar un correo electronico;";
            }
            if (!this.user.role) {
                msn += "Debe especificar un rol;";
            }
            if (!this.user.garage) {
                msn += "Debe especificar un taller";
            }
        }
        else {
            msn += "Usuario no definido";
        }
        return msn;
    }
    listGarages() {
        this.garageService.list({ page: 0, size: 3000 }).subscribe(data => {
            if (data) {
                this.garages = data.content;
            }
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    clear() {
        this.user = new _model_user__WEBPACK_IMPORTED_MODULE_1__["User"]();
    }
    list() {
        this.authService.list({ page: 0, size: 3000 }).subscribe(data => {
            if (data) {
                this.users = data.content;
                this.buildData();
            }
            else {
                this.users = [];
            }
        }, err => {
            this.messageHandler.errorHandler(err);
        });
    }
    buildData() {
        let dataSource = new Array();
        let data;
        this.users.forEach(element => {
            console.log(element, "aqui");
            let garageName = (element.garage) ? element.garage : { name: "No presenta" };
            data = {
                id: element.id,
                name: element.name,
                email: element.email,
                password: element.password,
                role: element.role,
                userIdentification: element.userIdentification,
                attemps: element.attemps,
                lastChangePaswword: element.lastChangePaswword,
                apps: element.apps,
                garage: garageName,
                forceChangePassword: element.forceChangePassword
            };
            dataSource.push(data);
        });
        this.dataSource = dataSource;
    }
    edit(element) {
        console.log(element);
        this.user = element;
    }
};
UserComponent.ctorParameters = () => [
    { type: _service_auth_service__WEBPACK_IMPORTED_MODULE_5__["AuthService"] },
    { type: _service_message_service__WEBPACK_IMPORTED_MODULE_3__["MessageService"] },
    { type: _dash_board_service_garage_service__WEBPACK_IMPORTED_MODULE_2__["GarageService"] }
];
UserComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["Component"])({
        selector: 'app-user',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./user.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/user/user.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./user.component.css */ "./src/app/core/user/user.component.css")).default]
    })
], UserComponent);



/***/ }),

/***/ "./src/app/dash-board/activity/activity.component.css":
/*!************************************************************!*\
  !*** ./src/app/dash-board/activity/activity.component.css ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".example-form {\r\n    width: 100%;\r\n  }\r\n  \r\n  .example-full-width {\r\n    width: 100%;\r\n  }\r\n  \r\n  .item-margin{\r\n      margin-top: 8%;\r\n      margin-bottom: 5%;\r\n  }\r\n  \r\n  table {\r\n    width: 100%;\r\n  }\r\n  \r\n  tr.example-detail-row {\r\n    height: 0;\r\n  }\r\n  \r\n  tr.example-element-row:not(.example-expanded-row):hover {\r\n    background: #777;\r\n  }\r\n  \r\n  tr.example-element-row:not(.example-expanded-row):active {\r\n    background: #efefef;\r\n  }\r\n  \r\n  .example-element-row td {\r\n    border-bottom-width: 0;\r\n  }\r\n  \r\n  .example-element-detail {\r\n    overflow: hidden;\r\n    display: flex;\r\n  }\r\n  \r\n  .example-element-diagram {\r\n    min-width: 80px;\r\n    border: 2px solid black;\r\n    padding: 8px;\r\n    font-weight: lighter;\r\n    margin: 8px 0;\r\n    height: 104px;\r\n  }\r\n  \r\n  .example-element-symbol {\r\n    font-weight: bold;\r\n    font-size: 40px;\r\n    line-height: normal;\r\n  }\r\n  \r\n  .example-element-description {\r\n    padding: 16px;\r\n  }\r\n  \r\n  .example-element-description-attribution {\r\n    opacity: 0.5;\r\n  }\r\n  \r\n  .element-margin{\r\n      margin-top: 1.5%;\r\n      margin-bottom: 1.5%;\r\n    text-transform: uppercase;\r\n\r\n  }\r\n  \r\n  .field{\r\n      font-weight: bolder;\r\n      background: #fbbc04;\r\n      margin-right: 5%;\r\n  }\r\n  \r\n  .label-accent{\r\n    background: #fbbc04;\r\n  }\r\n  \r\n  .button-padding{\r\n    margin-left: 2%;\r\n  }\r\n  \r\n  .btn-primary:hover {\r\n    color: #fff;\r\n    background-color: #343a40;\r\n   \r\n}\r\n  \r\n  .btn-black{\r\n    background: #343a40;\r\n    color: white;\r\n}\r\n  \r\n  .btn-black:hover{\r\n    background: #fbbc04;\r\n    color: white;\r\n}\r\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/dash-board/activity/activity.component.ts":
/*!***********************************************************!*\
  !*** ./src/app/dash-board/activity/activity.component.ts ***!
  \***********************************************************/
/*! exports provided: ActivityComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActivityComponent", function() { return ActivityComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! sweetalert2 */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _model_activity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../model/activity */ "./src/app/dash-board/model/activity.ts");
/* harmony import */ var src_app_core_model_listDTO__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/core/model/listDTO */ "./src/app/core/model/listDTO.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _service_garage_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../service/garage.service */ "./src/app/dash-board/service/garage.service.ts");
/* harmony import */ var src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/core/service/message.service */ "./src/app/core/service/message.service.ts");
/* harmony import */ var _service_bay_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../service/bay.service */ "./src/app/dash-board/service/bay.service.ts");
/* harmony import */ var _service_activity_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../service/activity.service */ "./src/app/dash-board/service/activity.service.ts");
/* harmony import */ var _service_component_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../service/component.service */ "./src/app/dash-board/service/component.service.ts");
/* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
/* harmony import */ var _service_activity_state_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../service/activity-state.service */ "./src/app/dash-board/service/activity-state.service.ts");
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! file-saver */ "./node_modules/file-saver/dist/FileSaver.min.js");
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(file_saver__WEBPACK_IMPORTED_MODULE_12__);













let ActivityComponent = class ActivityComponent {
    constructor(garageService, messageHandler, bayService, activityService, componentService, stateService) {
        this.garageService = garageService;
        this.messageHandler = messageHandler;
        this.bayService = bayService;
        this.activityService = activityService;
        this.componentService = componentService;
        this.stateService = stateService;
        this.textoListar = "EN PROCESO";
        this.editing = false;
        this.tittlesFilter = ['OT', 'TERMINADOS', 'ASIGNADOS'];
        this.attributesFilter = ["dto.ot", "deleted", 'assigned', "component", "state", "bay"];
        this.typeFilters = ['text', 'deleted', 'deleted', 'object'];
        this.initialized = 0;
        this.isFirstTime = true;
        this.dataSource = ELEMENT_DATA;
        this.columnsToDisplay = ['Estado', 'Componente', 'Orden de Trabajo'];
    }
    ngOnInit() {
        this.garages = new Array();
        this.listGarage();
        this.activity = new _model_activity__WEBPACK_IMPORTED_MODULE_2__["Activity"]();
        this.activities = new Array();
        this.bays = new Array();
        this.states = new Array();
        this.components = new Array();
        this.listComponents();
        this.listStates();
        this.listActivities();
        this.listBaysByUser();
        this.arrayObject = new Array();
        this.arrayResults = new Array();
        this.onFilter = new src_app_core_model_listDTO__WEBPACK_IMPORTED_MODULE_3__["ListDTO"](new _model_activity__WEBPACK_IMPORTED_MODULE_2__["Activity"]());
        this.onFilter.deleted = false;
    }
    listGarage() {
        this.garageService.list({ page: 0, size: 300 }).subscribe(data => {
            if (data) {
                this.garages = data.content;
            }
            else {
                this.garages = [];
            }
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    listBaysByGarage(event) {
        this.activity.garageId = this.garageSelected.id;
        this.bayService.findByGarage(this.garageSelected).subscribe(data => {
            if (data) {
                this.bays = data;
            }
            else {
                this.bays = [];
            }
        });
    }
    listBaysByUser() {
        this.bayService.getBaysByUser().subscribe(data => {
            if (data) {
                this.bays = data;
                this.putNameToFilter();
                this.initialized++;
                console.log(this.initialized, " bays");
                if (this.isFirstTime == true) {
                    this.arrayObject.push(this.bays);
                    this.tittlesFilter.push('BAHIA');
                    this.arrayResults.push("-1");
                    this.isFirstTime = false;
                }
            }
            else {
                this.bays = [];
            }
        }, error => {
            console.log(this.initialized, "fallo", "bays");
            this.messageHandler.errorHandler(error);
        });
    }
    putNameToFilter() {
        this.bays.forEach(element => {
            element.name = element.bayNumber;
        });
    }
    saveActivity() {
        let msn = "";
        if (this.editing == false) {
            msn = this.valid();
        }
        if ("" == msn) {
            /*    if(this.garageSelected){
                  this.activity.garageId = this.garageSelected.id;
                  this.activity.garageName = this.garageSelected.name;
                }*/
            if (this.baySelected) {
                console.log(this.activity, "actividad", this.editing);
                if (this.editing == true && this.activity.bayId) {
                    console.log("entrando");
                    this.activity.oldBay = this.activity.bayId;
                }
                this.activity.bayNumber = this.baySelected.id;
                this.activity.bayId = this.baySelected.id;
            }
            if (this.stateSelected) {
                this.activity.stateName = this.stateSelected.name;
                this.activity.color = this.stateSelected.color;
                this.activity.activityStateCode = this.stateSelected.code;
            }
            if (this.componentSelected) {
                this.activity.componentName = this.componentSelected.name;
                this.activity.componentCode = this.componentSelected.code;
            }
            this.activityService.save(this.activity).subscribe(data => {
                if (data) {
                    this.messageHandler.commonMessage("Guardado exitosamente", "success");
                    this.listActivities();
                    this.listBaysByUser();
                    this.clear();
                }
            }, error => {
                this.messageHandler.errorHandler(error);
            });
        }
        else {
            this.messageHandler.commonMessage(msn, "error");
        }
    }
    listActivities(dto = { page: 0, size: 3000, deleted: false }) {
        console.log(dto, "a filtrar");
        this.activityService.list(dto).subscribe(data => {
            this.onFilter = new src_app_core_model_listDTO__WEBPACK_IMPORTED_MODULE_3__["ListDTO"](new _model_activity__WEBPACK_IMPORTED_MODULE_2__["Activity"]());
            if (data) {
                this.activities = data.content;
                console.log(data, "bahias retornadas");
                this.constructDataSource();
            }
            else {
                this.activities = [];
            }
            this.clear();
        }, error => {
            this.clear();
            this.messageHandler.errorHandler(error);
        });
    }
    valid() {
        let msn = "";
        if (!this.stateSelected)
            msn += "Debe seleccionar un un estado;";
        return msn;
    }
    clear() {
        this.activity = new _model_activity__WEBPACK_IMPORTED_MODULE_2__["Activity"]();
        this.garageSelected = null;
        this.baySelected = null;
        this.stateSelected = null;
        this.componentSelected = null;
        this.editing = false;
    }
    listComponents() {
        this.componentService.list({ page: 0, size: 3000 }).subscribe(data => {
            if (data) {
                this.components = data.content;
                this.initialized++;
                console.log(this.initialized, "components");
                this.arrayObject.push(this.components);
                this.tittlesFilter.push('COMPONENTE');
                this.arrayResults.push("-1");
            }
            else {
                this.components = [];
            }
        }, error => {
            console.log(this.initialized, "fallo componentes");
            this.messageHandler.errorHandler(error);
        });
    }
    listStates() {
        this.stateService.list({ page: 0, size: 300 }).subscribe(data => {
            if (data) {
                this.states = data.content;
                this.initialized++;
                console.log(this.initialized, "estados");
                this.arrayObject.push(this.states);
                this.tittlesFilter.push('ESTADO');
                this.arrayResults.push("-1");
            }
            else {
                this.states = [];
            }
        }, error => {
            console.log(this.initialized, "fallo statdos");
            this.messageHandler.errorHandler(error);
        });
    }
    constructDataSource() {
        let dataSource = new Array();
        let data;
        this.activities.forEach(element => {
            data = {
                id: element.id,
                bayId: element.bayId,
                garageId: element.garageId,
                workOrder: element.workOrder,
                componentCode: element.componentCode,
                bayNumber: element.bayNumber,
                garageName: element.garageName,
                description: element.description,
                activityStateCode: element.activityStateCode,
                color: element.color,
                componentName: element.componentName,
                stateName: element.stateName
            };
            dataSource.push(data);
        });
        this.dataSource = dataSource;
    }
    getValue(column, element) {
        if (column == "Id")
            return element['id'];
        if (column == "Estado")
            return element['stateName'];
        if (column == 'Componente')
            return element['componentName'];
        if (column == "Orden de Trabajo") {
            let cell = element['workOrder'];
            if (cell)
                return cell;
            else
                return "No definida";
        }
    }
    edit(element) {
        this.activity = element;
        this.editing = true;
    }
    delete(element) {
        if (element && element.id) {
            sweetalert2__WEBPACK_IMPORTED_MODULE_1___default.a.fire({
                title: "Está seguro?",
                text: "Vas a terminar esta actividad",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: "No"
            })
                .then((willDelete) => {
                if (willDelete.value) {
                    this.activityService.delete(element).subscribe(data => {
                        if (data) {
                            this.messageHandler.commonMessage("Se termino actividad exitosamente", "success");
                            this.listActivities();
                            this.listBaysByUser();
                            this.clear();
                        }
                    }, error => {
                        this.messageHandler.errorHandler(error);
                    });
                }
            });
        }
        else {
            this.messageHandler.commonMessage("Debe especificar una actividad a eliminar", "info", "");
        }
    }
    downloadReport() {
        this.bayService.createFile().subscribe(data => {
            Object(file_saver__WEBPACK_IMPORTED_MODULE_12__["saveAs"])(data, 'bahias.xlsx');
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    getSate(item) {
        if (item.stateString) {
            return item.stateString;
        }
        else {
            return item.bayState;
        }
    }
    filter(event) {
        let dto = new src_app_core_model_listDTO__WEBPACK_IMPORTED_MODULE_3__["ListDTO"](new _model_activity__WEBPACK_IMPORTED_MODULE_2__["Activity"]());
        let activityFilter = new _model_activity__WEBPACK_IMPORTED_MODULE_2__["Activity"]();
        if (event.BAHIA) {
            let bay = JSON.parse(event.BAHIA);
            activityFilter.bayId = bay.id;
            activityFilter.bayNumber = bay.bayNumber;
            activityFilter.garageId = bay.garageId;
            activityFilter.garageName = bay.garageName;
        }
        if (event.COMPONENTE) {
            let component = JSON.parse(event.COMPONENTE);
            activityFilter.componentCode = component.code;
            activityFilter.componentName = component.name;
        }
        if (event.ESTADO) {
            let state = JSON.parse(event.ESTADO);
            activityFilter.stateName = state.name;
            activityFilter.activityStateCode = state.code;
        }
        if (event.principal.dto.ot) {
            activityFilter.workOrder = event.principal.dto.ot;
        }
        console.log(event, "esto es");
        if (event.principal.assigned) {
            dto.assigned = event.principal.assigned;
        }
        if (event.principal.deleted) {
            dto.deleted = event.principal.deleted;
        }
        console.log(dto, "aqui esta tu dto");
        dto.dto = activityFilter;
        console.log(dto);
        this.listActivities(dto);
    }
};
ActivityComponent.ctorParameters = () => [
    { type: _service_garage_service__WEBPACK_IMPORTED_MODULE_5__["GarageService"] },
    { type: src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_6__["MessageService"] },
    { type: _service_bay_service__WEBPACK_IMPORTED_MODULE_7__["BayService"] },
    { type: _service_activity_service__WEBPACK_IMPORTED_MODULE_8__["ActivityService"] },
    { type: _service_component_service__WEBPACK_IMPORTED_MODULE_9__["ComponentService"] },
    { type: _service_activity_state_service__WEBPACK_IMPORTED_MODULE_11__["ActivityStateService"] }
];
ActivityComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["Component"])({
        selector: 'app-activity',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./activity.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/activity/activity.component.html")).default,
        animations: [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_10__["trigger"])('detailExpand', [
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_10__["state"])('collapsed', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_10__["style"])({ height: '0px', minHeight: '0' })),
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_10__["state"])('expanded', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_10__["style"])({ height: '*' })),
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_10__["transition"])('expanded <=> collapsed', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_10__["animate"])('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            ]),
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./activity.component.css */ "./src/app/dash-board/activity/activity.component.css")).default]
    })
], ActivityComponent);

const ELEMENT_DATA = [];


/***/ }),

/***/ "./src/app/dash-board/bay/bay.component.css":
/*!**************************************************!*\
  !*** ./src/app/dash-board/bay/bay.component.css ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".shadow-element{\r\n    box-shadow: 17px 9px 24px 1px rgba(0,0,0,0.75);\r\n  }\r\n\r\n.texture{\r\n  transition: all 0.3s;\r\n  background-image: url('meta-texture.jpg');\r\n  opacity: 0.5;\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  position: relative;\r\n  height: 50px;\r\n}\r\n\r\n.label{\r\n  background: black;\r\n  color: white;\r\n  font-size: medium;\r\nborder-radius: 10px;\r\nfont-weight: bolder;\r\ntext-transform: uppercase;\r\npadding: 5px;\r\n}\r\n\r\n.item-title{\r\n  text-align: center;\r\n   display: inherit;\r\n}\r\n\r\n.item-col{\r\n  margin-top: 20px;\r\n}\r\n\r\n.button-group-style{\r\n  position: fixed;\r\n  text-align: center;\r\n  padding-top: 5%;\r\n  \r\n  bottom: 10px;\r\n\r\n\r\n}\r\n\r\n.shadow-element{\r\n  box-shadow: 17px 9px 24px 1px rgba(0,0,0,0.75);\r\n}\r\n\r\n.point{\r\n  width: 25px;\r\n  height: 25px;\r\n  border-radius: 25px;\r\n  background: green; \r\n  position: absolute;\r\n}\r\n\r\n#tshirt_container{\r\n  position: relative;\r\n}\r\n\r\n#tshirt_container .tshirt_layer, #tshirt_container canvas{\r\n  position: absolute;\r\n  display: table;\r\n}\r\n\r\n.button-padding{\r\n  margin-left: 2%;\r\n}\r\n\r\n.label-warning{\r\n  background: red;\r\n}\r\n\r\n.label-success{\r\n  background: #28e728;\r\n}\r\n\r\n.label-accent{\r\n  background: #fbbc04;\r\n}\r\n\r\n.item-info{\r\n  text-align: left;\r\n  display: inherit;\r\n  margin-top: 2%;\r\n  margin-bottom: 2%;\r\n  text-transform: uppercase;\r\n  font-weight: bolder;\r\n\r\n}\r\n\r\n.answer-item{\r\n  margin-left: 5%;\r\n  font-size: 150%;\r\n}\r\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/dash-board/bay/bay.component.ts":
/*!*************************************************!*\
  !*** ./src/app/dash-board/bay/bay.component.ts ***!
  \*************************************************/
/*! exports provided: BayComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BayComponent", function() { return BayComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _model_adaptergarage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../model/adaptergarage */ "./src/app/dash-board/model/adaptergarage.ts");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _service_garage_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../service/garage.service */ "./src/app/dash-board/service/garage.service.ts");
/* harmony import */ var _model_garage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../model/garage */ "./src/app/dash-board/model/garage.ts");
/* harmony import */ var src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/core/service/message.service */ "./src/app/core/service/message.service.ts");
/* harmony import */ var _model_bay__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../model/bay */ "./src/app/dash-board/model/bay.ts");
/* harmony import */ var _service_bay_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../service/bay.service */ "./src/app/dash-board/service/bay.service.ts");
/* harmony import */ var src_app_core_show_bay_show_bay_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! src/app/core/show-bay/show-bay.component */ "./src/app/core/show-bay/show-bay.component.ts");










let BayComponent = class BayComponent {
    constructor(garageService, messageHandler, bayService, dialog) {
        this.garageService = garageService;
        this.messageHandler = messageHandler;
        this.bayService = bayService;
        this.dialog = dialog;
        this.addGarage = 0;
        this.isDefiningBays = false;
        this.isLinear = true;
        this.bays = new Array();
        this.garages = new Array();
        this.garage = new _model_garage__WEBPACK_IMPORTED_MODULE_5__["Garage"]();
        this.bay = new _model_bay__WEBPACK_IMPORTED_MODULE_7__["Bay"]();
    }
    set inputTag(input) {
        if (!input) {
            return;
        }
        else {
            this.btnAditionalInfo = input;
        }
    }
    set inputTag2(input) {
        if (!input) {
            return;
        }
        else {
            this.btnCloseModal = input;
        }
    }
    ngOnInit() {
        this.listGarage();
    }
    ngAfterViewInit() {
    }
    onFileComplete(data) {
        this.imgURL = data;
        this.garage.urlLayout = data;
    }
    onClickImgBay(event) {
        if (this.isDefiningBays == true) {
            this.bay = new _model_bay__WEBPACK_IMPORTED_MODULE_7__["Bay"]();
            this.bay.garageName = this.garage.name;
            let percentY = (event.layerY / event.target.height) * 100;
            let percentX = (event.layerX / event.target.width) * 100;
            let point3 = '{"top": "' + percentY + '%", "left": "' + percentX + '%"}';
            this.bay.style = point3;
            this.btnAditionalInfo.nativeElement.click();
            this.isDefiningBays = false;
        }
    }
    giveStyle(item) {
        if (item)
            return JSON.parse(item);
    }
    putCursorPointer() {
        if (this.isDefiningBays)
            return { cursor: 'pointer' };
        else
            return { cursor: 'auto' };
    }
    listGarage() {
        this.garageService.list({ page: 0, size: 3000 }).subscribe(data => {
            if (data) {
                this.garages = data.content;
            }
            else {
                this.garages = [];
            }
        }, err => {
            this.messageHandler.errorHandler(err);
        });
    }
    defineBay() {
        this.isDefiningBays = true;
    }
    revert() {
        this.bays.pop();
    }
    saveBay() {
        let msn = false;
        if (this.bay.bayNumber) {
            if (this.bays.length > 0) {
                this.bays.forEach(element => {
                    if (element.bayNumber == this.bay.bayNumber) {
                        this.messageHandler.commonMessage("Nombre de bahía ya definido", "error");
                        msn = true;
                    }
                });
            }
            if (msn == false) {
                this.btnCloseModal.nativeElement.click();
                this.bays.push(this.bay);
            }
            else {
                return;
            }
        }
        else {
            this.messageHandler.commonMessage("Debe definir un numero de bahía valido", "error");
        }
    }
    restartBays() {
        this.bays = new Array();
    }
    deletedLastOne() {
        this.bays.pop();
    }
    isFirstStepComplete() {
        if (!this.imgURL)
            return false;
        if (!this.garage.name)
            return false;
        if (!this.garage.city)
            return false;
        return true;
    }
    isSecondStepComplete() {
        return (this.bays && this.bays.length != 0);
    }
    giveMeName(string, max = 15) {
        if (string.length > 15)
            return string.substring(0, max) + "...";
        else
            return string;
    }
    saveGarage() {
        let adapter = new _model_adaptergarage__WEBPACK_IMPORTED_MODULE_1__["AdapterGarageBays"]();
        adapter.bays = this.bays;
        adapter.garage = this.garage;
        this.garageService.saveList(adapter).subscribe(data => {
            if (data) {
                this.messageHandler.commonMessage("Taller guardado con exito", "success", "");
                this.cancel();
            }
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    restart() {
        this.bays = new Array();
        this.bay = new _model_bay__WEBPACK_IMPORTED_MODULE_7__["Bay"]();
        this.addGarage = 0;
        this.imgURL = null;
        this.listGarage();
    }
    newGarage() {
        this.addGarage = 1;
        this.bays = new Array();
        this.bay = new _model_bay__WEBPACK_IMPORTED_MODULE_7__["Bay"]();
        this.imgURL = null;
    }
    deleteBay(garage) {
        this.garageService.delete(garage).subscribe(data => {
            this.messageHandler.commonMessage("Taller eliminado exitosamente", "success", "");
            this.listGarage();
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    moveBayRequired(item, event) {
        this.bayToMove = item;
    }
    movingOnBay(event) {
        if (this.bayToMove && this.bayToMove != null) {
            this.bayToMove.style = this.defineCoordinate(event, "movingon");
        }
    }
    defineCoordinate(event, string) {
        let percentY = (event.layerY / event.target.height) * 100;
        let percentX = (event.layerX / event.target.width) * 100;
        let point3 = '{"top": "' + percentY + '%", "left": "' + percentX + '%"}';
        return point3;
    }
    finishMoveBay(event) {
        if (this.bayToMove) {
            if (event.target.height) {
                this.bayToMove.style = this.defineCoordinate(event, "finishMoveBay");
            }
            this.bayToMove = null;
        }
        this.bayToMove = null;
    }
    showInfoBay(bay) {
        const bayBefore = new _model_bay__WEBPACK_IMPORTED_MODULE_7__["Bay"]();
        bayBefore.bayNumber = bay.bayNumber;
        bayBefore.excludeBay = bay.excludeBay;
        if (this.bayToMove) {
            // this.bayToMove.style = this.defineCoordinate(event, "finishMoveBay");
            this.bayToMove = null;
        }
        const dialog = this.dialog.open(src_app_core_show_bay_show_bay_component__WEBPACK_IMPORTED_MODULE_9__["ShowBayComponent"], {
            data: { bay: bay },
        });
        dialog.afterClosed().subscribe(data => {
            if (data) {
                bay.excludeBay = data.excludeBay;
                if (bayBefore.bayNumber != data.bayNumber) {
                    let msn = false;
                    this.bays.forEach(element => {
                        if (element.bayNumber == data.bayNumber) {
                            this.messageHandler.commonMessage("Nombre de bahía ya definido", "error");
                            msn = true;
                            return;
                        }
                    });
                    if (msn == false) {
                        bay.bayNumber = data.bayNumber;
                    }
                }
            }
        });
    }
    editBay(item) {
        this.addGarage = 1;
        this.imgURL = item.urlLayout;
        this.garage = item;
        this.bayService.findByGarage(item).subscribe(data => {
            this.bays = data;
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    cancel() {
        this.addGarage = 0;
    }
};
BayComponent.ctorParameters = () => [
    { type: _service_garage_service__WEBPACK_IMPORTED_MODULE_4__["GarageService"] },
    { type: src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_6__["MessageService"] },
    { type: _service_bay_service__WEBPACK_IMPORTED_MODULE_8__["BayService"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialog"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewChild"])('btnAditionalInfo', { read: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"], static: false })
], BayComponent.prototype, "inputTag", null);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewChild"])('btnCloseModal', { read: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"], static: false })
], BayComponent.prototype, "inputTag2", null);
BayComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"])({
        selector: 'app-bay',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./bay.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/bay/bay.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./bay.component.css */ "./src/app/dash-board/bay/bay.component.css")).default]
    })
], BayComponent);



/***/ }),

/***/ "./src/app/dash-board/dash-board.module.ts":
/*!*************************************************!*\
  !*** ./src/app/dash-board/dash-board.module.ts ***!
  \*************************************************/
/*! exports provided: DashBoardModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DashBoardModule", function() { return DashBoardModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _bay_bay_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./bay/bay.component */ "./src/app/dash-board/bay/bay.component.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _material_material_module__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../material/material.module */ "./src/app/material/material.module.ts");
/* harmony import */ var _activity_activity_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./activity/activity.component */ "./src/app/dash-board/activity/activity.component.ts");
/* harmony import */ var _layout_layout_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./layout/layout.component */ "./src/app/dash-board/layout/layout.component.ts");
/* harmony import */ var _state_state_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./state/state.component */ "./src/app/dash-board/state/state.component.ts");
/* harmony import */ var _piece_piece_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./piece/piece.component */ "./src/app/dash-board/piece/piece.component.ts");
/* harmony import */ var ngx_color_picker__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ngx-color-picker */ "./node_modules/ngx-color-picker/dist/ngx-color-picker.es5.js");
/* harmony import */ var _traffic_light_traffic_light_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./traffic-light/traffic-light.component */ "./src/app/dash-board/traffic-light/traffic-light.component.ts");
/* harmony import */ var _core_core_module__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../core/core.module */ "./src/app/core/core.module.ts");
/* harmony import */ var _indicador_speed_indicador_speed_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./indicador-speed/indicador-speed.component */ "./src/app/dash-board/indicador-speed/indicador-speed.component.ts");
/* harmony import */ var _number_indicators_number_indicators_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./number-indicators/number-indicators.component */ "./src/app/dash-board/number-indicators/number-indicators.component.ts");
/* harmony import */ var _indicator_master_indicator_master_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./indicator-master/indicator-master.component */ "./src/app/dash-board/indicator-master/indicator-master.component.ts");


















let DashBoardModule = class DashBoardModule {
};
DashBoardModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_bay_bay_component__WEBPACK_IMPORTED_MODULE_3__["BayComponent"], _activity_activity_component__WEBPACK_IMPORTED_MODULE_7__["ActivityComponent"], _layout_layout_component__WEBPACK_IMPORTED_MODULE_8__["LayoutComponent"], _state_state_component__WEBPACK_IMPORTED_MODULE_9__["StateComponent"], _piece_piece_component__WEBPACK_IMPORTED_MODULE_10__["PieceComponent"], _traffic_light_traffic_light_component__WEBPACK_IMPORTED_MODULE_12__["TrafficLightComponent"], _indicador_speed_indicador_speed_component__WEBPACK_IMPORTED_MODULE_14__["IndicadorSpeedComponent"], _number_indicators_number_indicators_component__WEBPACK_IMPORTED_MODULE_15__["NumberIndicatorsComponent"], _indicator_master_indicator_master_component__WEBPACK_IMPORTED_MODULE_16__["IndicatorMasterComponent"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormsModule"],
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_5__["BrowserModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_4__["ReactiveFormsModule"],
            _material_material_module__WEBPACK_IMPORTED_MODULE_6__["MaterialModule"],
            ngx_color_picker__WEBPACK_IMPORTED_MODULE_11__["ColorPickerModule"],
            _core_core_module__WEBPACK_IMPORTED_MODULE_13__["CoreModule"]
        ]
    })
], DashBoardModule);



/***/ }),

/***/ "./src/app/dash-board/indicador-speed/indicador-speed.component.css":
/*!**************************************************************************!*\
  !*** ./src/app/dash-board/indicador-speed/indicador-speed.component.css ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".btn-primary{\r\n    background: #fbbc04;\r\n    border: none;\r\n}\r\n\r\n\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvZGFzaC1ib2FyZC9pbmRpY2Fkb3Itc3BlZWQvaW5kaWNhZG9yLXNwZWVkLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxtQkFBbUI7SUFDbkIsWUFBWTtBQUNoQiIsImZpbGUiOiJzcmMvYXBwL2Rhc2gtYm9hcmQvaW5kaWNhZG9yLXNwZWVkL2luZGljYWRvci1zcGVlZC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmJ0bi1wcmltYXJ5e1xyXG4gICAgYmFja2dyb3VuZDogI2ZiYmMwNDtcclxuICAgIGJvcmRlcjogbm9uZTtcclxufVxyXG5cclxuXHJcbiJdfQ== */");

/***/ }),

/***/ "./src/app/dash-board/indicador-speed/indicador-speed.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/dash-board/indicador-speed/indicador-speed.component.ts ***!
  \*************************************************************************/
/*! exports provided: IndicadorSpeedComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IndicadorSpeedComponent", function() { return IndicadorSpeedComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _core_bar_graphics_modal_bar_graphics_modal_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../../core/bar-graphics-modal/bar-graphics-modal.component */ "./src/app/core/bar-graphics-modal/bar-graphics-modal.component.ts");
/* harmony import */ var _core_bar_graphic_modal_bar_graphic_modal_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../../core/bar-graphic-modal/bar-graphic-modal.component */ "./src/app/core/bar-graphic-modal/bar-graphic-modal.component.ts");
/* harmony import */ var _core_just_info_dialog_just_info_dialog_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./../../core/just-info-dialog/just-info-dialog.component */ "./src/app/core/just-info-dialog/just-info-dialog.component.ts");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _model_garage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../model/garage */ "./src/app/dash-board/model/garage.ts");
/* harmony import */ var src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/core/service/message.service */ "./src/app/core/service/message.service.ts");
/* harmony import */ var _service_garage_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../service/garage.service */ "./src/app/dash-board/service/garage.service.ts");
/* harmony import */ var _service_indicator_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../service/indicator.service */ "./src/app/dash-board/service/indicator.service.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _model_indicator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../model/indicator */ "./src/app/dash-board/model/indicator.ts");












let IndicadorSpeedComponent = class IndicadorSpeedComponent {
    constructor(garageService, messageHandler, indicatorService, dialog, decimalPipe) {
        this.garageService = garageService;
        this.messageHandler = messageHandler;
        this.indicatorService = indicatorService;
        this.dialog = dialog;
        this.decimalPipe = decimalPipe;
        this.showCake = false;
        this.colorsCake = [
            {
                backgroundColor: ['rgba(191, 83, 77, 1)', 'rgba(76, 131, 187, 1)', 'rgba(134, 132, 164, 1)',
                    'rgba(221, 226, 237, 1)', 'rgba(71, 196, 106, 1)', 'rgba(242, 245, 54, 1)',
                    'rgba(234, 237, 50, 1)', 'rgba(44, 222, 213, 1)'],
            },
        ];
        this.errorShowCake = false;
        this.errorShowCakeBay = false;
        this.colorsBays = [
            {
                backgroundColor: ["#fff"],
            },
        ];
        this.months = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"];
        this.legendOptions = { position: 'bottom', align: "center" };
        this.arrayBarsGraphics = [];
    }
    set inputTag2(input) {
        if (!input) {
            return;
        }
        else {
            this.btnHamburger = input;
        }
    }
    ngOnInit() {
        this.indicators = new Array();
        this.listGarage();
        this.listIndicators();
        this.generalGarage = new _model_garage__WEBPACK_IMPORTED_MODULE_6__["Garage"]();
        this.generalGarage.name = "sin";
        this.garageSelected = new _model_garage__WEBPACK_IMPORTED_MODULE_6__["Garage"]();
        this.garageSelected.name = "sin";
    }
    listGarage() {
        this.garageService.list({ page: 0, size: 300 }).subscribe(data => {
            if (data) {
                this.garages = data.content;
            }
            else {
                this.garages = [];
            }
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    listIndicators() {
        this.indicatorService.getList({ page: 0, size: 3000 }).subscribe(data => {
            if (data) {
                this.indicatorsData = data.content;
            }
            //this.listIndicatorsByGarage();
            this.listIndicatorsByGarageAll();
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    listIndicatorsByGarageAll() {
        this.indicators = [];
        this.arrayBarsGraphics = [];
        let date = Object(_angular_common__WEBPACK_IMPORTED_MODULE_10__["formatDate"])(new Date(), 'yyyy-MM-dd', 'en');
        date += ' 00:00:00';
        this.indicatorService.getAllIndicators({ date: date, garage: this.garageSelected, indicators: this.indicatorsData }).subscribe(data => {
            console.log("estos son", data);
            this.putIndicatorAndGraphic(data);
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    putIndicatorAndGraphic(data) {
        console.log(data, "asi fue el resultado");
        data.forEach(element => {
            if (element.typeIndicator == "SPEEDOMETER") {
                console.log("Asi llegan desde afuera");
                this.indicators.push(element);
            }
            else if (element.typeIndicator == "CAKE") {
                if (element.description.indexOf("cliente") != -1) {
                    if (element.response.length > 0) {
                        this.putResultCustomerCake(element.response);
                    }
                    else {
                        this.errorShowCake = true;
                    }
                }
                else if (element.description.indexOf("bahia") != -1) {
                    this.putResultBayCake(element.response);
                }
            }
            else if (element.typeIndicator == "BAR") {
                if (element.description.indexOf("cliente más representativo") != -1) {
                    this.putBarResults(element);
                }
                else {
                    this.putBarResults(element);
                }
            }
        });
    }
    putResultBayCake(array) {
        this.resultsCakeBay = new Array();
        this.resultsLabelsBay = new Array();
        let arrayColors = new Array();
        array.forEach(element => {
            this.resultsCakeBay.push(element.counter);
            if (element.stateString) {
                this.resultsLabelsBay.push(element.stateString);
                arrayColors.push("#" + element.color);
            }
            else {
                this.resultsLabelsBay.push("LIBRE");
                arrayColors.push("#08cc40");
            }
        });
        this.colorsBays = [{
                backgroundColor: arrayColors
            }];
        this.showCake = true;
        this.errorShowCakeBay = false;
    }
    putResultCustomerCake(array) {
        this.resultsCake = new Array();
        this.resultsLabels = new Array();
        let accumClients = 0;
        array.forEach(element => {
            if (element.custType == 'X' || element.custType == 'x') {
                this.resultsCake.push(element.count);
                this.resultsLabels.push('CLIENTES EXTERNOS');
            }
            else {
                accumClients += element.count;
            }
        });
        this.resultsCake.push(accumClients);
        this.resultsLabels.push('CLIENTES INTERNOS  ');
        this.showCake = true;
        this.errorShowCake = false;
    }
    generateHistoryReport() {
        this.indicatorService.generateHistoryReport().subscribe(data => {
            this.messageHandler.commonMessage("Histórico generado con éxito", "success", "");
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    showInfoOnDialog(indicator) {
        let tittle = "Descripción";
        if (indicator.name) {
            tittle += " del " + indicator.name;
        }
        const DialogRef = this.dialog.open(_core_just_info_dialog_just_info_dialog_component__WEBPACK_IMPORTED_MODULE_3__["JustInfoDialogComponent"], {
            width: '80%',
            data: { tittle: tittle, info: indicator.description }
        });
    }
    showTendencyDialog(indicator) {
        let list = new Array();
        let indicatorMonthly = new _model_indicator__WEBPACK_IMPORTED_MODULE_11__["Indicator"]();
        indicatorMonthly.graficType = "MONTHLYBAR";
        indicatorMonthly.indicatorProcedure = indicator.monthly;
        indicatorMonthly.indicatorName = indicator.response[0].name;
        if (this.garageSelected) {
            indicatorMonthly.indicatorZone = this.garageSelected.id;
        }
        list.push(indicatorMonthly);
        this.indicatorService.getIndicatorsMonthly(list).subscribe(data => {
            let labels = new Array();
            let dataRecive = new Array();
            if (data[0].response) {
                data[0].response.forEach(element => {
                    labels.push(element.monthString);
                    dataRecive.push(element.avg);
                });
            }
            const DialogTendencyRef = this.dialog.open(_core_bar_graphic_modal_bar_graphic_modal_component__WEBPACK_IMPORTED_MODULE_2__["BarGraphicModalComponent"], {
                width: '70%',
                data: { labels: labels, data: [{ data: dataRecive, label: "Mensual" }], title: indicator.title }
            });
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    showHistoryDialog(indicator) {
        console.log(indicator, "indicador recorrido");
        let list = new Array();
        for (let i = 1; i <= 12; i++) {
            let indicatorMonthly = new _model_indicator__WEBPACK_IMPORTED_MODULE_11__["Indicator"]();
            indicatorMonthly.graficType = "BAR";
            indicatorMonthly.indicatorProcedure = indicator.procedure;
            indicatorMonthly.period = i + "";
            indicatorMonthly.indicatorClassImplementation = indicator.classImplementation;
            indicatorMonthly.monthly = this.months[i - 1];
            if (this.garageSelected) {
                indicatorMonthly.indicatorZone = this.garageSelected.id;
            }
            list.push(indicatorMonthly);
        }
        this.indicatorService.getIndicatorsMonthly(list).subscribe(data => {
            let bars = new Array();
            data.forEach(responseIndicator => {
                let resultsLabels = new Array();
                let dataResult = new Array();
                responseIndicator.response.forEach(listBars => {
                    if (listBars.componentName) {
                        resultsLabels.push(listBars.componentName);
                        dataResult.push(listBars.totalComponents);
                    }
                    else if (listBars.customer) {
                        resultsLabels.push(listBars.customer);
                        dataResult.push(listBars.totalWip);
                    }
                });
                if (dataResult.length > 0) {
                    let builded = { barChartLabels: resultsLabels, barChartData: [{ data: dataResult, label: responseIndicator.monthly }] };
                    bars.push(builded);
                }
            });
            const DialogTendencyRef = this.dialog.open(_core_bar_graphics_modal_bar_graphics_modal_component__WEBPACK_IMPORTED_MODULE_1__["BarGraphicsModalComponent"], {
                width: '80%',
                data: { data: bars, legendOption: { align: 'center', position: 'top' }, title: indicator.title },
                maxHeight: '90vh'
            });
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    putBarResults(indicator) {
        let resultsLabelsIndicator = new Array();
        let dataResult = new Array();
        if (indicator.response.length > 0) {
            indicator.response.forEach(responseResult => {
                if (responseResult.componentName) {
                    resultsLabelsIndicator.push(responseResult.componentName);
                    dataResult.push(responseResult.totalComponents);
                }
                else if (responseResult.customer) {
                    resultsLabelsIndicator.push(responseResult.customer);
                    dataResult.push(Number(this.decimalPipe.transform(responseResult.totalWip, '1.2-2')));
                }
            });
            let buildedInfo = [{ data: dataResult, label: indicator.procedureName }];
            let itemArrayBar = { labels: resultsLabelsIndicator, info: buildedInfo, indicator: indicator };
            this.arrayBarsGraphics.push(itemArrayBar);
        }
        else {
            let buildedInfo = [{ data: dataResult, label: indicator.procedureName }];
            let itemArrayBar = { error: "El indicador " + indicator.procedureName + " No contiene información ", info: buildedInfo, indicator: indicator };
            this.arrayBarsGraphics.push(itemArrayBar);
        }
    }
};
IndicadorSpeedComponent.ctorParameters = () => [
    { type: _service_garage_service__WEBPACK_IMPORTED_MODULE_8__["GarageService"] },
    { type: src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_7__["MessageService"] },
    { type: _service_indicator_service__WEBPACK_IMPORTED_MODULE_9__["IndicatorService"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatDialog"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_10__["DecimalPipe"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_5__["ViewChild"])('sidebarCollapse', { read: _angular_core__WEBPACK_IMPORTED_MODULE_5__["ElementRef"], static: false })
], IndicadorSpeedComponent.prototype, "inputTag2", null);
IndicadorSpeedComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_5__["Component"])({
        selector: 'app-indicador-speed',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./indicador-speed.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/indicador-speed/indicador-speed.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./indicador-speed.component.css */ "./src/app/dash-board/indicador-speed/indicador-speed.component.css")).default]
    })
], IndicadorSpeedComponent);



/***/ }),

/***/ "./src/app/dash-board/indicator-master/indicator-master.component.css":
/*!****************************************************************************!*\
  !*** ./src/app/dash-board/indicator-master/indicator-master.component.css ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2Rhc2gtYm9hcmQvaW5kaWNhdG9yLW1hc3Rlci9pbmRpY2F0b3ItbWFzdGVyLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/dash-board/indicator-master/indicator-master.component.ts":
/*!***************************************************************************!*\
  !*** ./src/app/dash-board/indicator-master/indicator-master.component.ts ***!
  \***************************************************************************/
/*! exports provided: IndicatorMasterComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IndicatorMasterComponent", function() { return IndicatorMasterComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let IndicatorMasterComponent = class IndicatorMasterComponent {
    constructor() { }
    ngOnInit() {
    }
};
IndicatorMasterComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-indicator-master',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./indicator-master.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/indicator-master/indicator-master.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./indicator-master.component.css */ "./src/app/dash-board/indicator-master/indicator-master.component.css")).default]
    })
], IndicatorMasterComponent);



/***/ }),

/***/ "./src/app/dash-board/layout/layout.component.css":
/*!********************************************************!*\
  !*** ./src/app/dash-board/layout/layout.component.css ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".shadow-element{\r\n    box-shadow: 17px 9px 24px 1px rgba(0,0,0,0.75);\r\n  }\r\n\r\n.texture{\r\n  transition: all 0.3s;\r\n  background-image: url('meta-texture.jpg');\r\n  opacity: 0.5;\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  position: relative;\r\n  height: 50px;\r\n}\r\n\r\n.label{\r\n  background: black;\r\n  color: white;\r\n  font-size: medium;\r\nborder-radius: 10px;\r\nfont-weight: bolder;\r\ntext-transform: uppercase;\r\npadding: 5px;\r\n}\r\n\r\n.item-title{\r\n  text-align: center;\r\n   display: inherit;\r\n}\r\n\r\n.item-col{\r\n  margin-top: 20px;\r\n}\r\n\r\n.button-group-style{\r\n  position: fixed;\r\n  text-align: center;\r\n  padding-top: 5%;\r\n  \r\n  bottom: 10px;\r\n  left:  10%;\r\n\r\n\r\n}\r\n\r\n.shadow-element{\r\n  box-shadow: 17px 9px 24px 1px rgba(0,0,0,0.75);\r\n}\r\n\r\n.point{\r\n  width: 25px;\r\n  height: 25px;\r\n  border-radius: 25px;\r\n  position: absolute;\r\n  cursor: pointer;\r\n}\r\n\r\n.point-color{\r\n  width: 25px;\r\n  height: 25px;\r\n  border-radius: 25px;\r\n  \r\n}\r\n\r\n.point-free{\r\n    background: green; \r\n}\r\n\r\n.point-store{\r\n    background: #fbbc04; \r\n}\r\n\r\n.point-process{\r\n    background: rgb(238, 27, 27); \r\n}\r\n\r\n#tshirt_container{\r\n  position: relative;\r\n}\r\n\r\n#tshirt_container .tshirt_layer, #tshirt_container canvas{\r\n  position: absolute;\r\n  display: table;\r\n}\r\n\r\n.button-padding{\r\n  margin-left: 2%;\r\n}\r\n\r\n.label-warning{\r\n  background: red;\r\n}\r\n\r\n.label-success{\r\n  background: #28e728;\r\n}\r\n\r\n.label-accent{\r\n  background: #fbbc04;\r\n}\r\n\r\n.item-info{\r\n  text-align: left;\r\n  display: inherit;\r\n  margin-top: 2%;\r\n  margin-bottom: 2%;\r\n  text-transform: uppercase;\r\n  font-weight: bolder;\r\n\r\n}\r\n\r\n.answer-item{\r\n  margin-left: 5%;\r\n  font-size: 150%;\r\n}\r\n\r\n.btn-primary:hover{\r\n    background: #fbbc04;\r\n}\r\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/dash-board/layout/layout.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/dash-board/layout/layout.component.ts ***!
  \*******************************************************/
/*! exports provided: LayoutComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LayoutComponent", function() { return LayoutComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _service_activity_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../service/activity.service */ "./src/app/dash-board/service/activity.service.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _service_garage_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../service/garage.service */ "./src/app/dash-board/service/garage.service.ts");
/* harmony import */ var src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/core/service/message.service */ "./src/app/core/service/message.service.ts");
/* harmony import */ var _service_bay_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../service/bay.service */ "./src/app/dash-board/service/bay.service.ts");
/* harmony import */ var _model_bay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../model/bay */ "./src/app/dash-board/model/bay.ts");
/* harmony import */ var _service_activity_state_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../service/activity-state.service */ "./src/app/dash-board/service/activity-state.service.ts");
/* harmony import */ var src_app_core_service_work_order_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! src/app/core/service/work-order.service */ "./src/app/core/service/work-order.service.ts");









let LayoutComponent = class LayoutComponent {
    constructor(garageService, messageHandler, bayService, activityState, workOrderService, activityService) {
        this.garageService = garageService;
        this.messageHandler = messageHandler;
        this.bayService = bayService;
        this.activityState = activityState;
        this.workOrderService = workOrderService;
        this.activityService = activityService;
        this.firsTime = true;
        this.changing = false;
        this.editingPositionBay = false;
    }
    set inputTag2(input) {
        if (!input) {
            return;
        }
        else {
            this.closeModal = input;
        }
    }
    set inputTag3(input) {
        if (!input) {
            return;
        }
        else {
            this.closeModal = input;
        }
    }
    set inputTag(input) {
        if (!input) {
            return;
        }
        else {
            this.btnAditionalInfo = input;
        }
    }
    ngOnInit() {
        this.garages = new Array();
        this.bays = new Array();
        this.listGarage();
        this.states = new Array();
        window.clearInterval();
        this.listActivityState();
        this.infoBay = new _model_bay__WEBPACK_IMPORTED_MODULE_6__["Bay"]();
    }
    getLayoutByGarage(garage) {
        this.garage = garage;
        this.bayService.findByGarage(garage).subscribe(data => {
            if (data) {
                this.bays = data;
                this.imgURL = this.garage.urlLayout;
                if (this.firsTime == true) {
                    this.listAgain();
                }
            }
            else {
                this.bays = [];
            }
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    listGarage() {
        this.garageService.list({ page: 0, size: 3000 }).subscribe(data => {
            if (data) {
                this.garages = data.content;
            }
            else {
                this.garages = [];
            }
        }, err => {
            this.messageHandler.errorHandler(err);
        });
    }
    giveStyle(item) {
        return JSON.parse(item);
    }
    getState(item) {
        if (item.bayState == "ON_FREE") {
            return true;
        }
        else {
            return false;
        }
    }
    listAgain() {
        let ctx = this;
        this.interval = setInterval(() => {
            ctx.getLayoutByGarage(ctx.garage);
            ctx.firsTime = false;
        }, 3000);
    }
    goBack() {
        window.clearInterval(this.interval);
        this.firsTime = true;
        this.listGarage();
        this.imgURL = null;
        this.garage = null;
        this.bays = [];
    }
    giveStyleWithColor(style, color) {
        let jsonStyle = JSON.parse(style);
        let all = { top: jsonStyle.top, left: jsonStyle.left, background: "#" + color };
        return all;
    }
    listActivityState() {
        this.activityState.list({ page: 0, size: 300 }).subscribe(data => {
            if (data) {
                this.states = data.content;
            }
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    getStyleState(item) {
        let style = { background: '#' + item.color };
        return style;
    }
    getInfoBay(item) {
        this.infoBay = item;
    }
    showAdditionalInfo(item) {
        if (item.workOrder) {
            this.workOrderService.findbyOt(item.workOrder).subscribe(data => {
                if (data) {
                    this.workOrderAditionalInfo = data;
                }
            }, error => {
                this.workOrderAditionalInfo = null;
            });
        }
    }
    terminateActivity(bay = this.infoBay) {
        this.bayService.terminateActivity(bay).subscribe(data => {
            this.closeModal.nativeElement.click();
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    isforTerminate() {
        return (this.infoBay && this.infoBay.activities && this.infoBay.activities.length == 1);
    }
    changeEditing() {
        this.editingPositionBay = true;
        this.closeModal.nativeElement.click();
    }
    onClickImgBay(event) {
        let percentY = (event.layerY / event.target.height) * 100;
        let percentX = (event.layerX / event.target.width) * 100;
        let point3 = '{"top": "' + percentY + '%", "left": "' + percentX + '%"}';
        this.infoBay.style = point3;
        this.updateBay();
    }
    updateBay() {
        this.bayService.save(this.infoBay).subscribe(data => {
            if (data) {
                this.editingPositionBay = false;
                this.getLayoutByGarage(this.garage);
                this.messageHandler.commonMessage("Bahía actualizada correctamente", "success", "Actualizado");
            }
        });
    }
    reassign(activity) {
        console.log(activity, "activity");
        this.reassignActivity = activity;
        window.clearInterval(this.interval);
    }
    reassignBay() {
        if (this.baySelected) {
            this.reassignActivity.oldBay = this.infoBay.id;
            this.reassignActivity.bayNumber = this.baySelected.id;
            this.reassignActivity.bayId = this.baySelected.id;
            this.activityService.save(this.reassignActivity).subscribe(data => {
                this.messageHandler.commonMessage("Actividad Reasignada correctamente", "success", "Reasignación");
                this.closeModal.nativeElement.click();
                this.reassignActivity = null;
                this.listAgain();
            });
        }
        else {
            this.messageHandler.commonMessage("Debe especificar una nueva bahía para reasignar", "info", "");
        }
    }
    getSate(item) {
        if (item.stateString) {
            return item.stateString;
        }
        else {
            return item.bayState;
        }
    }
    giveMeName(string, max = 15) {
        if (string.length > 15)
            return string.substring(0, max) + "...";
        else
            return string;
    }
};
LayoutComponent.ctorParameters = () => [
    { type: _service_garage_service__WEBPACK_IMPORTED_MODULE_3__["GarageService"] },
    { type: src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: _service_bay_service__WEBPACK_IMPORTED_MODULE_5__["BayService"] },
    { type: _service_activity_state_service__WEBPACK_IMPORTED_MODULE_7__["ActivityStateService"] },
    { type: src_app_core_service_work_order_service__WEBPACK_IMPORTED_MODULE_8__["WorkOrderService"] },
    { type: _service_activity_service__WEBPACK_IMPORTED_MODULE_1__["ActivityService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["ViewChild"])('btnCloseModal', { read: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ElementRef"], static: false })
], LayoutComponent.prototype, "inputTag2", null);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["ViewChild"])('btnCloseModal2', { read: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ElementRef"], static: false })
], LayoutComponent.prototype, "inputTag3", null);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["ViewChild"])('btnAditionalInfo', { read: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ElementRef"], static: false })
], LayoutComponent.prototype, "inputTag", null);
LayoutComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-layout',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./layout.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/layout/layout.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./layout.component.css */ "./src/app/dash-board/layout/layout.component.css")).default]
    })
], LayoutComponent);



/***/ }),

/***/ "./src/app/dash-board/model/activity.ts":
/*!**********************************************!*\
  !*** ./src/app/dash-board/model/activity.ts ***!
  \**********************************************/
/*! exports provided: Activity */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Activity", function() { return Activity; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var src_app_core_model_user_date_audit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! src/app/core/model/user-date-audit */ "./src/app/core/model/user-date-audit.ts");


class Activity extends src_app_core_model_user_date_audit__WEBPACK_IMPORTED_MODULE_1__["UserDateAudit"] {
    constructor() {
        super(...arguments);
        this.panelOpenState = false;
    }
}


/***/ }),

/***/ "./src/app/dash-board/model/activityState.ts":
/*!***************************************************!*\
  !*** ./src/app/dash-board/model/activityState.ts ***!
  \***************************************************/
/*! exports provided: ActivityState */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActivityState", function() { return ActivityState; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var src_app_core_model_user_date_audit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! src/app/core/model/user-date-audit */ "./src/app/core/model/user-date-audit.ts");


class ActivityState extends src_app_core_model_user_date_audit__WEBPACK_IMPORTED_MODULE_1__["UserDateAudit"] {
}


/***/ }),

/***/ "./src/app/dash-board/model/adaptergarage.ts":
/*!***************************************************!*\
  !*** ./src/app/dash-board/model/adaptergarage.ts ***!
  \***************************************************/
/*! exports provided: AdapterGarageBays */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdapterGarageBays", function() { return AdapterGarageBays; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class AdapterGarageBays {
}


/***/ }),

/***/ "./src/app/dash-board/model/bay.ts":
/*!*****************************************!*\
  !*** ./src/app/dash-board/model/bay.ts ***!
  \*****************************************/
/*! exports provided: Bay */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bay", function() { return Bay; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var src_app_core_model_user_date_audit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! src/app/core/model/user-date-audit */ "./src/app/core/model/user-date-audit.ts");


class Bay extends src_app_core_model_user_date_audit__WEBPACK_IMPORTED_MODULE_1__["UserDateAudit"] {
}


/***/ }),

/***/ "./src/app/dash-board/model/componentModel.ts":
/*!****************************************************!*\
  !*** ./src/app/dash-board/model/componentModel.ts ***!
  \****************************************************/
/*! exports provided: ComponentModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentModel", function() { return ComponentModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var src_app_core_model_user_date_audit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! src/app/core/model/user-date-audit */ "./src/app/core/model/user-date-audit.ts");


class ComponentModel extends src_app_core_model_user_date_audit__WEBPACK_IMPORTED_MODULE_1__["UserDateAudit"] {
}


/***/ }),

/***/ "./src/app/dash-board/model/garage.ts":
/*!********************************************!*\
  !*** ./src/app/dash-board/model/garage.ts ***!
  \********************************************/
/*! exports provided: Garage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Garage", function() { return Garage; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Garage {
}


/***/ }),

/***/ "./src/app/dash-board/model/indicator.ts":
/*!***********************************************!*\
  !*** ./src/app/dash-board/model/indicator.ts ***!
  \***********************************************/
/*! exports provided: Indicator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Indicator", function() { return Indicator; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Indicator {
}


/***/ }),

/***/ "./src/app/dash-board/number-indicators/number-indicators.component.css":
/*!******************************************************************************!*\
  !*** ./src/app/dash-board/number-indicators/number-indicators.component.css ***!
  \******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2Rhc2gtYm9hcmQvbnVtYmVyLWluZGljYXRvcnMvbnVtYmVyLWluZGljYXRvcnMuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/dash-board/number-indicators/number-indicators.component.ts":
/*!*****************************************************************************!*\
  !*** ./src/app/dash-board/number-indicators/number-indicators.component.ts ***!
  \*****************************************************************************/
/*! exports provided: NumberIndicatorsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NumberIndicatorsComponent", function() { return NumberIndicatorsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _model_indicator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../model/indicator */ "./src/app/dash-board/model/indicator.ts");
/* harmony import */ var _core_bar_graphic_modal_bar_graphic_modal_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../../core/bar-graphic-modal/bar-graphic-modal.component */ "./src/app/core/bar-graphic-modal/bar-graphic-modal.component.ts");
/* harmony import */ var _core_just_info_dialog_just_info_dialog_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./../../core/just-info-dialog/just-info-dialog.component */ "./src/app/core/just-info-dialog/just-info-dialog.component.ts");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _model_garage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../model/garage */ "./src/app/dash-board/model/garage.ts");
/* harmony import */ var _service_garage_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../service/garage.service */ "./src/app/dash-board/service/garage.service.ts");
/* harmony import */ var _service_indicator_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../service/indicator.service */ "./src/app/dash-board/service/indicator.service.ts");
/* harmony import */ var src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! src/app/core/service/message.service */ "./src/app/core/service/message.service.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");











let NumberIndicatorsComponent = class NumberIndicatorsComponent {
    constructor(garageService, messageHandler, indicatorService, dialog) {
        this.garageService = garageService;
        this.messageHandler = messageHandler;
        this.indicatorService = indicatorService;
        this.dialog = dialog;
    }
    ngOnInit() {
        this.indicators = new Array();
        this.listGarage();
        this.listIndicators();
        this.garageSelected = new _model_garage__WEBPACK_IMPORTED_MODULE_6__["Garage"]();
        this.garageSelected.name = "sin";
    }
    listGarage() {
        this.garageService.list({ page: 0, size: 300 }).subscribe(data => {
            if (data) {
                this.garages = data.content;
            }
            else {
                this.garages = [];
            }
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    listIndicators() {
        this.indicatorService.getList({ page: 0, size: 3000, dto: { graficType: "SPEEDOMETER" } }).subscribe(data => {
            if (data) {
                this.indicatorsData = data.content;
            }
            this.listIndicatorsByGarageAll();
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    listIndicatorsByGarageAll() {
        this.indicators = [];
        let date = Object(_angular_common__WEBPACK_IMPORTED_MODULE_10__["formatDate"])(new Date(), 'yyyy-MM-dd', 'en');
        date += ' 00:00:00';
        this.indicatorService.getAllIndicators({ date: date, garage: this.garageSelected, indicators: this.indicatorsData }).subscribe(data => {
            console.log(data, "asjdf");
            this.indicators = data;
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    showInfoOnDialog(indicator) {
        const DialogRef = this.dialog.open(_core_just_info_dialog_just_info_dialog_component__WEBPACK_IMPORTED_MODULE_3__["JustInfoDialogComponent"], {
            width: '80%',
            data: { tittle: "Descripción del" + indicator.name, info: indicator.description }
        });
    }
    showTendencyDialog(indicator) {
        let list = new Array();
        let indicatorMonthly = new _model_indicator__WEBPACK_IMPORTED_MODULE_1__["Indicator"]();
        indicatorMonthly.graficType = "MONTHLYBAR";
        indicatorMonthly.indicatorProcedure = indicator.monthly;
        indicatorMonthly.indicatorName = indicator.response[0].name;
        if (this.garageSelected) {
            indicatorMonthly.indicatorZone = this.garageSelected.id;
        }
        list.push(indicatorMonthly);
        this.indicatorService.getIndicatorsMonthly(list).subscribe(data => {
            let labels = new Array();
            let dataRecive = new Array();
            if (data[0].response) {
                data[0].response.forEach(element => {
                    labels.push(element.monthString);
                    dataRecive.push(element.avg);
                });
            }
            const DialogTendencyRef = this.dialog.open(_core_bar_graphic_modal_bar_graphic_modal_component__WEBPACK_IMPORTED_MODULE_2__["BarGraphicModalComponent"], {
                width: '70%',
                data: { labels: labels, data: [{ data: dataRecive, label: "Mensual" }] }
            });
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
};
NumberIndicatorsComponent.ctorParameters = () => [
    { type: _service_garage_service__WEBPACK_IMPORTED_MODULE_7__["GarageService"] },
    { type: src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_9__["MessageService"] },
    { type: _service_indicator_service__WEBPACK_IMPORTED_MODULE_8__["IndicatorService"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatDialog"] }
];
NumberIndicatorsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_5__["Component"])({
        selector: 'app-number-indicators',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./number-indicators.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/number-indicators/number-indicators.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./number-indicators.component.css */ "./src/app/dash-board/number-indicators/number-indicators.component.css")).default]
    })
], NumberIndicatorsComponent);



/***/ }),

/***/ "./src/app/dash-board/piece/piece.component.css":
/*!******************************************************!*\
  !*** ./src/app/dash-board/piece/piece.component.css ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("table {\r\n    width: 100%;\r\n  }\r\n\r\n\r\n  .btn-primary:hover {\r\n    color: #fff;\r\n    background-color: #343a40;\r\n   \r\n}\r\n\r\n\r\n  .btn-primary{\r\n    background: #fbbc04;\r\n    border: none;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvZGFzaC1ib2FyZC9waWVjZS9waWVjZS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksV0FBVztFQUNiOzs7RUFHQTtJQUNFLFdBQVc7SUFDWCx5QkFBeUI7O0FBRTdCOzs7RUFFQTtJQUNJLG1CQUFtQjtJQUNuQixZQUFZO0FBQ2hCIiwiZmlsZSI6InNyYy9hcHAvZGFzaC1ib2FyZC9waWVjZS9waWVjZS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsidGFibGUge1xyXG4gICAgd2lkdGg6IDEwMCU7XHJcbiAgfVxyXG5cclxuXHJcbiAgLmJ0bi1wcmltYXJ5OmhvdmVyIHtcclxuICAgIGNvbG9yOiAjZmZmO1xyXG4gICAgYmFja2dyb3VuZC1jb2xvcjogIzM0M2E0MDtcclxuICAgXHJcbn1cclxuXHJcbi5idG4tcHJpbWFyeXtcclxuICAgIGJhY2tncm91bmQ6ICNmYmJjMDQ7XHJcbiAgICBib3JkZXI6IG5vbmU7XHJcbn1cclxuIl19 */");

/***/ }),

/***/ "./src/app/dash-board/piece/piece.component.ts":
/*!*****************************************************!*\
  !*** ./src/app/dash-board/piece/piece.component.ts ***!
  \*****************************************************/
/*! exports provided: PieceComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PieceComponent", function() { return PieceComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _model_componentModel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model/componentModel */ "./src/app/dash-board/model/componentModel.ts");
/* harmony import */ var _service_component_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../service/component.service */ "./src/app/dash-board/service/component.service.ts");
/* harmony import */ var src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/core/service/message.service */ "./src/app/core/service/message.service.ts");





let PieceComponent = class PieceComponent {
    constructor(componentService, messageHandler) {
        this.componentService = componentService;
        this.messageHandler = messageHandler;
        this.displayedColumns = ['code', 'name', 'edit'];
    }
    ngOnInit() {
        this.components = new Array();
        this.component = new _model_componentModel__WEBPACK_IMPORTED_MODULE_2__["ComponentModel"]();
        this.dataSource = new Array();
        this.listComponents();
    }
    listComponents() {
        this.componentService.list({ page: 0, size: 3000 }).subscribe(data => {
            if (data) {
                console.log(data);
                this.components = data.content;
                this.buildData();
            }
            else {
                this.components = [];
            }
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    clear() {
        this.component = new _model_componentModel__WEBPACK_IMPORTED_MODULE_2__["ComponentModel"]();
    }
    save() {
        let msn = this.valid();
        if ("" == msn) {
            this.componentService.save(this.component).subscribe(data => {
                if (data) {
                    this.messageHandler.commonMessage("Componente almacenado correctamente", "success");
                    this.clear();
                    this.listComponents();
                }
            }, error => {
                this.messageHandler.errorHandler(error);
            });
        }
        else {
            this.messageHandler.commonMessage(msn, "info");
        }
    }
    delete() {
        if (this.component.id) {
            this.componentService.delete(this.component).subscribe(data => {
                this.clear();
                this.listComponents();
                this.messageHandler.commonMessage("Componente eliminado con exito", "success");
            });
        }
        else {
            this.messageHandler.commonMessage("Debe especificar el componente a eliminar", "info");
        }
    }
    valid() {
        let msn = "";
        if (!this.component.code) {
            msn += "Debe especificar un codigó;";
        }
        if (!this.component.name)
            msn += "Debe especificar un nombre;";
        return msn;
    }
    buildData() {
        let dataSource = new Array();
        let data;
        this.components.forEach(element => {
            data = {
                id: element.id,
                code: element.code,
                name: element.name
            };
            dataSource.push(data);
        });
        this.dataSource = dataSource;
        console.log("ey");
    }
    edit(element) {
        this.component = element;
    }
};
PieceComponent.ctorParameters = () => [
    { type: _service_component_service__WEBPACK_IMPORTED_MODULE_3__["ComponentService"] },
    { type: src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] }
];
PieceComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-piece',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./piece.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/piece/piece.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./piece.component.css */ "./src/app/dash-board/piece/piece.component.css")).default]
    })
], PieceComponent);



/***/ }),

/***/ "./src/app/dash-board/service/activity-state.service.ts":
/*!**************************************************************!*\
  !*** ./src/app/dash-board/service/activity-state.service.ts ***!
  \**************************************************************/
/*! exports provided: ActivityStateService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActivityStateService", function() { return ActivityStateService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_core_service_base_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/core/service/base.service */ "./src/app/core/service/base.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let ActivityStateService = class ActivityStateService extends src_app_core_service_base_service__WEBPACK_IMPORTED_MODULE_2__["BaseService"] {
    constructor(http) {
        super(http);
        this.path = "activity/state";
    }
};
ActivityStateService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
ActivityStateService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], ActivityStateService);



/***/ }),

/***/ "./src/app/dash-board/service/activity.service.ts":
/*!********************************************************!*\
  !*** ./src/app/dash-board/service/activity.service.ts ***!
  \********************************************************/
/*! exports provided: ActivityService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActivityService", function() { return ActivityService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_core_service_base_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/core/service/base.service */ "./src/app/core/service/base.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");





let ActivityService = class ActivityService extends src_app_core_service_base_service__WEBPACK_IMPORTED_MODULE_2__["BaseService"] {
    constructor(http) {
        super(http);
        this.path = "activity";
    }
    createFile() {
        return this.http.get(src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].url + this.path + "/download/", { responseType: 'blob' });
        //return this.http.get<any>(environment.apiUrl+this.path+"/reportAudios/"+tripId,headers);
    }
};
ActivityService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
ActivityService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], ActivityService);



/***/ }),

/***/ "./src/app/dash-board/service/bay.service.ts":
/*!***************************************************!*\
  !*** ./src/app/dash-board/service/bay.service.ts ***!
  \***************************************************/
/*! exports provided: BayService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BayService", function() { return BayService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_core_service_base_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/core/service/base.service */ "./src/app/core/service/base.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _model_adaptergarage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../model/adaptergarage */ "./src/app/dash-board/model/adaptergarage.ts");






let BayService = class BayService extends src_app_core_service_base_service__WEBPACK_IMPORTED_MODULE_3__["BaseService"] {
    constructor(http) {
        super(http);
        this.path = "bay";
    }
    saveList(bayList, garage) {
        let adapter = new _model_adaptergarage__WEBPACK_IMPORTED_MODULE_5__["AdapterGarageBays"]();
        adapter.bays = bayList;
        adapter.garage = garage;
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].url + this.path + "/list/save", adapter);
    }
    saveList2(bayList) {
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].url + this.path + "/list/save", bayList);
    }
    findByGarage(garage) {
        console.log();
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].url + this.path + "/list/bay/garage", garage);
    }
    createFile() {
        return this.http.get(src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].url + this.path + "/download/", { responseType: 'blob' });
    }
    terminateActivity(bay) {
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].url + this.path + "/terminate", bay);
    }
    getBaysByUser() {
        return this.http.get(src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].url + this.path + "/list/byuser");
    }
};
BayService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
BayService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], BayService);



/***/ }),

/***/ "./src/app/dash-board/service/component.service.ts":
/*!*********************************************************!*\
  !*** ./src/app/dash-board/service/component.service.ts ***!
  \*********************************************************/
/*! exports provided: ComponentService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentService", function() { return ComponentService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_core_service_base_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/core/service/base.service */ "./src/app/core/service/base.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let ComponentService = class ComponentService extends src_app_core_service_base_service__WEBPACK_IMPORTED_MODULE_2__["BaseService"] {
    constructor(http) {
        super(http);
        this.path = "component";
    }
};
ComponentService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
ComponentService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], ComponentService);



/***/ }),

/***/ "./src/app/dash-board/service/garage.service.ts":
/*!******************************************************!*\
  !*** ./src/app/dash-board/service/garage.service.ts ***!
  \******************************************************/
/*! exports provided: GarageService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GarageService", function() { return GarageService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../../../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_core_service_base_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/core/service/base.service */ "./src/app/core/service/base.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");





let GarageService = class GarageService extends src_app_core_service_base_service__WEBPACK_IMPORTED_MODULE_3__["BaseService"] {
    constructor(http) {
        super(http);
        this.path = "garage";
    }
    saveList(adapter) {
        return this.http.post(_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].url + this.path + "/save/with/bays", adapter);
    }
};
GarageService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpClient"] }
];
GarageService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    })
], GarageService);



/***/ }),

/***/ "./src/app/dash-board/service/indicator.service.ts":
/*!*********************************************************!*\
  !*** ./src/app/dash-board/service/indicator.service.ts ***!
  \*********************************************************/
/*! exports provided: IndicatorService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IndicatorService", function() { return IndicatorService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");




let IndicatorService = class IndicatorService {
    constructor(http) {
        this.http = http;
        this.path = "indicator";
    }
    getProductivityDay(adapter) {
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].url + this.path + "/image", adapter);
    }
    getList(dto) {
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].url + this.path + "/list", dto);
    }
    getCake(garageName) {
        return this.http.get(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].url + this.path + "/cake/" + garageName);
    }
    getCakeBay(garageName) {
        return this.http.get(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].url + this.path + "/cake/bays/" + garageName);
    }
    generateHistoryReport() {
        return this.http.get(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].url + this.path + "/history/report");
    }
    getAllIndicators(adapter) {
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].url + this.path + "/image/all", adapter);
    }
    getIndicatorsMonthly(list) {
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].url + this.path + "/monthly", list);
    }
};
IndicatorService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
IndicatorService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], IndicatorService);



/***/ }),

/***/ "./src/app/dash-board/service/workorder.service.ts":
/*!*********************************************************!*\
  !*** ./src/app/dash-board/service/workorder.service.ts ***!
  \*********************************************************/
/*! exports provided: WorkorderService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WorkorderService", function() { return WorkorderService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_core_service_base_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/core/service/base.service */ "./src/app/core/service/base.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");





let WorkorderService = class WorkorderService extends src_app_core_service_base_service__WEBPACK_IMPORTED_MODULE_2__["BaseService"] {
    constructor(http) {
        super(http);
        this.path = "workorder";
    }
    assign(adapter) {
        return this.http.post(src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].url + this.path + "/assign", adapter);
    }
};
WorkorderService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
WorkorderService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], WorkorderService);



/***/ }),

/***/ "./src/app/dash-board/state/state.component.css":
/*!******************************************************!*\
  !*** ./src/app/dash-board/state/state.component.css ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("table {\r\n    width: 100%;\r\n  }\r\n\r\n\r\n  .btn-primary:hover {\r\n    color: #fff;\r\n    background-color: #343a40;\r\n   \r\n}\r\n\r\n\r\n  .btn-primary{\r\n    background: #fbbc04;\r\n    border: none;\r\n}\r\n\r\n\r\n  .picker{\r\n  border-radius: 77px 77px 77px 77px;\r\n  -moz-border-radius: 77px 77px 77px 77px;\r\n  -webkit-border-radius: 77px 77px 77px 77px;\r\n  border: 0px solid #000000;\r\n  background: #fbbc04 ;\r\n  text-align: center;\r\n  margin-top: 5%;\r\n\r\n\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvZGFzaC1ib2FyZC9zdGF0ZS9zdGF0ZS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksV0FBVztFQUNiOzs7RUFHQTtJQUNFLFdBQVc7SUFDWCx5QkFBeUI7O0FBRTdCOzs7RUFFQTtJQUNJLG1CQUFtQjtJQUNuQixZQUFZO0FBQ2hCOzs7RUFFQTtFQUNFLGtDQUFrQztFQUNsQyx1Q0FBdUM7RUFDdkMsMENBQTBDO0VBQzFDLHlCQUF5QjtFQUN6QixvQkFBb0I7RUFDcEIsa0JBQWtCO0VBQ2xCLGNBQWM7OztBQUdoQiIsImZpbGUiOiJzcmMvYXBwL2Rhc2gtYm9hcmQvc3RhdGUvc3RhdGUuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbInRhYmxlIHtcclxuICAgIHdpZHRoOiAxMDAlO1xyXG4gIH1cclxuXHJcblxyXG4gIC5idG4tcHJpbWFyeTpob3ZlciB7XHJcbiAgICBjb2xvcjogI2ZmZjtcclxuICAgIGJhY2tncm91bmQtY29sb3I6ICMzNDNhNDA7XHJcbiAgIFxyXG59XHJcblxyXG4uYnRuLXByaW1hcnl7XHJcbiAgICBiYWNrZ3JvdW5kOiAjZmJiYzA0O1xyXG4gICAgYm9yZGVyOiBub25lO1xyXG59XHJcblxyXG4ucGlja2Vye1xyXG4gIGJvcmRlci1yYWRpdXM6IDc3cHggNzdweCA3N3B4IDc3cHg7XHJcbiAgLW1vei1ib3JkZXItcmFkaXVzOiA3N3B4IDc3cHggNzdweCA3N3B4O1xyXG4gIC13ZWJraXQtYm9yZGVyLXJhZGl1czogNzdweCA3N3B4IDc3cHggNzdweDtcclxuICBib3JkZXI6IDBweCBzb2xpZCAjMDAwMDAwO1xyXG4gIGJhY2tncm91bmQ6ICNmYmJjMDQgO1xyXG4gIHRleHQtYWxpZ246IGNlbnRlcjtcclxuICBtYXJnaW4tdG9wOiA1JTtcclxuXHJcblxyXG59XHJcbiJdfQ== */");

/***/ }),

/***/ "./src/app/dash-board/state/state.component.ts":
/*!*****************************************************!*\
  !*** ./src/app/dash-board/state/state.component.ts ***!
  \*****************************************************/
/*! exports provided: StateComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateComponent", function() { return StateComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _model_activityState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model/activityState */ "./src/app/dash-board/model/activityState.ts");
/* harmony import */ var _service_activity_state_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../service/activity-state.service */ "./src/app/dash-board/service/activity-state.service.ts");
/* harmony import */ var src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/core/service/message.service */ "./src/app/core/service/message.service.ts");





let StateComponent = class StateComponent {
    constructor(stateService, messageHandler) {
        this.stateService = stateService;
        this.messageHandler = messageHandler;
        this.displayedColumns = ['code', 'name', 'color', 'edit'];
    }
    ngOnInit() {
        this.states = new Array();
        this.state = new _model_activityState__WEBPACK_IMPORTED_MODULE_2__["ActivityState"]();
        this.dataSource = new Array();
        this.listStates();
    }
    listStates() {
        this.stateService.list({ page: 0, size: 3000 }).subscribe(data => {
            if (data) {
                console.log(data);
                this.states = data.content;
                this.buildData();
            }
            else {
                this.states = [];
            }
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    clear() {
        this.state = new _model_activityState__WEBPACK_IMPORTED_MODULE_2__["ActivityState"]();
    }
    save() {
        let msn = this.valid();
        if ("" == msn) {
            this.state.color = this.state.color.replace("#", "");
            this.stateService.save(this.state).subscribe(data => {
                if (data) {
                    this.messageHandler.commonMessage("Estado almacenado correctamente", "success");
                    this.clear();
                    this.listStates();
                }
            }, error => {
                this.messageHandler.errorHandler(error);
            });
        }
        else {
            this.messageHandler.commonMessage(msn, "info");
        }
    }
    delete() {
        if (this.state.id) {
            this.stateService.delete(this.state).subscribe(data => {
                if (data) {
                    this.messageHandler.commonMessage("Estado eliminado con exito", "success");
                }
                this.listStates();
                this.clear();
            });
        }
        else {
            this.messageHandler.commonMessage("Debe especificar el estado a eliminar", "info");
        }
    }
    valid() {
        let msn = "";
        console.log(this.state);
        if (!this.state.code) {
            msn += "Debe especificar un codigó;";
        }
        if (!this.state.name)
            msn += "Debe especificar un nombre;";
        if (!this.state.color)
            msn += "Debe especificar un color;";
        return msn;
    }
    buildData() {
        let dataSource = new Array();
        let data;
        this.states.forEach(element => {
            data = {
                id: element.id,
                code: element.code,
                name: element.name,
                color: element.color
            };
            dataSource.push(data);
        });
        this.dataSource = dataSource;
        console.log("ey", this.dataSource);
    }
    edit(element) {
        this.state = element;
    }
};
StateComponent.ctorParameters = () => [
    { type: _service_activity_state_service__WEBPACK_IMPORTED_MODULE_3__["ActivityStateService"] },
    { type: src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] }
];
StateComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-state',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./state.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/state/state.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./state.component.css */ "./src/app/dash-board/state/state.component.css")).default]
    })
], StateComponent);



/***/ }),

/***/ "./src/app/dash-board/traffic-light/traffic-light.component.css":
/*!**********************************************************************!*\
  !*** ./src/app/dash-board/traffic-light/traffic-light.component.css ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".example-form {\r\n    width: 100%;\r\n  }\r\n  \r\n  .example-full-width {\r\n    width: 100%;\r\n  }\r\n  \r\n  .item-margin{\r\n      margin-top: 8%;\r\n      margin-bottom: 5%;\r\n  }\r\n  \r\n  table {\r\n    width: 100%;\r\n  }\r\n  \r\n  tr.example-detail-row {\r\n    height: 0;\r\n  }\r\n  \r\n  tr.example-element-row:not(.example-expanded-row):hover {\r\n    background: #777;\r\n  }\r\n  \r\n  tr.example-element-row:not(.example-expanded-row):active {\r\n    background: #efefef;\r\n  }\r\n  \r\n  .example-element-row td {\r\n    border-bottom-width: 0;\r\n  }\r\n  \r\n  .example-element-detail {\r\n    overflow: hidden;\r\n    display: flex;\r\n  }\r\n  \r\n  .example-element-diagram {\r\n    min-width: 80px;\r\n    border: 2px solid black;\r\n    padding: 8px;\r\n    font-weight: lighter;\r\n    margin: 8px 0;\r\n    height: 104px;\r\n  }\r\n  \r\n  .example-element-symbol {\r\n    font-weight: bold;\r\n    font-size: 40px;\r\n    line-height: normal;\r\n  }\r\n  \r\n  .example-element-description {\r\n    padding: 16px;\r\n  }\r\n  \r\n  .example-element-description-attribution {\r\n    opacity: 0.5;\r\n  }\r\n  \r\n  .element-margin{\r\n      margin-top: 1.5%;\r\n      margin-bottom: 1.5%;\r\n    text-transform: uppercase;\r\n\r\n  }\r\n  \r\n  .field{\r\n      font-weight: bolder;\r\n      background: #fbbc04;\r\n      margin-right: 5%;\r\n  }\r\n  \r\n  .label-accent{\r\n    background: #fbbc04;\r\n  }\r\n  \r\n  .button-padding{\r\n    margin-left: 2%;\r\n  }\r\n  \r\n  .btn-primary:hover {\r\n    color: #fff;\r\n    background-color: #343a40;\r\n   \r\n}\r\n  \r\n  .btn-primary{\r\n    background: #fbbc04;\r\n    border: none;\r\n}\r\n  \r\n  .btn-black{\r\n    background: #343a40;\r\n    color: white;\r\n}\r\n  \r\n  .btn-black:hover{\r\n    background: #fbbc04;\r\n    color: white;\r\n}\r\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/dash-board/traffic-light/traffic-light.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/dash-board/traffic-light/traffic-light.component.ts ***!
  \*********************************************************************/
/*! exports provided: TrafficLightComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrafficLightComponent", function() { return TrafficLightComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _core_loading_loading_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../../core/loading/loading.component */ "./src/app/core/loading/loading.component.ts");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _service_workorder_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../service/workorder.service */ "./src/app/dash-board/service/workorder.service.ts");
/* harmony import */ var src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/core/service/message.service */ "./src/app/core/service/message.service.ts");
/* harmony import */ var src_app_core_model_workorder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/core/model/workorder */ "./src/app/core/model/workorder.ts");
/* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
/* harmony import */ var src_app_core_model_listDTO__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! src/app/core/model/listDTO */ "./src/app/core/model/listDTO.ts");
/* harmony import */ var _service_garage_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../service/garage.service */ "./src/app/dash-board/service/garage.service.ts");
/* harmony import */ var _service_bay_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../service/bay.service */ "./src/app/dash-board/service/bay.service.ts");
/* harmony import */ var _service_activity_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../service/activity.service */ "./src/app/dash-board/service/activity.service.ts");
/* harmony import */ var _service_activity_state_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../service/activity-state.service */ "./src/app/dash-board/service/activity-state.service.ts");
/* harmony import */ var _service_component_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../service/component.service */ "./src/app/dash-board/service/component.service.ts");
/* harmony import */ var _model_activity__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../model/activity */ "./src/app/dash-board/model/activity.ts");















let TrafficLightComponent = class TrafficLightComponent {
    constructor(workOrderService, messageHandler, garageService, bayService, activityService, componentService, stateService, dialog) {
        this.workOrderService = workOrderService;
        this.messageHandler = messageHandler;
        this.garageService = garageService;
        this.bayService = bayService;
        this.activityService = activityService;
        this.componentService = componentService;
        this.stateService = stateService;
        this.dialog = dialog;
        this.columnsToDisplay = ['Id', 'Taller', 'OT', 'Cliente', 'F. Inicio', 'F. Final', 'Ver'];
        this.tittlesFilter = ['TALLER', 'STORE', 'OT', 'MODELO', 'SERIAL', 'CLIENTE', 'TIPO DE CLIENTE', 'CODIGO', 'CONTROL DE TAREA', 'PROPIETARIO', 'EN PROCESO'];
        this.attributesFilter = ["dto.zona", "dto.store", "dto.ot", "dto.model", "dto.serial", "dto.customer", "dto.custType", "dto.codigo", "dto.jobCtrl", 'owner', 'deleted'];
        this.typeFilters = ['text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'deleted'];
    }
    set inputTag2(input) {
        if (!input) {
            return;
        }
        else {
            this.btnCloseModal = input;
        }
    }
    ngOnInit() {
        this.listWorkOrder();
        this.onFilter = new src_app_core_model_listDTO__WEBPACK_IMPORTED_MODULE_8__["ListDTO"](new src_app_core_model_workorder__WEBPACK_IMPORTED_MODULE_6__["WorkOrder"]());
        this.onFilter.deleted = false;
        this.listGarage();
        this.bays = new Array();
        this.states = new Array();
        this.components = new Array();
        this.listComponents();
        this.listStates();
        this.listBaysByUser();
        this.activity = new _model_activity__WEBPACK_IMPORTED_MODULE_14__["Activity"]();
    }
    listWorkOrder(dto = { page: 0, size: 80 }) {
        this.showDialog();
        this.workOrderService.list(dto).subscribe(data => {
            this.closeDialog();
            if (data) {
                this.workOrders = data.content;
                this.constructDataSource();
            }
            if (!this.workOrders || this.workOrders.length == 0) {
                this.messageHandler.commonMessage("No se encuentra ningun resultado", "info");
            }
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    listGarage() {
        this.garageService.list({ page: 0, size: 300 }).subscribe(data => {
            console.log(data, "garages");
            if (data) {
                this.garages = data.content;
            }
            else {
                this.garages = [];
            }
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    listBaysByUser() {
        this.bayService.getBaysByUser().subscribe(data => {
            if (data) {
                this.bays = data;
            }
            else {
                this.bays = [];
            }
        });
    }
    constructDataSource() {
        this.dataSource = this.workOrders;
    }
    getValue(column, element) {
        if (column == "Id")
            return element['id'];
        if (column == 'Taller')
            return element['zona'];
        if (column == "OT")
            return element['ot'];
        if (column == "Cliente")
            return element['customer'];
        if (column == "F. Inicio")
            return element['openDate'];
        if (column == "F. Final")
            return element['dateFinsh'];
        if (column == 'Ver') {
            // return '<i class="fas fa-plus"></i>'
            return '+';
        }
    }
    filter(event) {
        this.listWorkOrder(event.principal);
        this.onFilter = new src_app_core_model_listDTO__WEBPACK_IMPORTED_MODULE_8__["ListDTO"](new src_app_core_model_workorder__WEBPACK_IMPORTED_MODULE_6__["WorkOrder"]());
    }
    selectWorkOrder(element) {
        this.garageSelected = null;
        this.baySelected = null;
        this.workOrerSelected = element;
        console.log(element, "seleccionado");
    }
    assignOTtoWorkOrder() {
        let valid = this.validAssign();
        console.log(this.baySelected, this.workOrerSelected, this.garageSelected, valid);
        if ("" == valid) {
            this.workOrderService.assign({ workOrder: this.workOrerSelected, bay: this.baySelected, state: this.stateSelected, component: this.componentSelected, activity: this.activity }).subscribe(data => {
                if (data) {
                    this.btnCloseModal.nativeElement.click();
                    this.messageHandler.commonMessage("La OT " + data.ot + " fue asignada correctamente", "info");
                }
            }, error => {
                this.messageHandler.errorHandler(error);
            });
        }
        else {
            this.messageHandler.commonMessage(valid, "error");
        }
    }
    validAssign() {
        let valid = "";
        if (!this.baySelected || !this.baySelected.id)
            valid += "Debe especificar una bahía;";
        if (!this.workOrerSelected || !this.workOrerSelected.id)
            valid += "Debe seleccionar una actividad;";
        if (!this.stateSelected || !this.stateSelected.id)
            valid += "Debe especificar un estado para la actividad";
        return valid;
    }
    listComponents() {
        this.componentService.list({ page: 0, size: 3000 }).subscribe(data => {
            console.log(data);
            if (data) {
                this.components = data.content;
            }
            else {
                this.components = [];
            }
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    listStates() {
        this.stateService.list({ page: 0, size: 300 }).subscribe(data => {
            console.log(data, "states");
            if (data) {
                this.states = data.content;
            }
            else {
                this.states = [];
            }
        }, error => {
            this.messageHandler.errorHandler(error);
        });
    }
    getSate(item) {
        if (item.stateString) {
            return item.stateString;
        }
        else {
            return item.bayState;
        }
    }
    showDialog() {
        this.dialogRef = this.dialog.open(_core_loading_loading_component__WEBPACK_IMPORTED_MODULE_1__["LoadingComponent"], { width: '30%', disableClose: true, data: { message: "Espere mientras se carga la información" } });
    }
    closeDialog() {
        this.dialog.closeAll();
    }
};
TrafficLightComponent.ctorParameters = () => [
    { type: _service_workorder_service__WEBPACK_IMPORTED_MODULE_4__["WorkorderService"] },
    { type: src_app_core_service_message_service__WEBPACK_IMPORTED_MODULE_5__["MessageService"] },
    { type: _service_garage_service__WEBPACK_IMPORTED_MODULE_9__["GarageService"] },
    { type: _service_bay_service__WEBPACK_IMPORTED_MODULE_10__["BayService"] },
    { type: _service_activity_service__WEBPACK_IMPORTED_MODULE_11__["ActivityService"] },
    { type: _service_component_service__WEBPACK_IMPORTED_MODULE_13__["ComponentService"] },
    { type: _service_activity_state_service__WEBPACK_IMPORTED_MODULE_12__["ActivityStateService"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialog"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewChild"])('btnCloseModal', { read: _angular_core__WEBPACK_IMPORTED_MODULE_3__["ElementRef"], static: false })
], TrafficLightComponent.prototype, "inputTag2", null);
TrafficLightComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"])({
        selector: 'app-traffic-light',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./traffic-light.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dash-board/traffic-light/traffic-light.component.html")).default,
        animations: [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["trigger"])('detailExpand', [
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["state"])('collapsed', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["style"])({ height: '0px', minHeight: '0' })),
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["state"])('expanded', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["style"])({ height: '*' })),
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["transition"])('expanded <=> collapsed', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_7__["animate"])('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            ]),
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./traffic-light.component.css */ "./src/app/dash-board/traffic-light/traffic-light.component.css")).default]
    })
], TrafficLightComponent);



/***/ }),

/***/ "./src/app/graphproof/graphproof.component.css":
/*!*****************************************************!*\
  !*** ./src/app/graphproof/graphproof.component.css ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2dyYXBocHJvb2YvZ3JhcGhwcm9vZi5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/graphproof/graphproof.component.ts":
/*!****************************************************!*\
  !*** ./src/app/graphproof/graphproof.component.ts ***!
  \****************************************************/
/*! exports provided: GraphproofComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GraphproofComponent", function() { return GraphproofComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let GraphproofComponent = class GraphproofComponent {
    constructor() { }
    ngOnInit() {
    }
};
GraphproofComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-graphproof',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./graphproof.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/graphproof/graphproof.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./graphproof.component.css */ "./src/app/graphproof/graphproof.component.css")).default]
    })
], GraphproofComponent);



/***/ }),

/***/ "./src/app/material/material-file-upload/material-file-upload.component.css":
/*!**********************************************************************************!*\
  !*** ./src/app/material/material-file-upload/material-file-upload.component.css ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("ul,\r\nli {\r\n      margin: 0;\r\n      padding: 0;\r\n      list-style: none;\r\n}\r\n\r\n#file-label {\r\n      display: inline-flex;\r\n      vertical-align: middle;\r\n      font-size: 12px;\r\n      line-height: 18px;\r\n}\r\n\r\n#file-label mat-icon {\r\n      font-size: 18px;\r\n      text-align: center;\r\n}\r\n\r\n#file-label a {\r\n      cursor: pointer;\r\n}\r\n\r\n.mat-button{\r\n      color: #fbbc04;\r\n}\r\n\r\ntable {\r\n      width: 100%;\r\n    }\r\n\r\ntr.example-detail-row {\r\n      height: 0;\r\n    }\r\n\r\ntr.example-element-row:not(.example-expanded-row):hover {\r\n      background: #777;\r\n    }\r\n\r\ntr.example-element-row:not(.example-expanded-row):active {\r\n      background: #efefef;\r\n    }\r\n\r\n.example-element-row td {\r\n      border-bottom-width: 0;\r\n    }\r\n\r\n.example-element-detail {\r\n      overflow: hidden;\r\n      display: flex;\r\n    }\r\n\r\n.example-element-diagram {\r\n      min-width: 80px;\r\n      border: 2px solid black;\r\n      padding: 8px;\r\n      font-weight: lighter;\r\n      margin: 8px 0;\r\n      height: 104px;\r\n    }\r\n\r\n.example-element-symbol {\r\n      font-weight: bold;\r\n      font-size: 40px;\r\n      line-height: normal;\r\n    }\r\n\r\n.example-element-description {\r\n      padding: 16px;\r\n    }\r\n\r\n.example-element-description-attribution {\r\n      opacity: 0.5;\r\n    }\r\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/material/material-file-upload/material-file-upload.component.ts":
/*!*********************************************************************************!*\
  !*** ./src/app/material/material-file-upload/material-file-upload.component.ts ***!
  \*********************************************************************************/
/*! exports provided: MaterialFileUploadComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaterialFileUploadComponent", function() { return MaterialFileUploadComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let MaterialFileUploadComponent = class MaterialFileUploadComponent {
    constructor(_http) {
        this._http = _http;
        /** Link text */
        this.text = 'Cargar';
        /** Name used in form which will be sent in HTTP request. */
        this.param = 'file';
        /** Target URL for file uploading. */
        this.target = 'https://file.io';
        /** File extension that accepted, same as 'accept' of <input type="file" />.
            By the default, it's set to 'image/*'. */
        this.accept = 'image/*';
        /** Allow you to add handler after its completion. Bubble up response text from remote. */
        this.complete = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.files = [];
    }
    ngOnInit() {
    }
    onClick() {
        console.log(this.accept);
        const fileUpload = document.getElementById('fileUpload');
        fileUpload.onchange = () => {
            const file = fileUpload.files[0];
            this.files.push({
                data: file, state: 'in',
                inProgress: false, progress: 0, canRetry: false, canCancel: true
            });
            this.uploadFiles();
        };
        fileUpload.click();
    }
    cancelFile(file) {
        file.sub.unsubscribe();
        this.removeFileFromArray(file);
    }
    retryFile(file) {
        this.uploadFile(file);
        file.canRetry = false;
    }
    uploadFile(file) {
        let strin = file.data;
        // let task: UploadTask = this.angularFire.tareaCloudStorage(file.data.name,file.data);
        let returned = this.isImgForUpload(file.data);
        console.log(returned);
        console.log("error");
        this.complete.emit(file.data);
        this.files = [];
    }
    isImgForUpload(file) {
        let fileType = ['csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
        let returnd = false;
        fileType.forEach(element => {
            console.log(file.type);
            if (file.type == element) {
                console.log(file.type, "aqui", element, false);
                console.log(returnd, "wowo");
                return returnd;
            }
        });
        return true;
    }
    uploadFiles() {
        const fileUpload = document.getElementById('fileUpload');
        fileUpload.value = '';
        this.files.forEach(file => {
            this.uploadFile(file);
        });
    }
    removeFileFromArray(file) {
        const index = this.files.indexOf(file);
        if (index > -1) {
            this.files.splice(index, 1);
        }
    }
};
MaterialFileUploadComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], MaterialFileUploadComponent.prototype, "text", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], MaterialFileUploadComponent.prototype, "param", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], MaterialFileUploadComponent.prototype, "target", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], MaterialFileUploadComponent.prototype, "accept", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], MaterialFileUploadComponent.prototype, "complete", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], MaterialFileUploadComponent.prototype, "formControlName", void 0);
MaterialFileUploadComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-material-file-upload',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./material-file-upload.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/material/material-file-upload/material-file-upload.component.html")).default,
        animations: [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["trigger"])('fadeInOut', [
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["state"])('in', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["style"])({ opacity: 100 })),
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["transition"])('* => void', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["animate"])(300, Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["style"])({ opacity: 0 }))
                ])
            ])
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./material-file-upload.component.css */ "./src/app/material/material-file-upload/material-file-upload.component.css")).default]
    })
], MaterialFileUploadComponent);



/***/ }),

/***/ "./src/app/material/material-img-upload/material-img-upload.component.css":
/*!********************************************************************************!*\
  !*** ./src/app/material/material-img-upload/material-img-upload.component.css ***!
  \********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("ul,\r\nli {\r\n      margin: 0;\r\n      padding: 0;\r\n      list-style: none;\r\n}\r\n\r\n#file-label {\r\n      display: inline-flex;\r\n      vertical-align: middle;\r\n      font-size: 12px;\r\n      line-height: 18px;\r\n}\r\n\r\n#file-label mat-icon {\r\n      font-size: 18px;\r\n      text-align: center;\r\n}\r\n\r\n#file-label a {\r\n      cursor: pointer;\r\n}\r\n\r\n.mat-button{\r\n      color: #fbbc04;\r\n}\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvbWF0ZXJpYWwvbWF0ZXJpYWwtaW1nLXVwbG9hZC9tYXRlcmlhbC1pbWctdXBsb2FkLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O01BRU0sU0FBUztNQUNULFVBQVU7TUFDVixnQkFBZ0I7QUFDdEI7O0FBRUE7TUFDTSxvQkFBb0I7TUFDcEIsc0JBQXNCO01BQ3RCLGVBQWU7TUFDZixpQkFBaUI7QUFDdkI7O0FBRUE7TUFDTSxlQUFlO01BQ2Ysa0JBQWtCO0FBQ3hCOztBQUVBO01BQ00sZUFBZTtBQUNyQjs7QUFFQTtNQUNNLGNBQWM7QUFDcEIiLCJmaWxlIjoic3JjL2FwcC9tYXRlcmlhbC9tYXRlcmlhbC1pbWctdXBsb2FkL21hdGVyaWFsLWltZy11cGxvYWQuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbInVsLFxyXG5saSB7XHJcbiAgICAgIG1hcmdpbjogMDtcclxuICAgICAgcGFkZGluZzogMDtcclxuICAgICAgbGlzdC1zdHlsZTogbm9uZTtcclxufVxyXG5cclxuI2ZpbGUtbGFiZWwge1xyXG4gICAgICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcclxuICAgICAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcclxuICAgICAgZm9udC1zaXplOiAxMnB4O1xyXG4gICAgICBsaW5lLWhlaWdodDogMThweDtcclxufVxyXG5cclxuI2ZpbGUtbGFiZWwgbWF0LWljb24ge1xyXG4gICAgICBmb250LXNpemU6IDE4cHg7XHJcbiAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcclxufVxyXG5cclxuI2ZpbGUtbGFiZWwgYSB7XHJcbiAgICAgIGN1cnNvcjogcG9pbnRlcjtcclxufVxyXG5cclxuLm1hdC1idXR0b257XHJcbiAgICAgIGNvbG9yOiAjZmJiYzA0O1xyXG59Il19 */");

/***/ }),

/***/ "./src/app/material/material-img-upload/material-img-upload.component.ts":
/*!*******************************************************************************!*\
  !*** ./src/app/material/material-img-upload/material-img-upload.component.ts ***!
  \*******************************************************************************/
/*! exports provided: MaterialImgUploadComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaterialImgUploadComponent", function() { return MaterialImgUploadComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _service_upload_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../service/upload.service */ "./src/app/material/service/upload.service.ts");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! sweetalert2 */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_4__);





let MaterialImgUploadComponent = class MaterialImgUploadComponent {
    constructor(_http, angularFire) {
        this._http = _http;
        this.angularFire = angularFire;
        /** Link text */
        this.text = 'Cargar';
        /** Name used in form which will be sent in HTTP request. */
        this.param = 'file';
        /** Target URL for file uploading. */
        this.target = 'https://file.io';
        /** File extension that accepted, same as 'accept' of <input type="file" />.
            By the default, it's set to 'image/*'. */
        this.accept = 'image/*';
        /** Allow you to add handler after its completion. Bubble up response text from remote. */
        this.complete = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.files = [];
    }
    ngOnInit() {
        console.log(this.accept);
    }
    onClick() {
        console.log("aqui", this.accept);
        const fileUpload = document.getElementById('fileUpload');
        fileUpload.onchange = () => {
            const file = fileUpload.files[0];
            this.files.push({
                data: file, state: 'in',
                inProgress: false, progress: 0, canRetry: false, canCancel: true
            });
            this.uploadFiles();
        };
        fileUpload.click();
    }
    cancelFile(file) {
        file.sub.unsubscribe();
        this.removeFileFromArray(file);
    }
    retryFile(file) {
        this.uploadFile(file);
        file.canRetry = false;
    }
    uploadFile(file) {
        let strin = file.data;
        let task = this.angularFire.tareaCloudStorage(file.data.name, file.data);
        let returned = this.isImgForUpload(file.data);
        console.log(returned);
        if (this.isImgForUpload(file.data) == true) {
            task.then(onFull => {
                let url = onFull.ref.getDownloadURL().then(data => {
                    this.files = [];
                    this.complete.emit(data);
                });
            }, error => {
                sweetalert2__WEBPACK_IMPORTED_MODULE_4___default.a.fire("Error", "No se pudo almacenar la imagen", "error");
            });
        }
        else {
            console.log("error");
            this.complete.emit(file.data);
            this.files = [];
        }
        //let url = task.snapshot.ref.getDownloadURL();
    }
    isImgForUpload(file) {
        let fileType = ['csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
        let returnd = false;
        fileType.forEach(element => {
            console.log(file.type);
            if (file.type == element) {
                console.log(file.type, "aqui", element, false);
                console.log(returnd, "wowo");
                return returnd;
            }
        });
        return true;
    }
    uploadFiles() {
        const fileUpload = document.getElementById('fileUpload');
        fileUpload.value = '';
        this.files.forEach(file => {
            this.uploadFile(file);
        });
    }
    removeFileFromArray(file) {
        const index = this.files.indexOf(file);
        if (index > -1) {
            this.files.splice(index, 1);
        }
    }
};
MaterialImgUploadComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: _service_upload_service__WEBPACK_IMPORTED_MODULE_3__["UploadService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], MaterialImgUploadComponent.prototype, "text", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], MaterialImgUploadComponent.prototype, "param", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], MaterialImgUploadComponent.prototype, "target", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], MaterialImgUploadComponent.prototype, "accept", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], MaterialImgUploadComponent.prototype, "complete", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], MaterialImgUploadComponent.prototype, "formControlName", void 0);
MaterialImgUploadComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-material-img-upload',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./material-img-upload.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/material/material-img-upload/material-img-upload.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./material-img-upload.component.css */ "./src/app/material/material-img-upload/material-img-upload.component.css")).default]
    })
], MaterialImgUploadComponent);



/***/ }),

/***/ "./src/app/material/material.module.ts":
/*!*********************************************!*\
  !*** ./src/app/material/material.module.ts ***!
  \*********************************************/
/*! exports provided: MaterialModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaterialModule", function() { return MaterialModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_cdk_table__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/table */ "./node_modules/@angular/cdk/esm2015/table.js");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _angular_fire__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/fire */ "./node_modules/@angular/fire/es2015/index.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _material_file_upload_material_file_upload_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./material-file-upload/material-file-upload.component */ "./src/app/material/material-file-upload/material-file-upload.component.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/fire/firestore */ "./node_modules/@angular/fire/firestore/es2015/index.js");
/* harmony import */ var angularfire2_storage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! angularfire2/storage */ "./node_modules/angularfire2/storage/index.js");
/* harmony import */ var angularfire2_storage__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(angularfire2_storage__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _material_img_upload_material_img_upload_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./material-img-upload/material-img-upload.component */ "./src/app/material/material-img-upload/material-img-upload.component.ts");












let MaterialModule = class MaterialModule {
};
MaterialModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_4__["BrowserAnimationsModule"],
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_9__["AngularFirestoreModule"],
            angularfire2_storage__WEBPACK_IMPORTED_MODULE_10__["AngularFireStorageModule"],
            _angular_fire__WEBPACK_IMPORTED_MODULE_5__["AngularFireModule"].initializeApp(src_environments_environment__WEBPACK_IMPORTED_MODULE_8__["firebaseConfig"]),
            _angular_cdk_table__WEBPACK_IMPORTED_MODULE_3__["CdkTableModule"],
            //MatTreeModule,
            //MatAutocompleteModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatButtonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatButtonToggleModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatCardModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatCheckboxModule"],
            // MatChipsModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatStepperModule"],
            //  MatDatepickerModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatDialogModule"],
            //  MatDividerModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatExpansionModule"],
            // MatGridListModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatIconModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatInputModule"],
            // MatListModule,
            //  MatMenuModule,
            //  MatNativeDateModule,
            // MatPaginatorModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatProgressBarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatProgressSpinnerModule"],
            //  MatRadioModule,
            //  MatRippleModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatSelectModule"],
            // MatSidenavModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatSliderModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatSlideToggleModule"],
            //  MatSnackBarModule,
            //  MatSortModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatTableModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatTabsModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatToolbarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatTooltipModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatBadgeModule"],
        ],
        exports: [
            _angular_cdk_table__WEBPACK_IMPORTED_MODULE_3__["CdkTableModule"],
            // MatTreeModule,
            // MatAutocompleteModule,
            // MatChipsModule,
            // MatDatepickerModule,
            // MatDividerModule,
            // MatGridListModule,
            // MatListModule,
            // MatMenuModule,
            //MatNativeDateModule,
            // MatPaginatorModule,
            // MatRadioModule,
            // MatRippleModule,
            // MatSidenavModule,
            //  MatSliderModule,
            // MatSnackBarModule,
            // MatSortModule,
            //DragDropModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatExpansionModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatCheckboxModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatButtonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatButtonToggleModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatCardModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatStepperModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatDialogModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatIconModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatInputModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatProgressBarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatProgressSpinnerModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatSelectModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatSlideToggleModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatTableModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatTabsModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatToolbarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatTooltipModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatBadgeModule"],
            _material_file_upload_material_file_upload_component__WEBPACK_IMPORTED_MODULE_7__["MaterialFileUploadComponent"],
            _material_img_upload_material_img_upload_component__WEBPACK_IMPORTED_MODULE_11__["MaterialImgUploadComponent"]
        ],
        declarations: [_material_file_upload_material_file_upload_component__WEBPACK_IMPORTED_MODULE_7__["MaterialFileUploadComponent"], _material_img_upload_material_img_upload_component__WEBPACK_IMPORTED_MODULE_11__["MaterialImgUploadComponent"]]
    })
], MaterialModule);



/***/ }),

/***/ "./src/app/material/service/upload.service.ts":
/*!****************************************************!*\
  !*** ./src/app/material/service/upload.service.ts ***!
  \****************************************************/
/*! exports provided: UploadService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UploadService", function() { return UploadService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var firebase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! firebase */ "./node_modules/firebase/dist/index.cjs.js");
/* harmony import */ var firebase__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(firebase__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");




let UploadService = class UploadService {
    constructor() {
        firebase__WEBPACK_IMPORTED_MODULE_2__["initializeApp"](src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["firebaseConfig"]);
    }
    tareaCloudStorage(nombreArchivo, datos) {
        let date = new Date();
        let name = date.getFullYear() + "_" + date.getMonth() + "_" + date.getDay() + "_" + date.getTime() + "/" + nombreArchivo;
        console.log(name, "nmnre");
        let ref = firebase__WEBPACK_IMPORTED_MODULE_2__["storage"]().ref("images/" + name);
        let task = ref.put(datos);
        return task;
    }
};
UploadService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], UploadService);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment, firebaseConfig, messages */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firebaseConfig", function() { return firebaseConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "messages", function() { return messages; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false,
    url: 'https://test.sismoit.com/'
    // url: 'http://localhost:5000/'
};
const firebaseConfig = {
    apiKey: "AIzaSyCdrgekhdUBSEYZs_vcuf27hrSwdt7ROMw",
    authDomain: "shop-bay.firebaseapp.com",
    databaseURL: "https://shop-bay.firebaseio.com",
    projectId: "shop-bay",
    storageBucket: "shop-bay.appspot.com",
    messagingSenderId: "615702782897",
    appId: "1:615702782897:web:18385d7bc4320e3569d390",
    measurementId: "G-CYEFKRX07N"
};
const messages = {
    errorTittle: "Error",
    saveTittle: "Guardado",
    saveSuccess: "Registro guardado con éxito.",
    deleteSuccess: "Registro eliminado con éxito.",
    updateSuccess: "Registro actualizado con éxito"
};


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! hammerjs */ "./node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");






if (_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_4__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! E:\proyectos\gecolsa\shopbay-web\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map